/**
 * Created by mukund on 7/17/15.
 */

"use strict";

angular
    .module("mediacloudApp")
    .controller(
        "QuizzingController",
        function (
            $scope,
            $sce,
            $compile,
            $state,
            $stateParams,
            $window,
            $rootScope,
            $http,
            $filter,
            Principal,
            AssetService,
            CollectionService,
            AVMedia,
            $timeout
        ) {
            Principal.identity().then(function (account) {
                $scope.account = account;
                $scope.render = false;
                $scope.renderSource = "Publish";
                $scope.content = {};
                var logger = function (msg) {
                    var active = false;

                    if (active) {
                        console.log(msg);
                    }
                };

                var assetId = $state.params.assetId;
                var collectionId = $state.params.collectionId;
                var collectionType = "course";
                $scope.isNewQuiz = $state.params.isNewQuiz === "true";
                $scope.isAssignmentFromLMS = sessionStorage.getItem('isAssignmentFromLMS') === "true";
                $scope.isFromPnP = $state.params.isFromPnP === "true";
                $scope.rootCollectionType = collectionType;
                $scope.isSaving = false;
                $scope.originalQuizNumSubmissions = null;
                $scope.isImpactingChange = false;
                $scope.isPreEdit = false;
                $scope.isFirstSeek = true;
                $scope.fromDeleteQuizAnswer = false;
                $scope.selectedQuestionNumber = -1;
                $scope.deleteText = "Unpublished";
                $scope.afterModelFocus = null;
                $scope.isInReview = false;
                $scope.isNextQuestion = false;
                $scope.isChangingAnswer = false;
                $scope.quizInProgress = false;
                $scope.showSkip = false;
                $scope.media = null;
                $scope.srcLang = "English";
                $scope.captionsIncluded = false;
                $scope.subtitlesIncluded = false;
                $scope.audioDescriptionsIncluded = false;
                $scope.updateTimeout = null;
                $scope.currentFormType = null;
                $scope.metadataloaded = false;
                $scope.currentWidth = 0;
                $scope.currentTextTrackFontSize = 0;
                $scope.playerEl;
                
                var originalMultipleChoiceFormHtml;
                var originalMultiselectFormHtml;
                var quizName;
                var quizDescription;

                var player;
                var testVideo = false;
                var testHlsUrl = "";
                $http({method: 'GET', url: 'api/properties?name=TEST_VIDEO_HLS_URL'})
                    .then(function (response) {
                        if (response.data.value != null && response.data.value.length > 0) {
                            testVideo = true;
                            testHlsUrl = response.data.value;
                            console.log("-------------Using Test Video-------------\ntestHlsUrl: " + testHlsUrl);
                        }
                    });
                //            if($window.location.hash.indexOf("#/lms/playback/") === 0) {
                //                //lms
                //                $scope.rootCollectionType = $rootScope.rootCollectionType;
                //            } else {
                //                //standalone
                //                if($window.location.hash.indexOf('course') > -1) {
                //                    $scope.rootCollectionType = 'course';
                //                }
                //
                //                if($window.location.hash.indexOf('protected') > -1) {
                //                    $scope.rootCollectionType = 'collection';
                //                }
                //
                //                if($window.location.hash.indexOf('collection') > -1) {
                //                    $scope.rootCollectionType = 'collection';
                //                }
                //
                //                if($window.location.hash.indexOf('channel') > -1) {
                //                    $scope.rootCollectionType = 'channel';
                //                }
                //            }

                $scope.hasWritePermissions = false;
                $scope.isInstructor = false;
                $scope.isPreview = false;
                $scope.enterPreviewTime = 0;
                $scope.enterPreviewSelectedQuestionNumber = -1;
                $scope.menuDescriptionText = "";
                $scope.questionsTabSelected = true;
                $scope.breadcrumbLoaded = false;
                $scope.studentQuizButton = "";
                $scope.answeredQuestions = [];
                $scope.seekedLoadMarkers = false;
                $scope.takeQuizSelectedQuestion = -1;
                $scope.finalStop = null;
                $scope.nextStop = null;
                $scope.lastMarker = null;

                $scope.shouldStartQuiz = false;
                $scope.assetFetched = false;
                $scope.quizFetched = false;
                $scope.collectionContentFetched = false;
                $scope.playerLoaded = false;
                $scope.quizAttemptLoaded = false;
                $scope.submissionsLeft = 0;
                $scope.tabs =[];
                $scope.firstTab = null;
                $scope.lastTab = null;

                $scope.$watch("[breadcrumbLoaded, isPreview, isAssignmentFromLMS, hasWritePermissions]",
                    function () {
                        if ($scope.breadcrumbLoaded) {
                            if ($scope.isAssignmentFromLMS && (!$scope.hasWritePermissions || $scope.isPreview)) {
                                $('.breadcrumb').css('visibility', 'hidden');
                            }else if ($scope.isAssignmentFromLMS && $scope.hasWritePermissions) {
                                $(".breadcrumb").each(function () {
                                    var el = $(this);
                                    el.addClass("non-interactive");
                                    $timeout(function(){
                                        // Disable keyboard focusability for all children
                                        el.find("a, button, input, [tabindex]").each(function () {
                                            $(this).attr("tabindex", "-1");
                                            $(this).attr("disabled", true); // Only affects elements that support it
                                        });
                                        // Prevent Enter/Space key activation
                                        el.on("keydown", function (e) {
                                            if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }
                                        });
                                    },0);
                                });
                                $('.breadcrumb').css('visibility', 'visible');
                            }
                        }
                    },
                    true
                );

                $scope.$watch(
                    "[assetFetched, quizFetched, playerLoaded, quizAttemptLoaded]",
                    function () {
                        if ($scope.assetFetched && $scope.quizFetched && !$scope.collectionContentFetched) {
                            $scope.getCollectionContent();
                        }
                        if (
                            $scope.assetFetched &&
                            $scope.quizFetched &&
                            $scope.playerLoaded &&
                            $scope.quizAttemptLoaded
                        ) {
                            if (!$scope.hasWritePermissions && !$scope.quiz.isAvailable && !$scope.isPreview) {
                                // if student and quiz is not available and not preview mode,
                                // show modal blocking interaction with quiz
                                $("#quizUnavailableModal").modal({
                                    backdrop: "static",
                                    keyboard: false,
                                });
                                return;
                            }

                            if ($scope.asset.isActive) {
                                $(".add-question-button").hide();
                            } else if ($scope.hasWritePermissions && !$scope.asset.isActive) {
                                $(".add-question-button").show();
                            }

                            console.log('canTakeQuiz: ', $scope.quiz.canTakeQuiz)
                            console.log('quizAttemptId: ', $scope.quizAttemptId)
                            console.log('answeredQuestions.length: ', $scope.answeredQuestions.length)
                            console.log('quiz.questions.length: ', $scope.quiz.questions.length)
                            console.log('studentQuizButton: ', $scope.studentQuizButton)

                            if (
                                $scope.quiz.canTakeQuiz &&
                                $scope.quizAttemptId &&
                                $scope.answeredQuestions.length ==
                                    $scope.quiz.questions.length
                            ) {
                                // TODO: Submit quiz flow
                                $scope.studentQuizButton = "resume";
                                $scope.submissionsLeft--;
                            } else if (
                                $scope.quiz.canTakeQuiz &&
                                $scope.quizAttemptId &&
                                $scope.answeredQuestions.length > 0
                            ) {
                                // TODO: resume quiz flow
                                $scope.studentQuizButton = "resume";
                                $scope.submissionsLeft--;
                            } else if (
                                !$scope.hasWritePermissions &&
                                !$scope.quiz.canTakeQuiz
                            ) {
                                // TODO: no more attempts left, what to do?
                                $scope.studentQuizButton = "";
                                console.log("No more quiz attempts left!");
                            } else {
                                if (!$scope.hasWritePermissions) {
                                    $(
                                        ".quiz-metadata .empty-state-container-student"
                                    ).show();
                                }
                            }

                            $timeout(() => {
                                // quiz settings
                                // editable tracks if students have attempted, true when attempts = 0
                                // asset.isActive == 0 is when quiz is unpublished
                                console.log("quiz.editable: "+$scope.quiz.editable);
                                console.log("asset.isActive: "+$scope.asset.isActive);
                                console.log("quiz.isLocked: "+$scope.quiz.isLocked);
                                var settingsEnabled = $scope.quiz.editable && $scope.asset.isActive == 0 && !$scope.quiz.isLocked;
                                if(!settingsEnabled){
                                    $("#allowSkipping").attr("aria-readonly",true);
                                    $("#allowChanges").attr("aria-readonly",true);
                                    $("#shuffleAnswers").attr("aria-readonly",true);
                                    $("#quizSubmissions").attr("aria-readonly",true);
                                    $("#showFeedback").attr("aria-readonly",true);
                                    $("#showResults").attr("aria-readonly",true);
                                }
                            }, 250);
                        }
                    },
                    true
                );

                $scope.$on('reloadQuiz', function(event, data) {
                    if (data.reload) {
                        $scope.loadPageInfo();
                    }
                });

                $scope.$watch(
                    "[editQuestion]",
                    function () {
                        if ($scope.editQuestion) {
                            $(".save-question span").text("Save Edits");
                        } else {
                            $(".save-question span").text("Save Question");
                        }
                    },
                    true
                );

                $scope.getQuizMetadata = function () {
                    $scope.quizFetched = false;
                    var quizRequest = AssetService.GetQuizMetadata.get({
                        cid: collectionId,
                        aid: assetId
                    });

                    return quizRequest.$promise.then(function (quiz) {
                        $scope.quiz = quiz;

                        if ($scope.isPreview) {
                            $scope.quiz.canTakeQuiz = true;

                            $timeout(function() {
                                player.pause();
                                player.currentTime(0);
                                $(".add-question-button").hide();
                                $(".vjs-rewatch").show();
                                $(".take-quiz-metadata-container").show();
                            }, 400);
                        }else if($scope.hasWritePermissions){
                            $(".vjs-rewatch").hide();
                        }

                        $scope.originalQuizNumSubmissions =
                            quiz.settings.quizSubmissions;
                        $scope.submissionsLeft = quiz.settings.quizSubmissions - quiz.studentQuizAttempts;

                        if ($scope.shouldStartQuiz) {
                            $scope.shouldStartQuiz = false;
                            $scope.submissionsLeft = $scope.submissionsLeft - 1;
                            $scope.enableButton(null, null, {
                                Video: true,
                                PlayToggle: true,
                                SkipBackward: true,
                                SkipForward: true,
                                SubsCapsButton: true,
                                AudioButton: true,
                                PlaybackRateMenuButton: true,
                                VolumePanel: true,
                            });
                            $(".vjs-rewatch .rewatch-button").removeAttr("disabled");
                            $(".button-row").hide();
                            $timeout(function() {
                                player.play();
                            }, 600);
                        }

                        $timeout(() => {
                            $("#quizSubmissions")
                                .val($scope.originalQuizNumSubmissions)
                                .prop("selected", true);

                            $("#showResults").attr("aria-readonly", $scope.originalQuizNumSubmissions > 1);

                            $("#showFeedback").attr("aria-readonly", $scope.originalQuizNumSubmissions > 1 ||
                                    $scope.quiz.settings.allowChanges ||
                                    $scope.quiz.settings.allowSkipping);
                            $("#allowSkipping").attr("aria-readonly", quiz.settings.showFeedbackAnswerSubmission);
                            $("#allowChanges").attr("aria-readonly", quiz.settings.showFeedbackAnswerSubmission);
                            $("#quizSubmissions").attr("aria-readonly", quiz.settings.showFeedbackAnswerSubmission || quiz.settings.showResultsQuizSubmission);
                            if ($scope.afterModelFocus) {
                                $("#" + $scope.afterModelFocus).focus();
                            }
                            $scope.afterModelFocus = null;
                        }, 250);
                        $.each($scope.quiz.questions, function (k, v) {
                            v.displayTime = moment
                                .utc(v.time * 1000)
                                .format("HH:mm:ss");
                        });

                        if ($scope.quiz.id) {
                            if($scope.quizInProgress === true){
                                $scope.studentQuizButton = "";
                            }else{
                                $scope.studentQuizButton = "start";
                            }
                            $scope.answeredQuestions =
                                $scope.quiz.questions.filter(
                                    (x) => x.answered
                                );
                            $scope.allUserQuestions =
                                $scope.quiz.questions.filter(
                                    (x) => x.answered || x.skipped
                                );

                            if ($scope.quiz.questionIdMap) {
                                let questionIdMap = Object.fromEntries(
                                    $scope.quiz.questions.map((e) => [
                                        e.id,
                                        e,
                                    ])
                                );

                                $scope.quiz.questionIdMap = questionIdMap;
                            }
                            console.log("HERE quiz: ", $scope.quiz);
                            if (player) {
                                $scope.loadMarkers(false);
                            }

                            if ($scope.recentlyAddedQuestion) {
                                setTimeout(function () {
                                    $(
                                        "#question-" +
                                            $scope.recentlyAddedQuestion
                                    ).css("background", "#EEFFF7");
                                    setTimeout(function () {
                                        $(
                                            "#question-" +
                                                $scope.recentlyAddedQuestion
                                        ).css("background", "#fff");
                                        $scope.recentlyAddedQuestion = null;
                                    }, 10000);
                                }, 250);
                            }

                            if (!$scope.hasWritePermissions) {
                                AssetService.GetInProgressQuizAttempt.get(
                                    {
                                        quizId: $scope.quiz.id,
                                        isPreview: $scope.isPreview && $scope.isInstructor,
                                    },
                                    function (quizAttempt) {
                                        $scope.quizAttemptId =
                                            quizAttempt.quizAttemptId;
                                        console.log("HEREquizAttempt");
                                        console.log($scope.quizAttemptId);
                                        $scope.quizAttemptLoaded = true;
                                    }
                                );
                            }else{
                                $scope.quizAttemptLoaded = true;
                            }

                            // if the selected question still exists (not deleted), return to it
                            var selectedQuestion =
                                $scope.quiz.questions.filter(
                                    (x) => x.id == $scope.selectedQuestionId
                                )[0];

                            if (
                                selectedQuestion &&
                                !$scope.fromDeleteQuizAnswer
                            ) {
                                // return to preedit
                                $scope.handlePreEditQuestionClick(
                                    selectedQuestion.questionNumber
                                );
                            }

                            $scope.fromDeleteQuizAnswer = false;
                            $scope.quizFetched = true;
                        } else {
                            $scope.quiz.id = 0;
                        }

                        return quiz;
                    });
                };

                $scope.safeApply =
                    $scope.safeApply ||
                    function (fn) {
                        var phase = this.$root.$$phase;
                        if (phase == "$apply" || phase == "$digest") {
                            if (fn && typeof fn === "function") {
                                fn();
                            }
                        } else {
                            this.$apply(fn);
                        }
                    };

                $scope.handleReturnToPnP = function () {
                    $("#quizUnavailableModal").modal("hide");
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    $state.go("course", {
                        collectionId:
                            ($scope.collectionTree &&
                                $scope.collectionTree.cid) ||
                            $scope.currentCollection.cid,
                        type: "",
                    });
                    return;
                }

                $scope.openModal = function (type) {
                    logger("openModal");
                    $scope.content = {
                        type: type,
                        item: $scope.contentItem,
                    };
                    $("#itemManagementWindow")
                        .modal("show")
                        .on("shown.bs.modal", function () {
                            modalFocus(
                                "#publishHeading",
                                "#returnTopublishHeading"
                            );
                            $("#returnTopublishHeading").on(
                                "focus",
                                function () {
                                    $("#publishHeading").focus();
                                }
                            );
                        });
                };

                var modalFocus = function (first, last) {
                    logger("modalFocus");
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on("keydown", function (e) {
                        if (e.which === 9 && !e.shiftKey) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on("keydown", function (e) {
                        if (e.which === 9 && e.shiftKey) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };

                function pad(d) {
                    return d < 10 ? "0" + d.toString() : d.toString();
                }

                var removeHTMLTags = function (value) {
                    var processedText = value.replaceAll("<", "&lt;");
                    processedText = processedText.replaceAll(">", "&gt;");
                    return processedText;
                };

                $scope.loadPageInfo = function () {
                    logger("loadPageInfo");
                    $scope.assetFetched = false;
                    AssetService.GetAsset.get(
                        {
                            cid: collectionId,
                            aid: assetId,
                        },
                        function (asset) {
                            $scope.asset = asset;
                            $scope.menuDescriptionText = $scope.asset.description && $scope.asset.description.trim().length ? 'Edit Description' : 'Add Description';
                            var split = asset.language.split('- ');
                            if (split.length > 1) {
                                srcLang = split[1];
                            }
                            quizName = asset.title;
                            quizDescription = asset.description;
                            if (asset.isActive) {
                                $scope.deleteText = "";
                            }
                            $scope.rootCollectionId = $scope.asset.rootLevelCid;
                            $scope.getCollectionTree();
                            $rootScope.rootLevelCid = $scope.asset.rootLevelCid;
                            $rootScope.rootCollectionId =
                                $scope.asset.rootLevelCid;
                            $scope.hideCurrentFolderOnBreadcrumb =
                                !$scope.rootCollectionId;
                            $scope.hasWritePermissions =
                                $scope.asset.acl.indexOf("W") > -1 && !$scope.isPreview;

                            $scope.isInstructor = $scope.asset.acl.indexOf("W") > -1;
                            if (!$scope.hasWritePermissions) {
                                $(".take-quiz-metadata-container").show();
                            }
                            console.log("HERE asset: ", $scope.asset);
                            $scope.getCollections();

                            $scope.assetFetched = true;

                            AssetService.GetQuizInfo.get(
                                {
                                    cid: $scope.asset.cid,
                                    aid: $scope.asset.aid,
                                },
                                function (quiz) {
                                    $scope.mmQuiz = quiz;
                                    $scope.getAVMedia(quiz.originAid);
                                }
                            );
                        }
                    );
                    $scope.getQuizMetadata();
                };

                $scope.hlsUrl = "";
                $scope.captionUrl = "";

                $scope.getAVMedia = function (aid) {
                    var AUTHTOKEN = $scope.$root.AUTHTOKEN;
                    AVMedia.get(
                        {
                            cid: $scope.asset.cid,
                            aid: aid,
                        },
                        function (media) {
                            if (!player) {
                                $scope.media = media;
                                if (!testVideo) {
                                    $scope.hlsUrl =
                                        media.mediaUrl +
                                        "/playlist.m3u8?authToken=" +
                                        (AUTHTOKEN
                                            ? AUTHTOKEN
                                            : JSON.parse(
                                                  localStorage.getItem(
                                                      "ls.authToken"
                                                  )
                                              ));

                                    $scope.captionUrl = media.captionUrl;
                                } else {
                                    $scope.hlsUrl = testHlsUrl;
                                }
                                $scope.initializeVideo(
                                    "quizzing-video",
                                    800,
                                    400,
                                    media
                                );
                                originalMultipleChoiceFormHtml = $(
                                    ".question-form.multiple-choice-metadata-container"
                                ).clone();
                                originalMultiselectFormHtml = $(
                                    ".question-form.multi-select-metadata-container"
                                ).clone();
                            }

                            if (player) {
                                if ($scope.isPreview) {
                                    $scope.enableButton("All", false, null);
                                    $scope.enableButton(null, null, {
                                        CurrentTimeDisplay: true,
                                        TimeDivider: true,
                                        DurationDisplay: true,
                                    });
                                    $timeout(() => {
                                        $scope.enableButton("PlayToggle", false, null);
                                    }, 350);
                                }
                            }
                        }
                    );
                };

                var manageBreadcrumbTruncation = function () {
                    var assetTitleIntervalId = setInterval(function () {
                        if ($(".breadcrumb .asset-name .name").length) {
                            clearInterval(assetTitleIntervalId);

                            var breadcrumbInterval = setInterval(function () {
                                if (
                                    $(
                                        ".breadcrumb .sub-folder .name"
                                    ).height() > 0 ||
                                    $(
                                        ".breadcrumb .current-folder .name"
                                    ).height() > 0 ||
                                    $(
                                        ".breadcrumb .asset-name .name"
                                    ).height() > 0
                                ) {
                                    clearInterval(breadcrumbInterval);

                                    //If the breadcrumb is bigger than the max width
                                    var isBreadcrumbBigger =
                                        $(
                                            ".breadcrumb .sub-folder .name"
                                        ).height() > 28 ||
                                        $(
                                            ".breadcrumb .current-folder .name"
                                        ).height() > 28 ||
                                        $(
                                            ".breadcrumb .asset-name .name"
                                        ).height() > 28;

                                    if (isBreadcrumbBigger) {
                                        //If each subfolder is bigger than the limit
                                        if (
                                            hasEllipsisWidth(
                                                $(".breadcrumb .sub-folder")[0]
                                            ) ||
                                            hasEllipsisWidth(
                                                $(
                                                    ".breadcrumb .current-folder"
                                                )[0]
                                            ) ||
                                            hasEllipsisHeight(
                                                $(".breadcrumb .asset-name")[0]
                                            )
                                        ) {
                                            //Add ellipsis to subfolders that are wider than the limit
                                            $(
                                                ".breadcrumb .sub-folder .name"
                                            ).addClass("truncate-ellipsis");
                                            $(
                                                ".breadcrumb .sub-folder .name"
                                            ).addClass("limit-folder-size");
                                            $(
                                                ".breadcrumb .current-folder .name"
                                            ).addClass("truncate-ellipsis");
                                            $(
                                                ".breadcrumb .current-folder .name"
                                            ).addClass("limit-folder-size");

                                            //TODO: get player width - .root-container width
                                            var nameWidthIntervalId =
                                                setInterval(function () {
                                                    if (
                                                        $(
                                                            ".breadcrumb .root-collection .name"
                                                        ).width()
                                                    ) {
                                                        clearInterval(
                                                            nameWidthIntervalId
                                                        );

                                                        var subFoldersWidth = 0;
                                                        $(
                                                            ".breadcrumb .sub-folder"
                                                        ).each(function (
                                                            index,
                                                            item
                                                        ) {
                                                            subFoldersWidth +=
                                                                $(
                                                                    item
                                                                ).width() + 16;
                                                        });

                                                        // var assetNameWidth = $('#player').width() - titleWidth - subFoldersWidth - 40;
                                                        var assetNameWidth = 187;

                                                        $(
                                                            ".breadcrumb .asset-name .name"
                                                        ).addClass(
                                                            "truncate-ellipsis"
                                                        );
                                                        $(
                                                            ".breadcrumb .asset-name .name"
                                                        ).css(
                                                            "max-width",
                                                            assetNameWidth.toString() +
                                                                "px"
                                                        );
                                                    }
                                                }, 10);
                                        }

                                        $scope.showSubFolderTooltip = [];

                                        if (
                                            $(".breadcrumb .sub-folder")
                                                .length > 0
                                        ) {
                                            $scope.showSubFolderTooltip[0] =
                                                hasEllipsisWidth(
                                                    $(
                                                        ".breadcrumb .sub-folder .name"
                                                    )[0]
                                                );
                                        }

                                        if (
                                            $(".breadcrumb .sub-folder")
                                                .length > 1
                                        ) {
                                            $scope.showSubFolderTooltip[1] =
                                                hasEllipsisWidth(
                                                    $(
                                                        ".breadcrumb .sub-folder .name"
                                                    )[1]
                                                );
                                        }

                                        if (
                                            $(".breadcrumb .sub-folder")
                                                .length > 2
                                        ) {
                                            $scope.showSubFolderTooltip[2] =
                                                hasEllipsisWidth(
                                                    $(
                                                        ".breadcrumb .sub-folder .name"
                                                    )[2]
                                                );
                                        }
                                    }

                                    if (
                                        hasEllipsisWidth(
                                            $(
                                                ".breadcrumb .current-folder .name"
                                            )[0]
                                        )
                                    ) {
                                        $scope.showCurrentFolderTooltip = true;
                                    }

                                    setTimeout(function () {
                                        if (
                                            hasEllipsisWidth(
                                                $(
                                                    ".breadcrumb .asset-name .name"
                                                )[0]
                                            )
                                        ) {
                                            $scope.showAssetTooltip = true;
                                        }
                                    }, 1000);

                                    $(".breadcrumb").css("opacity", 1);
                                }
                            }, 50);
                        }
                    }, 10);
                };

                $scope.getCollections = function () {
                    logger("getCollections");

                    CollectionService.GetCollection.get(
                        {
                            cid: collectionId,
                            type: collectionType.toUpperCase(),
                        },
                        function (parentCollection) {
                            $scope.parent = parentCollection;
                            $scope.parentCollection = parentCollection;
                            $scope.currentCollection = parentCollection;
                            $scope.isMediaInboxCollection =
                                $scope.currentCollection.type === "dropbox" ||
                                $scope.currentCollection.type ===
                                    "assignment" ||
                                $scope.currentCollection.type === "zoom";

                            var collectionTreeIntervalId = setInterval(
                                function () {
                                    if ($scope.collectionTree) {
                                        clearInterval(collectionTreeIntervalId);
                                        $scope.currentCollection.crumbs =
                                            generateCrumbs(
                                                parentCollection.cid,
                                                parentCollection.path
                                            );
                                        $scope.showBreadcrumbEllipsis =
                                            $scope.currentCollection.crumbs
                                                .length > 1;

                                        //show only last 2 subfolders
                                        $scope.breadcrumbFolders =
                                            $scope.currentCollection.crumbs.slice(
                                                $scope.currentCollection.crumbs
                                                    .length - 1,
                                                $scope.currentCollection.crumbs
                                                    .length
                                            );
                                        $scope.breadcrumbLoaded = true;
                                        $scope.crumbsForMenu = JSON.parse(
                                            JSON.stringify(
                                                $scope.currentCollection.crumbs.slice(
                                                    0,
                                                    $scope.currentCollection
                                                        .crumbs.length - 1
                                                )
                                            )
                                        );

                                        setTimeout(function () {
                                            manageBreadcrumbTruncation();
                                        }, 500);
                                    }
                                },
                                50
                            );

                            $scope.currentCollection.pathLength =
                                parentCollection.path.split("/").length;
                            var arrPath = parentCollection.path.split("/");
                            if (arrPath.length > 2) {
                                if ($scope.rootCollectionId) {
                                    CollectionService.GetCollection.get(
                                        {
                                            cid: $scope.rootCollectionId,
                                            type: collectionType.toUpperCase(),
                                        },
                                        function (collection) {
                                            $scope.collection = collection;
                                            $rootScope.rootLevelCollectionTitle =
                                                collection.title;

                                        }
                                    );
                                }
                            } else {
                                if (!$scope.rootCollectionId) {
                                    $scope.rootCollectionId = $scope.asset.cid;
                                    collectionId = $scope.rootCollectionId;
                                }

                                CollectionService.GetCollection.get(
                                    {
                                        cid: $scope.rootCollectionId,
                                        type: collectionType.toUpperCase(),
                                    },
                                    function (collection) {
                                        $scope.collection = collection;
                                        $rootScope.rootLevelCollectionTitle =
                                            collection.title;
                                    }
                                );
                            }
                        }
                    );
                };

                $scope.loadPageInfo();

                $scope.getCollectionTree = function () {
                    logger("getCollectionTree");

                    var intervalId = setInterval(() => {
                        if ($scope.rootCollectionId) {
                            clearInterval(intervalId);
                            //rootCollectionId 2
                            CollectionService.GetCollectionTree.get(
                                {
                                    cid: $scope.rootCollectionId,
                                },
                                function (tree) {
                                    $scope.collectionTree = tree;
                                    $scope.collectionTree.show = false;
                                    // $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});

                                    //here
                                }
                            );
                        }
                    }, 100);
                };

                $scope.handleQuizDescriptionKeyDown = function (e) {
                    if (e.key === "Tab" && !e.shiftKey) {
                        $(".video-toolbar div:nth-child(1)").focus();
                    }
                };

                $scope.handleDescriptionKeyPress = function(e) {
                    logger('handleDescriptionKeyPress');

                    var maxLength = 4000;
                    var description = $(e.target).text();

                    if(description.length >= maxLength) {
                        e.preventDefault();
                    }

                    if(e.key === 'Enter') {
                        e.preventDefault();
                        e.target.blur();
                    }
                }


                $scope.handleAddQuestionButtonClick = function (e) {
                    //show/hide menu
                    player.pause();
                    $("#quizzingAddQuestionMenu").css("display","");
                    var addQuestionButton = $("#quizzingAddQuestionButton");
                    if(addQuestionButton.hasClass("open")){
                        addQuestionButton.removeClass("open").attr("aria-expanded","false").focus();
                    }else{
                        addQuestionButton.addClass("open").attr("aria-expanded","true");
                        $("#quizzingAddQuestionMenu").find('[tabindex="0"]').first().focus();
                    }
                };
                $scope.handleAddQuestionMenuKeydown = function(e){
                    if(e.which===32 || e.which===13){
                        e.preventDefault();
                        var targetButton = $(e.target);
                        if(!targetButton.has('[tabindex="0"]')){
                            targetButton = $(e.target).parents('[tabindex="0"]');
                        }
                        targetButton.click();
                    } else if (e.which === 9 && !e.shiftKey) {
                        var lastItem = $("#quizzingAddQuestionMenu").find('[tabindex="0"]').last();
                        if($(e.target).is(lastItem)){
                            e.preventDefault();
                            $("#quizzingAddQuestionButton").focus();
                        }
                    } else if(e.which===27){
                        var addQuestionButton = $("#quizzingAddQuestionButton");
                        if(addQuestionButton.hasClass("open")){
                            addQuestionButton.focus();
                        }
                        addQuestionButton.removeClass("open").attr("aria-expanded","false");
                    }
                };

                $scope.handleQuizNameKeyDown = function (e) {
                    setTimeout(function () {
                        //enable add question btn
                        //set quiz title color
                        if ($(e.target).val().trim() !== "") {
                            $(".quiz-metadata .title-container .title").text(
                                $(e.target).val()
                            );
                            $(".quiz-metadata .title-container .title").css(
                                "color",
                                "#253042"
                            );

                            //enable main buttons
                            $(
                                ".header .buttons-container button:nth-child(2)"
                            ).attr("disabled", false);
                            $(
                                ".header .buttons-container button:nth-child(3)"
                            ).attr("disabled", false);
                            $(
                                ".header .buttons-container button:nth-child(4)"
                            ).attr("disabled", false);
                        } else {
                            $(".quiz-metadata .title-container .title").text(
                                "Untitled Quiz"
                            );
                            $(".quiz-metadata .title-container .title").css(
                                "color",
                                "#67707E"
                            );

                            //disable main buttons
                            $(
                                ".header .buttons-container button:nth-child(2)"
                            ).attr("disabled", true);
                            $(
                                ".header .buttons-container button:nth-child(3)"
                            ).attr("disabled", true);
                            $(
                                ".header .buttons-container button:nth-child(4)"
                            ).attr("disabled", true);
                        }

                        //show error with red icon if title is only space(s)
                        if (
                            $(e.target).val().trim() === "" &&
                            $(e.target).val().length > 0
                        ) {
                            showQuizTitleErrorMessage();
                        } else {
                            hideQuizTitleErrorMessage();
                        }

                        if (e.key === "Tab") {
                            validateQuizTitle();
                        }
                    }, 0);
                };

                var showQuizTitleErrorMessage = function (params) {
                    $(".quiz-metadata-container .error-message").css(
                        "display",
                        "flex"
                    );
                    $(".quiz-metadata-container .quiz-field-container").css(
                        "margin-bottom",
                        "4px"
                    );

                    if (params) {
                        if (params.changeBorderColor) {
                            $(
                                ".quiz-metadata-container .quiz-field-container:has(.quiz-title-input)"
                            ).addClass("error-message");
                            $(
                                ".quiz-metadata-container .quiz-field-container:has(.quiz-title-input)"
                            ).addClass("force-display-flex");
                        }
                    }
                };

                var hideQuizTitleErrorMessage = function () {
                    $(".quiz-metadata-container .quiz-field-container").css(
                        "margin-bottom",
                        "16px"
                    );
                    $(".quiz-metadata-container .error-message").css(
                        "display",
                        "none"
                    );
                    $(
                        ".quiz-metadata-container .quiz-field-container:has(.quiz-title-input)"
                    ).removeClass("error-message");
                };

                $scope.updateQuizMetadata = function (e) {
                    if ($scope.quiz.id) {
                        $scope.isSaving = true;
                        var updateQuiz = {
                            id: $scope.quiz.id,
                            assetId: $scope.quiz.assetId,
                            collectionId: $scope.quiz.collectionId,
                            title: $(
                                ".quiz-metadata-container .quiz-field-container input"
                            ).val(),
                            description: $(
                                ".quiz-metadata-container .quiz-field-container textarea"
                            ).val(),
                            token: $rootScope.launchToken,
                            state: $rootScope.launchState,
                        };
                        AssetService.UpdateQuiz.send(
                            updateQuiz,
                            function (response) {
                                $scope.loadPageInfo();
                                $timeout(() => {
                                    $scope.isSaving = false;
                                }, 550);
                            }
                        );
                    }
                };

                $scope.handleQuizDescriptionTextareaFocus = function (e) {
                    quizDescription = e.target.value;
                };

                $scope.handleQuizDescriptionTextareaBlur = function (e) {
                    if (e.target.value !== quizDescription) {
                        $scope.updateQuizMetadata();
                    }
                };

                $scope.handleQuizNameFocus = function (e) {
                    quizName = e.target.value;
                    $scope.focusInQuizTitle = true;
                };

                $scope.handleQuizNameBlur = function (e) {
                    setTimeout(function () {
                        var focusedElement = document.activeElement;

                        if (
                            !focusedElement.classList.contains(
                                "quiz-title-input"
                            )
                        ) {
                            $scope.focusInQuizTitle = false;
                        }
                    }, 500);

                    if (e.target.value !== quizName) {
                        $scope.updateQuizMetadata();
                    }
                };

                $scope.addTempMarker = function () {
                    var question = {
                        time: playerCurrentTime().toString(),
                        isDraft: true,
                    };

                    $(".time").val(
                        moment
                            .utc(playerCurrentTime() * 1000)
                            .format("HH:mm:ss")
                    );

                    if (!$scope.quiz.questions) $scope.quiz.questions = [];

                    $scope.quiz.questions.push(question);
                    $scope.enableButton("AddQuestion",false,null);
                };

                $scope.showEmptyStateQuestions = function () {
                    if (!$scope.hasWritePermissions) {
                        return false;
                    }
                    if (!$scope.quizFetched) {
                        return false;
                    }

                    if ($scope.quiz.questions) {
                        if ($scope.quiz.questions.length > 0) {
                            var nonDraftQuestions =
                                $scope.quiz.questions.filter((x) => !x.isDraft);

                            if (nonDraftQuestions.length > 0) {
                                return false;
                            }
                        }

                        return true;
                    }

                    if (!$scope.quiz.questions) {
                        return true;
                    }

                    return true;
                };

                $scope.questionFilter = function (item) {
                    return !item.isDraft;
                };

                $scope.handleAddMultipleChoiceClick = function (isNew) {
                    // reset form
                    if (isNew) {
                        $(
                            ".question-form.multiple-choice-metadata-container .defaultSecondaryButton"
                        ).click();
                        $scope.selectedQuestionId = -1;
                        $scope.selectedQuestionNumber = -1;
                    }
                    $(".quiz-metadata-container").hide();
                    $(".pre-edit-question").hide();
                    $(".true-false-metadata-container").hide();
                    $(".multi-select-metadata-container").hide();
                    $(".numeric-metadata-container").hide();
                    $(".multiple-choice-metadata-container").show();
                    $("#quizzingAddQuestionButton").removeClass("open").attr("aria-expanded","false");
                    //set menu icon aria-expanded to false
                    $(".menu-icon").attr("aria-expanded","false");
                    $scope.currentQuestionAnswerFeedbackList = [];
                    $scope.currentQuestionFeedbackList = [];
                    $(".multiple-choice-metadata-container .time").val(
                        $(".vjs-current-time-display").text()
                    );

                    if (isNew) {
                        $scope.addTempMarker();
                    }
                    $scope.loadMarkersSeeked(isNew);

                    if (isNew) {
                        setTimeout(function () {
                            $(
                                ".multiple-choice-metadata-container .question-title"
                            ).focus();
                        }, 100);
                    }
                };

                $scope.handleAddTrueFalseClick = function (isNew) {
                    // reset form
                    if (isNew) {
                        $(
                            ".question-form.true-false-metadata-container .defaultSecondaryButton"
                        ).click();
                        $scope.selectedQuestionId = -1;
                        $scope.selectedQuestionNumber = -1;
                    }
                    $(".quiz-metadata-container").hide();
                    $(".pre-edit-question").hide();
                    $(".multiple-choice-metadata-container").hide();
                    $(".multi-select-metadata-container").hide();
                    $(".numeric-metadata-container").hide();
                    $(".true-false-metadata-container").show();
                    $("#quizzingAddQuestionButton").removeClass("open").attr("aria-expanded","false");
                    //set menu icon aria-expanded to false
                    $(".menu-icon").attr("aria-expanded","false");
                    $(".true-false-metadata-container .time").val(
                        $(".vjs-current-time-display").text()
                    );
                    $scope.currentQuestionAnswerFeedbackList = [];
                    $scope.currentQuestionFeedbackList = [];

                    if (isNew) {
                        $scope.addTempMarker();
                    }
                    $scope.loadMarkersSeeked(isNew);

                    if (isNew) {
                        setTimeout(function () {
                            $(
                                ".true-false-metadata-container .question-title"
                            ).focus();
                        }, 100);
                    }
                };

                $scope.handleAddMultiSelectClick = function (isNew) {
                    // reset form
                    if (isNew) {
                        $(
                            ".question-form.multi-select-metadata-container .defaultSecondaryButton"
                        ).click();
                        $scope.selectedQuestionId = -1;
                        $scope.selectedQuestionNumber = -1;
                    }
                    $(".quiz-metadata-container").hide();
                    $(".pre-edit-question").hide();
                    $(".multiple-choice-metadata-container").hide();
                    $(".numeric-metadata-container").hide();
                    $(".true-false-metadata-container").hide();
                    $(".multi-select-metadata-container").show();
                    $("#quizzingAddQuestionButton").removeClass("open").attr("aria-expanded","false");
                    //set menu icon aria-expanded to false
                    $(".menu-icon").attr("aria-expanded","false");
                    $(".multi-select-metadata-container .time").val(
                        $(".vjs-current-time-display").text()
                    );
                    $scope.currentQuestionAnswerFeedbackList = [];
                    $scope.currentQuestionFeedbackList = [];

                    if (isNew) {
                        $scope.addTempMarker();
                    }
                    $scope.loadMarkersSeeked(isNew);

                    if (isNew) {
                        setTimeout(function () {
                            $(
                                ".multi-select-metadata-container .question-title"
                            ).focus();
                        }, 100);
                    }
                };

                $scope.handleAddNumericClick = function (isNew) {
                    if (isNew) {
                        $scope.selectedQuestionId = -1;
                        $scope.selectedQuestionNumber = -1;
                    }
                    $(".quiz-metadata-container").hide();
                    $(".pre-edit-question").hide();
                    $(".multiple-choice-metadata-container").hide();
                    $(".multi-select-metadata-container").hide();
                    $(".true-false-metadata-container").hide();
                    $(".numeric-metadata-container").show();
                    $("#quizzingAddQuestionButton").removeClass("open").attr("aria-expanded","false");
                    //set menu icon aria-expanded to false
                    $(".menu-icon").attr("aria-expanded","false");
                    $(".numeric-metadata-container .time").val(
                        $(".vjs-current-time-display").text()
                    );
                    $scope.currentQuestionAnswerFeedbackList = [];
                    $scope.currentQuestionFeedbackList = [];

                    if (isNew) {
                        $scope.addTempMarker();
                    }
                    $scope.loadMarkersSeeked(isNew);

                    if (isNew) {
                        setTimeout(function () {
                            $(
                                ".numeric-metadata-container .question-title"
                            ).focus();
                        }, 100);
                    }
                };

                $scope.handleMultipleChoiceAddNewOptionClick = function (id) {
                    //get max value
                    var maxValue = 0;
                    $(
                        ".multiple-choice-metadata-container .answer-option"
                    ).each(function (index, item) {
                        maxValue = Math.max(
                            maxValue,
                            parseInt($(item).find(".answerOptionRadio").val())
                        );
                    });

                    var newValue = maxValue + 1;
                    var isEdit = id !== undefined;
                    if (id) newValue = id;

                    var newOption = '<div class="answer-option">';
                    newOption += '<label class="radio-button" >';
                    newOption +=
                        '<input type="radio" name="answer-option-radio" class="answerOptionRadio" ng-click="handleAnswerOptionInputRadioClick($event, \'multiple-choice\')" value="' +
                        newValue +
                        '" />';
                    newOption += '<span></span>';
                    newOption += '</label>';
                    newOption += '<div class="answer-container">';
                    newOption +=
                        '<input class="answerOptionTitle" required type="text" placeholder="Enter an answer" ng-keyup="handleAnswerInputKeyUp($event)">';
                    newOption += "</div>";
                    newOption +=
                        '<div role="button" data-toggle="modal" data-target="#answerFeedbackModal"  class="answer-comment" ng-click="handleQuestionAnswerFeedbackButtonClick($event, \'answer\')"></div>';
                    newOption +=
                        '<div role="button" ng-click="handleDeleteQuestionAnswerClick($event)" class="trash-icon"></div>';

                    var newOptionElement = angular.element(newOption);
                    $compile(newOptionElement)($scope);

                    if (
                        $(
                            ".multiple-choice-metadata-container .questions .answer-option:last-child"
                        ).length
                    ) {
                        $(".multiple-choice-metadata-container")
                            .find(".questions .answer-option:last-child")
                            .after(newOptionElement);
                    } else {
                        $(
                            ".multiple-choice-metadata-container .questions .error-message"
                        ).after(newOptionElement);
                    }

                    if (!isEdit) {
                        setTimeout(function () {
                            $(
                                ".multiple-choice-metadata-container .questions .answer-option:last-child input"
                            ).focus();
                        }, 100);
                    }
                    enableFormQuestionSaveButton("multiple-choice");
                };

                $scope.handleMultiselectAddNewOptionClick = function (id) {
                    var maxValue = 0;
                    $(".multi-select-metadata-container .answer-option").each(
                        function (index, item) {
                            maxValue = Math.max(
                                maxValue,
                                parseInt(
                                    $(item).find(".answerOptionCheckbox").val()
                                )
                            );
                        }
                    );

                    var newValue = maxValue + 1;
                    var isEdit = id !== undefined;
                    if (id) newValue = id;

                    var newOption = '<div class="answer-option">';
                    newOption += '<label class="check-box">';
                    newOption +=
                        '<input type="checkbox" value="' +
                        newValue +
                        '" class="answerOptionCheckbox" name="answer-option-checkbox" ng-click="handleAnswerOptionInputCheckboxClick($event)" ng-keydown="handleInputKeypress($event)">';
                    newOption += '<span></span>';
                    newOption += '</label>';
                    newOption += '<div class="answer-container">';
                    newOption +=
                        '<input class="answerOptionTitle" required type="text" placeholder="Enter an answer" ng-keyup="handleAnswerInputKeyUp($event)">';
                    newOption += "</div>";
                    newOption +=
                        '<div role="button" data-toggle="modal" data-target="#answerFeedbackModal"  class="answer-comment" ng-click="handleQuestionAnswerFeedbackButtonClick($event, \'answer\')"></div>';
                    newOption +=
                        '<div role="button" ng-click="handleDeleteQuestionAnswerClick($event)" class="trash-icon"></div>';

                    var newOptionElement = angular.element(newOption);
                    $compile(newOptionElement)($scope);

                    if (
                        $(
                            ".multi-select-metadata-container .questions .answer-option"
                        ).last().length
                    ) {
                        $(
                            ".multi-select-metadata-container .questions .answer-option"
                        )
                            .last()
                            .after(newOptionElement);
                    } else {
                        $(
                            ".multi-select-metadata-container .questions .question-title-component"
                        ).after(newOptionElement);
                    }

                    if (!isEdit) {
                        setTimeout(function () {
                            $(
                                ".multi-select-metadata-container .questions .answer-option:last .answerOptionTitle"
                            ).focus();
                        }, 100);
                    }
                    enableFormQuestionSaveButton("multi-select");
                };

                $scope.handleDeleteQuestionAnswerClick = function (e) {
                    var questionId = getQuestionId();
                    if (questionId > 0) {
                        var quizAnswerId = $(e.currentTarget.parentElement)
                            .children(".answerOptionRadio")
                            .val();
                        if (!quizAnswerId)
                            quizAnswerId = $(e.currentTarget.parentElement)
                                .children(".answerOptionCheckbox")
                                .val();
                        if (quizAnswerId)
                            $scope.handleDeleteQuizAnswerClick(quizAnswerId);
                        $(".save-question").attr("disabled", false);
                    }
                    logger("handleDeleteQuestionAnswerClick");
                    $(e.target).parents(".answer-option").remove();
                    enableFormQuestionSaveButton($scope.currentFormType);
                    if (
                        $(
                            ".multiple-choice-metadata-container .questions .answer-option"
                        ).length < 2
                    ) {
                        $(
                            ".multiple-choice-metadata-container .buttons-container .save-question"
                        ).attr("disabled", true);
                    }
                };

                var previousActiveElement = null;

                $scope.setPreviousActiveElement = function (e) {
                    previousActiveElement = document.activeElement;
                };

                $scope.handleExpandQuizSubmissionClick = function (e) {
                    if (
                        previousActiveElement != null &&
                        ($(previousActiveElement).hasClass("question-title") ||
                            $(previousActiveElement).hasClass(
                                "answerOptionTitle"
                            ))
                    ) {
                        $(previousActiveElement).focus();
                    }
                    //Expand
                    if (
                        $(e.target).hasClass(
                            "arrow-up-right-and-arrow-down-left"
                        )
                    ) {
                        $(e.target).removeClass(
                            "arrow-up-right-and-arrow-down-left"
                        );

                        setTimeout(function () {
                            $(e.target).addClass(
                                "arrow-down-left-and-arrow-up-right-to-center"
                            );

                            $(e.target).attr("aria-label","Collapse Quiz Details");

                            $(".video-player").css("max-height", "220px");

                            //student view
                            $(".submit-quiz").css({
                                "overflow-y": "",
                                "min-height": "38vh",
                                height: "unset",
                            });
                        }, 10);
                    }

                    //Collapse
                    if (
                        $(e.target).hasClass(
                            "arrow-down-left-and-arrow-up-right-to-center"
                        )
                    ) {
                        $(e.target).removeClass(
                            "arrow-down-left-and-arrow-up-right-to-center"
                        );
                        $(e.target).addClass(
                            "arrow-up-right-and-arrow-down-left"
                        );

                        //student view
                        $(".submit-quiz").css({
                            "overflow-y": "scroll",
                            "min-height": "",
                        });

                        $(".video-player").css("max-height", "");
                        $(".questions").css("height", "");
                        $(".questions").css("min-height", "");
                    }
                };

                $scope.handleExpandQuizDetailsClick = function (e) {
                    //Expand
                    if (
                        $(e.target).hasClass(
                            "arrow-up-right-and-arrow-down-left"
                        )
                    ) {
                        $(e.target).removeClass(
                            "arrow-up-right-and-arrow-down-left"
                        );

                        setTimeout(function () {
                            $(e.target).addClass(
                                "arrow-down-left-and-arrow-up-right-to-center"
                            );

                            $(".video-player").css("max-height", "220px");

                            //instructor view
                            $(".quiz-metadata-container .card").css({
                                "overflow-y": "",
                                "min-height": "38vh",
                                height: "unset",
                            });

                            //student view
                            $(".take-quiz-metadata-container .card").css({
                                "overflow-y": "",
                                "min-height": "38vh",
                                height: "unset",
                            });
                        }, 10);
                    }

                    //Collapse
                    if (
                        $(e.target).hasClass(
                            "arrow-down-left-and-arrow-up-right-to-center"
                        )
                    ) {
                        $(e.target).removeClass(
                            "arrow-down-left-and-arrow-up-right-to-center"
                        );
                        $(e.target).addClass(
                            "arrow-up-right-and-arrow-down-left"
                        );

                        $(e.target).attr("aria-label","Expand Quiz Details");

                        //instructor view
                        $(".quiz-metadata-container .card").css({
                            "min-height": "",
                            "overflow-y": "scroll",
                        });

                        //student view
                        $(".take-quiz-metadata-container .card").css({
                            "overflow-y": "scroll",
                            "min-height": "",
                        });

                        $(".video-player").css("max-height", "");
                        $(".questions").css("height", "");
                        $(".questions").css("min-height", "");
                    }
                };

                $scope.handleExpandAnswersClick = function (e, source) {
                    if (
                        previousActiveElement != null &&
                        ($(previousActiveElement).hasClass("question-title") ||
                            $(previousActiveElement).hasClass(
                                "answerOptionTitle"
                            ))
                    ) {
                        $(previousActiveElement).focus();
                    }
                    //Expand
                    if (
                        $(e.target).hasClass(
                            "arrow-up-right-and-arrow-down-left"
                        )
                    ) {
                        $(e.target).removeClass(
                            "arrow-up-right-and-arrow-down-left"
                        );

                        setTimeout(function () {
                            $(e.target).addClass(
                                "arrow-down-left-and-arrow-up-right-to-center"
                            );

                            $(".video-player").css("max-height", "220px");

                            //instructor view
                            $(
                                "." + source + "-metadata-container .questions"
                            ).css({
                                "overflow-y": "",
                                "min-height": "38vh",
                                height: "unset",
                            });
                            $(
                                ".pre-edit-question .questions"
                            ).css({
                                "overflow-y": "",
                                "min-height": "38vh",
                                height: "unset",
                            });

                            //student view
                            $(
                                ".take-quiz-answer-question .questions"
                            ).css({
                                "overflow-y": "",
                                "min-height": "38vh",
                                height: "unset",
                            });
                        }, 10);
                    }

                    //Collapse
                    if (
                        $(e.target).hasClass(
                            "arrow-down-left-and-arrow-up-right-to-center"
                        )
                    ) {
                        $(e.target).removeClass(
                            "arrow-down-left-and-arrow-up-right-to-center"
                        );
                        $(e.target).addClass(
                            "arrow-up-right-and-arrow-down-left"
                        );

                        //instructor view
                        $("." + source + "-metadata-container .questions").css({
                            height: "182px",
                            "overflow-y": "scroll",
                        });

                        //student view
                        $(".take-quiz-answer-question .question-container").css(
                            {
                                "overflow-y": "scroll",
                                "min-height": "",
                            }
                        );

                        $(".video-player").css("max-height", "");
                        $(".questions").css("height", "");
                        $(".questions").css("min-height", "");
                    }
                };

                var getQuestionId = function () {
                    if ($scope.selectedQuestionId) {
                        return $scope.selectedQuestionId;
                    }
                    return -1;
                };

                $scope.getFeedbacks = function (item, questionType) {
                    var selector = ".answerOptionRadio";
                    if (questionType == "multi-select") {
                        selector = ".answerOptionCheckbox";
                    }

                    var feedbacks =
                        $scope.currentQuestionAnswerFeedbackList.filter(
                            (x) => x.id == $(item).find(selector).attr("value")
                        );

                    return feedbacks;
                };

                $scope.handleMultipleChoiceSaveQuestionClick = function (e) {
                    if (
                        $scope.validateQuestion(
                            $(e.target)
                                .parents(".question-form")
                                .find("input.question-title")
                        )
                    ) {
                        var questionId = getQuestionId();

                        if (questionId == -1) {
                            var question = {
                                quizId: $scope.quiz.id,
                                title: $(
                                    ".multiple-choice-metadata-container input.question-title"
                                ).val(),
                                questionTime: player.currentTime().toString(),
                                questionType: "multiple-choice",
                                questionFeedbackList:
                                    $scope.currentQuestionFeedbackList,
                            };

                            if (!$scope.quiz.questions) {
                                $scope.quiz.questions = [];
                            }

                            // first add question, then add answers to question
                            AssetService.AddQuestionToQuiz.send(
                                question,
                                function (response) {
                                    var quizId = response.quizId;
                                    var answersList = [];
                                    $(
                                        ".multiple-choice-metadata-container .answer-option"
                                    ).each(function (index, item) {
                                        answersList.push({
                                            answer: $(item)
                                                .find("input.answerOptionTitle")
                                                .val(),
                                            quizAnswerFeedbackList:
                                                $scope.getFeedbacks(
                                                    item,
                                                    "multiple-choice"
                                                ),
                                            isCorrectAnswer: $(item)
                                                .find(".answerOptionRadio")
                                                .prop("checked"),
                                            quizQuestionId: response.id,
                                            sortOrder: index + 1,
                                        });
                                    });
                                    var answerRequest = {
                                        answersList: answersList,
                                    };
                                    $scope.recentlyAddedQuestion = response.id;
                                    AssetService.AddAnswersToQuiz.send(
                                        answerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.multiple-choice-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                            );
                        } else {
                            // add answer to existing question
                            var questionId = $scope.selectedQuestionId;
                            var questions = $scope.quiz.questions.filter(
                                (x) => x.id == questionId
                            );
                            if (questions.length) {
                                questions[0].time =
                                    playerCurrentTime().toString();
                                var question = questions[0];
                                var updateQuestionRequest = {
                                    id: question.id,
                                    title: $(
                                        ".multiple-choice-metadata-container input.question-title"
                                    ).val(),
                                    questionTime:
                                        playerCurrentTime().toString(),
                                    questionFeedbackList:
                                        $scope.currentQuestionFeedbackList,
                                };
                                AssetService.UpdateQuizQuestion.send(
                                    updateQuestionRequest,
                                    function (response) {}
                                );
                                var answers = question.answers;
                                var addAnswersList = [];
                                var updateAnswersList = [];
                                $(
                                    ".multiple-choice-metadata-container .answer-option"
                                ).each(function (index, item) {
                                    var existingAnswer = answers.filter(
                                        (x) =>
                                            x.id ==
                                            $(item)
                                                .find(".answerOptionRadio")
                                                .val()
                                    );

                                    var upsertAnswer = {
                                        answer: $(item)
                                            .find("input.answerOptionTitle")
                                            .val(),
                                        quizAnswerFeedbackList:
                                            $scope.getFeedbacks(
                                                item,
                                                "multiple-choice"
                                            ),
                                        isCorrectAnswer: $(item)
                                            .find(".answerOptionRadio")
                                            .prop("checked"),
                                        quizQuestionId: questionId,
                                        sortOrder: index + 1,
                                    };
                                    if (existingAnswer.length) {
                                        upsertAnswer.id = existingAnswer[0].id;
                                        updateAnswersList.push(upsertAnswer);
                                    } else {
                                        addAnswersList.push(upsertAnswer);
                                    }
                                });
                                if (addAnswersList.length) {
                                    var addAnswerRequest = {
                                        answersList: addAnswersList,
                                    };
                                    AssetService.AddAnswersToQuiz.send(
                                        addAnswerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.multiple-choice-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                                if (updateAnswersList.length) {
                                    var updateAnswerRequest = {
                                        answersList: updateAnswersList,
                                    };
                                    AssetService.UpdateQuizAnswer.send(
                                        updateAnswerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.multiple-choice-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                            }
                        }
                    } else {
                        console.log("error");
                    }
                };

                $scope.handleMultipleChoiceCancelClick = function (e) {
                    $scope.resetQuestionForm("multiple-choice", e);

                    // edit
                    if ($scope.selectedQuestionNumber > -1) {
                        $scope.handlePreEditQuestionClick(
                            $scope.selectedQuestionNumber
                        );
                    } else {
                        // add
                        $scope.quiz.questions = $scope.quiz.questions.filter(
                            function (e) {
                                return e.isDraft !== true;
                            }
                        );
                        $scope.selectedQuestionId = null;
                        $(".multiple-choice-metadata-container").hide();
                        $(".quiz-metadata-container").show();
                        $scope.selectedQuestionId = -1;
                        $scope.editQuestion = null;
                        $scope.currentQuestionAnswerFeedbackList = [];
                        $scope.currentQuestionFeedbackList = [];
                        $scope.loadMarkers(false);
                        $scope.enableButton("AddQuestion",true,null);
                    }
                };

                $scope.handleTrueFalseSaveQuestionClick = function (e) {
                    if (
                        $scope.validateQuestion(
                            $(e.target)
                                .parents(".question-form")
                                .find("input.question-title")
                        )
                    ) {
                        var questionId = getQuestionId();

                        if (questionId == -1) {
                            var question = {
                                id: questionId,
                                title: $(
                                    ".true-false-metadata-container input.question-title"
                                ).val(),
                                time: player.currentTime().toString(),
                                type: "true-false",
                                quizAnswerFeedbackList:
                                    $scope.currentQuestionFeedbackList,
                            };

                            var answers = [];
                            $(
                                ".true-false-metadata-container .answer-option"
                            ).each(function (index, item) {
                                answers.push({
                                    title: $(item)
                                        .find("span.text-option")
                                        .text(),
                                    feedback: "",
                                });
                            });
                            var question = {
                                quizId: $scope.quiz.id,
                                title: $(
                                    ".true-false-metadata-container input.question-title"
                                ).val(),
                                questionTime: player.currentTime().toString(),
                                questionType: "true-false",
                                questionFeedbackList:
                                    $scope.currentQuestionFeedbackList,
                            };

                            if (!$scope.quiz.questions) {
                                $scope.quiz.questions = [];
                            }

                            // first add question, then add answers to question
                            AssetService.AddQuestionToQuiz.send(
                                question,
                                function (response) {
                                    var quizId = response.quizId;
                                    var answersList = [];
                                    $(
                                        ".true-false-metadata-container .answer-option"
                                    ).each(function (index, item) {
                                        answersList.push({
                                            answer: $(item)
                                                .find(".text-option")
                                                .text(),
                                            quizAnswerFeedbackList:
                                                $scope.getFeedbacks(
                                                    item,
                                                    "true-false"
                                                ),
                                            isCorrectAnswer: $(item)
                                                .find(".answerOptionRadio")
                                                .prop("checked"),
                                            quizQuestionId: response.id,
                                            sortOrder: index + 1,
                                        });
                                    });
                                    var answerRequest = {
                                        answersList: answersList,
                                    };
                                    $scope.recentlyAddedQuestion = response.id;
                                    AssetService.AddAnswersToQuiz.send(
                                        answerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.true-false-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                            );
                        } else {
                            // add answer to existing question
                            var questionId = $scope.selectedQuestionId;
                            var questions = $scope.quiz.questions.filter(
                                (x) => x.id == questionId
                            );
                            if (questions.length) {
                                questions[0].time =
                                    playerCurrentTime().toString();
                                var question = questions[0];
                                var updateQuestionRequest = {
                                    id: question.id,
                                    title: $(
                                        ".true-false-metadata-container input.question-title"
                                    ).val(),
                                    questionTime:
                                        playerCurrentTime().toString(),
                                    questionFeedbackList:
                                        $scope.currentQuestionFeedbackList,
                                };
                                AssetService.UpdateQuizQuestion.send(
                                    updateQuestionRequest,
                                    function (response) {}
                                );
                                var answers = question.answers;
                                var updateAnswersList = [];
                                $(
                                    ".true-false-metadata-container .answer-option"
                                ).each(function (index, item) {
                                    var existingAnswer = answers.filter(
                                        (x) =>
                                            x.title ==
                                            $(item)
                                                .find(".answerOptionRadio")
                                                .val()
                                    );
                                    var upsertAnswer = {
                                        answer: $(item)
                                            .find("input.answerOptionRadio")
                                            .val(),
                                        quizAnswerFeedbackList:
                                            $scope.getFeedbacks(
                                                item,
                                                "true-false"
                                            ),
                                        isCorrectAnswer: $(item)
                                            .find(".answerOptionRadio")
                                            .prop("checked"),
                                        quizQuestionId: questionId,
                                        sortOrder: index + 1,
                                    };
                                    if (existingAnswer.length) {
                                        upsertAnswer.id = existingAnswer[0].id;
                                        updateAnswersList.push(upsertAnswer);
                                    }
                                });
                                if (updateAnswersList.length) {
                                    var updateAnswerRequest = {
                                        answersList: updateAnswersList,
                                    };
                                    AssetService.UpdateQuizAnswer.send(
                                        updateAnswerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.true-false-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                            }
                        }
                    } else {
                        console.log("error");
                    }
                };

                $scope.clickTimecode = function (questionNumber) {
                    $(".submit-quiz").hide();
                    $("#marker-" + questionNumber)
                        .children("button")
                        .click();
                };

                $scope.getMarkerType = function (question) {
                    //console.log("question("+ question.id +"): "+ question.questionNumber +" " + question.time +" " + question.answered+" "+question.skipped);
                    if (
                        $scope.takeQuizSelectedQuestion ==
                            question.questionNumber ||
                        ($scope.editQuestion &&
                            $scope.editQuestion.questionNumber ==
                                question.questionNumber)
                    ) {
                        return "active";
                    } else if (question.skipped) {
                        return "skipped";
                    } else if (question.answered) {
                        return "completed";
                    } else if (typeof question.questionNumber === "undefined") {
                        return "active";
                    } else if ($scope.selectedQuestionId === question.id) {
                        return "active";
                    } else {
                        return "inactive";
                    }
                };

                $scope.setFinalStop = function () {
                    $scope.finalStop = null;
                    $.each($scope.quiz.questions, function (k, v) {
                        v.time = roundValue(v.time);
                        //console.log("Q:"+ v.questionNumber + " " + v.time + " " + v.answered + " " + v.skipped);
                        if (!v.answered && !v.skipped) {
                            $scope.finalStop = v;
                            return false;
                        }
                    });
                };

                $scope.setNextStop = function () {
                    //console.log("setNextStop playerCurrentTime(): "+playerCurrentTime());
                    $scope.nextStop = null;
                    $.each($scope.quiz.questions, function (k, v) {
                        v.time = roundValue(v.time);
                        //console.log("Q:"+ v.questionNumber + " " + v.time +" "+ v.answered +" "+ v.skipped);
                        if (
                            !v.answered &&
                            (v.time > playerCurrentTime() ||
                                ($scope.finalStop &&
                                    v.time === $scope.finalStop.time))
                        ) {
                            $scope.nextStop = v;
                            //console.log("setNextStop Matched: "+ $scope.nextStop.time);
                            return false;
                        }
                    });
                };

                $scope.setLastMarker = function () {
                    $scope.lastMarker = null;
                    $.each($scope.quiz.questions, function (k, v) {
                        v.time = roundValue(v.time);
                        //console.log("Q:"+ v.questionNumber + " " + v.time);
                        $scope.lastMarker = v;
                    });
                };

                $scope.loadMarkers = function (loadDrafts) {
                    //console.log("loadMarkers("+loadDrafts+")");
                    if (!$scope.quiz) return;
                    var newMarkers = [];
                    $scope.quiz.questions.sort(
                        (a, b) =>
                            hmsToSecondsOnly(a.time) - hmsToSecondsOnly(b.time)
                    );
                    $.each($scope.quiz.questions, function (k, v) {
                        v.time = roundValue(hmsToSecondsOnly(v.time));
                        //console.log("v("+ v.id +"): "+ v.questionNumber +" " + v.time +" " + v.answered+" "+v.skipped+" "+$scope.getMarkerType(v));
                        var label = k + 1;
                        if (!loadDrafts) {
                            v.questionNumber = label;
                        }
                        var popover = "";
                        if (
                            !$scope.hasWritePermissions &&
                            $scope.takeQuizSelectedQuestion !==
                                v.questionNumber &&
                            (v.answered || v.skipped)
                        ) {
                            popover = v.title;
                        } else if (
                            $scope.hasWritePermissions &&
                            (!$scope.editQuestion ||
                                $scope.editQuestion.questionNumber !==
                                    v.questionNumber)
                        ) {
                            popover = v.title;
                        }
                        newMarkers.push({
                            time: v.time,
                            label: label,
                            type: $scope.getMarkerType(v),
                            popover: popover,
                            displayTime: v.displayTime,
                        });
                    });

                    $scope.addVideoMarkers(newMarkers);
                    if (!$scope.hasWritePermissions) {
                        $scope.setFinalStop();
                        $scope.setNextStop();
                        $scope.setLastMarker();
                    }
                };

                /*
                 * Function to trigger a loadMarkers only after a player seeked event has occured
                 * and loadDrafts is false
                 * @param {type} loadDrafts
                 */
                $scope.loadMarkersSeeked = function (loadDrafts) {
                    //console.log("loadMarkersSeeked("+loadDrafts+")");
                    if (loadDrafts) {
                        $scope.loadMarkers(loadDrafts);
                    } else {
                        $scope.seekedloadMarkers = true;
                    }
                };

                $scope.handleTrueFalseCancelClick = function (e) {
                    $scope.resetQuestionForm("true-false", e);

                    // edit
                    if ($scope.selectedQuestionNumber > -1) {
                        $scope.handlePreEditQuestionClick(
                            $scope.selectedQuestionNumber
                        );
                    } else {
                        // add
                        $scope.quiz.questions = $scope.quiz.questions.filter(
                            function (e) {
                                return e.isDraft !== true;
                            }
                        );
                        $scope.selectedQuestionId = null;
                        $(".true-false-metadata-container").hide();
                        $(".quiz-metadata-container").show();
                        $scope.selectedQuestionId = -1;
                        $scope.editQuestion = null;
                        $scope.currentQuestionAnswerFeedbackList = [];
                        $scope.currentQuestionFeedbackList = [];
                        $scope.loadMarkers(false);
                        $scope.enableButton("AddQuestion",true,null);
                    }
                };

                $scope.handleBreadcrumbRootContainerClick = function () {
                    $scope.navigateToCollection({
                        type: "Collection",
                        xid: $scope.rootCollectionId,
                    });
                };

                $scope.navigateToCollection = function (content) {
                    logger("navigateToCollection");
                    $scope.goBack(content);
                };

                $scope.goBack = function (content) {
                    logger("goBack");
                    if (
                        $scope.parent.type === "course" ||
                        $scope.parent.type === "collection" ||
                        $scope.parent.type === "dropbox" ||
                        $scope.parent.type === "assignment" ||
                        $scope.parent.type === "zoom"
                    ) {
                        if ($scope.hideHeaderAndFooter) {
                            $state.go("lmsCourse", {
                                collectionId:
                                    ($scope.collectionTree &&
                                        $scope.collectionTree.cid) ||
                                    $scope.currentCollection.cid,
                                items: [],
                                type: "",
                                showUnpublished: $scope.asset.isActive == 0 && !$scope.isNewQuiz,
                                destinationFolderId: content.xid,
                                destinationFolderCollectionTree:
                                    $scope.collectionTree,
                            });
                        } else {
                            $state.go("course", {
                                collectionId:
                                    ($scope.collectionTree &&
                                        $scope.collectionTree.cid) ||
                                    $scope.currentCollection.cid,
                                items: [],
                                showUnpublished: $scope.asset.isActive == 0 && !$scope.isNewQuiz,
                                type: "",
                                destinationFolderId: content.xid,
                                destinationFolderCollectionTree:
                                    $scope.collectionTree,
                            });
                        }
                    } else if ($scope.parent.type === "channel") {
                        $state.go("channel", {
                            collectionId:
                                ($scope.collectionTree &&
                                    $scope.collectionTree.cid) ||
                                $scope.currentCollection.cid,
                            items: [],
                            showUnpublished: $scope.asset.isActive == 0 && !$scope.isNewQuiz,
                            type: "",
                            destinationFolderId: content.xid,
                            destinationFolderCollectionTree:
                                $scope.collectionTree,
                        });
                    } else if (
                        $scope.parent.type === "protected" ||
                        $scope.parent.type === "reserves"
                    ) {
                        $state.go("protected", {
                            collectionId:
                                ($scope.collectionTree &&
                                    $scope.collectionTree.cid) ||
                                $scope.currentCollection.cid,
                            items: [],
                            showUnpublished: $scope.asset.isActive == 0 && !$scope.isNewQuiz,
                            type: "",
                            destinationFolderId: content.xid,
                            destinationFolderCollectionTree:
                                $scope.collectionTree,
                        });
                    }
                };

                $scope.handleMultiselectSaveQuestionClick = function (e) {
                    if (
                        $scope.validateQuestion(
                            $(e.target)
                                .parents(".question-form")
                                .find("input.question-title")
                        )
                    ) {
                        var questionId = getQuestionId();

                        if (questionId == -1) {
                            var question = {
                                id: questionId,
                                title: $(
                                    ".multi-select-metadata-container input.question-title"
                                ).val(),
                                time: player.currentTime().toString(),
                                type: "multi-select",
                                quizAnswerFeedbackList:
                                    $scope.currentQuestionFeedbackList,
                            };

                            var answers = [];
                            $(
                                ".multi-select-metadata-container .answer-option"
                            ).each(function (index, item) {
                                answers.push({
                                    title: $(item)
                                        .find("span.text-option")
                                        .text(),
                                    feedback: "",
                                });
                            });
                            var question = {
                                quizId: $scope.quiz.id,
                                title: $(
                                    ".multi-select-metadata-container input.question-title"
                                ).val(),
                                questionTime: player.currentTime().toString(),
                                questionType: "multi-select",
                                questionFeedbackList:
                                    $scope.currentQuestionFeedbackList,
                            };

                            if (!$scope.quiz.questions) {
                                $scope.quiz.questions = [];
                            }

                            // first add question, then add answers to question
                            AssetService.AddQuestionToQuiz.send(
                                question,
                                function (response) {
                                    var quizId = response.quizId;
                                    var answersList = [];
                                    $(
                                        ".multi-select-metadata-container .answer-option"
                                    ).each(function (index, item) {
                                        answersList.push({
                                            answer: $(item)
                                                .find("input.answerOptionTitle")
                                                .val(),
                                            quizAnswerFeedbackList:
                                                $scope.getFeedbacks(
                                                    item,
                                                    "multi-select"
                                                ),
                                            isCorrectAnswer: $(item)
                                                .find(".answerOptionCheckbox")
                                                .prop("checked"),
                                            quizQuestionId: response.id,
                                            sortOrder: index + 1,
                                        });
                                    });
                                    var answerRequest = {
                                        answersList: answersList,
                                    };
                                    $scope.recentlyAddedQuestion = response.id;
                                    AssetService.AddAnswersToQuiz.send(
                                        answerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.multi-select-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                            );
                        } else {
                            // add answer to existing question
                            var questionId = $scope.selectedQuestionId;
                            var questions = $scope.quiz.questions.filter(
                                (x) => x.id == questionId
                            );
                            if (questions.length) {
                                questions[0].time =
                                    playerCurrentTime().toString();
                                var question = questions[0];
                                var updateQuestionRequest = {
                                    id: question.id,
                                    title: $(
                                        ".multi-select-metadata-container input.question-title"
                                    ).val(),
                                    questionTime:
                                        playerCurrentTime().toString(),
                                    questionFeedbackList:
                                        $scope.currentQuestionFeedbackList,
                                };
                                AssetService.UpdateQuizQuestion.send(
                                    updateQuestionRequest,
                                    function (response) {}
                                );
                                var answers = question.answers;
                                var addAnswersList = [];
                                var updateAnswersList = [];
                                $(
                                    ".multi-select-metadata-container .answer-option"
                                ).each(function (index, item) {
                                    var existingAnswer = answers.filter(
                                        (x) =>
                                            x.id ==
                                            $(item)
                                                .find(".answerOptionCheckbox")
                                                .val()
                                    );
                                    var upsertAnswer = {
                                        answer: $(item)
                                            .find("input.answerOptionTitle")
                                            .val(),
                                        quizAnswerFeedbackList:
                                            $scope.getFeedbacks(
                                                item,
                                                "multi-select"
                                            ),
                                        isCorrectAnswer: $(item)
                                            .find(".answerOptionCheckbox")
                                            .prop("checked"),
                                        quizQuestionId: questionId,
                                        sortOrder: index + 1,
                                    };
                                    if (existingAnswer.length) {
                                        upsertAnswer.id = existingAnswer[0].id;
                                        updateAnswersList.push(upsertAnswer);
                                    } else {
                                        addAnswersList.push(upsertAnswer);
                                    }
                                });
                                if (addAnswersList.length) {
                                    var addAnswerRequest = {
                                        answersList: addAnswersList,
                                    };
                                    AssetService.AddAnswersToQuiz.send(
                                        addAnswerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.multi-select-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                                if (updateAnswersList.length) {
                                    var updateAnswerRequest = {
                                        answersList: updateAnswersList,
                                    };
                                    AssetService.UpdateQuizAnswer.send(
                                        updateAnswerRequest,
                                        function (response) {
                                            $scope
                                                .getQuizMetadata()
                                                .finally(function () {
                                                    // click cancel button to reset form
                                                    $(
                                                        ".question-form.multi-select-metadata-container .defaultSecondaryButton"
                                                    ).click();
                                                });
                                        }
                                    );
                                }
                            }
                        }
                    } else {
                        console.log("error");
                    }
                };

                $scope.handleMultiselectCancelClick = function (e) {
                    $scope.resetQuestionForm("multi-select", e);

                    // edit
                    if ($scope.selectedQuestionNumber > -1) {
                        $scope.handlePreEditQuestionClick(
                            $scope.selectedQuestionNumber
                        );
                    } else {
                        // add
                        $scope.quiz.questions = $scope.quiz.questions.filter(
                            function (e) {
                                return e.isDraft !== true;
                            }
                        );
                        $scope.selectedQuestionId = null;
                        $(".multi-select-metadata-container").hide();
                        $(".quiz-metadata-container").show();
                        $scope.selectedQuestionId = -1;
                        $scope.editQuestion = null;
                        $scope.currentQuestionAnswerFeedbackList = [];
                        $scope.currentQuestionFeedbackList = [];
                        $scope.loadMarkers(false);
                        $scope.enableButton("AddQuestion",true,null);
                    }
                };

                $scope.handleNumericCancelClick = function (e) {
                    $scope.resetQuestionForm("numeric", e);

                    // edit
                    if ($scope.selectedQuestionNumber > -1) {
                        $scope.handlePreEditQuestionClick(
                            $scope.selectedQuestionNumber
                        );
                    } else {
                        // add
                        $scope.quiz.questions = $scope.quiz.questions.filter(
                            function (e) {
                                return e.isDraft !== true;
                            }
                        );
                        $scope.selectedQuestionId = null;
                        $(".numeric-metadata-container").hide();
                        $(".quiz-metadata-container").show();
                        $scope.selectedQuestionId = -1;
                        $scope.editQuestion = null;
                        $scope.currentQuestionAnswerFeedbackList = [];
                        $scope.currentQuestionFeedbackList = [];
                        $scope.loadMarkers(false);
                    }
                };

                $scope.handleNumericSaveQuestionClick = function (e) {
                    if (
                        $scope.validateQuestion(
                            $(e.target)
                                .parents(".question-form")
                                .find("input.question-title")
                        )
                    ) {
                        var questionId = getQuestionId();

                        var question = {
                            id: questionId,
                            title: $(
                                ".numeric-metadata-container input.question-title"
                            ).val(),
                            time: player.currentTime().toString(),
                            type: "numeric",
                        };

                        var answers = [];
                        answers.push({
                            title: $(
                                ".numeric-metadata-container .answer-option input.number"
                            ).val(),
                            feedback: "",
                        });

                        question.answers = answers;

                        if (!$scope.quiz.questions) $scope.quiz.questions = [];

                        $scope.quiz.questions.push(question);
                        $scope.resetQuestionForm("numeric", e);

                        console.log("$scope.quiz", $scope.quiz);
                    } else {
                        console.log("error");
                    }
                };

                $scope.resetQuestionForm = function (formType, e) {
                    $scope.editQuestion = null;
                    $scope.selectedQuestionId = -1;
                    $scope.currentFormType = formType;
                    $(".save-question span").text("Save Question");
                    $(".save-question").attr("disabled","true");

                    var questionTitleInput = $(e.target)
                        .parents(".question-form")
                        .find("input.question-title");

                    $(questionTitleInput).val("");
                    $(e.target)
                        .parents(".question-form")
                        .find("input.time")
                        .val("");
                    hideQuestionFormErrorMessage(questionTitleInput);

                    if (
                        formType === "multiple-choice" ||
                        formType === "multi-select"
                    ) {
                        $(".answer-container .answerOptionTitle").val("");
                        $(".answer-container .answerOptionTitle")
                            .parent()
                            .css("background", "#f2f3f5");

                        $(e.target)
                            .parents(".question-form")
                            .find(".answer-option")
                            .each(function (index, item) {
                                $(item)
                                    .find("input[type=radio]")
                                    .prop("checked", false);
                                $(item)
                                    .find("input[type=checkbox]")
                                    .prop("checked", false);
                            });
                    } else if (formType === "true-false") {
                        $('input[name="answer-option-radio"]').prop(
                            "checked",
                            false
                        );
                    }

                    // reset number of answers back to 2
                    $scope.resetAnswerOptions(formType);
                };

                $scope.resetAnswerOptions = function (formType) {
                    $scope.currentFormType = formType;
                    if (
                        formType === "multiple-choice" &&
                        $(
                            ".multiple-choice-metadata-container .questions .answer-option"
                        ).length !== 2
                    ) {
                        $(
                            ".question-form.multiple-choice-metadata-container"
                        ).replaceWith(originalMultipleChoiceFormHtml);
                        $compile(
                            $(
                                ".question-form.multiple-choice-metadata-container"
                            )
                        )($scope);
                    } else if (
                        formType === "multi-select" &&
                        $(
                            ".multi-select-metadata-container .questions .answer-option"
                        ).length !== 2
                    ) {
                        $(
                            ".question-form.multi-select-metadata-container"
                        ).replaceWith(originalMultiselectFormHtml);
                        $compile(
                            $(".question-form.multi-select-metadata-container")
                        )($scope);
                    }
                };

                $scope.handleNumSubmissionsChanged = function () {
                    if($("#quizSubmissions").attr("aria-readonly")==="true"){
                        $("#quizSubmissions").val($scope.originalQuizNumSubmissions);
                    }else{
                        if (
                            $scope.originalQuizNumSubmissions == 1 &&
                            $scope.quiz.settings.quizSubmissions > 1
                        ) {
                            $scope.showSettingsConfirmModal("numSubmissions");
                        } else {
                            $scope.updateQuizSettings();
                        }
                    }
                };

                $scope.handleEnterOnlyKeydown = function (e) {
                    //console.log("handleEnterOnlyKeydown()");
                    if($(e.target).attr("aria-readonly")==="true" &&
                            (e.key !== "Shift" && e.key !== "Tab")){
                        //console.log("Stop propagation");
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }

                $scope.handleNumericIncreaseClick = function (e) {
                    var inputField = $(e.target)
                        .parents(".numeric-answer-component")
                        .find("input");
                    var value = $(inputField).val();

                    if (!isNaN(value)) {
                        value++;
                    }

                    $(inputField).val(value);
                    $scope.updateQuizSettings();
                };

                $scope.handleNumericDecreaseClick = function (e) {
                    var inputField = $(e.target)
                        .parents(".numeric-answer-component")
                        .find("input");
                    var value = $(inputField).val();

                    if (!isNaN(value)) {
                        value--;
                    }

                    $(inputField).val(value);
                    $scope.updateQuizSettings();
                };

                $scope.handleQuestionTitleBlur = function (e) {
                    $scope.validateQuestion(e.target);
                };

                $scope.validateQuestion = function (element) {
                    if ($(element).val().trim() === "") {
                        setTimeout(() => {
                            showQuestionFormErrorMessage(element);
                        }, 200);
                        return false;
                    } else {
                        setTimeout(() => {
                            hideQuestionFormErrorMessage(element);
                        }, 200);
                        return true;
                    }
                };

                var showQuestionFormErrorMessage = function (
                    questionTitleElement
                ) {
                    $(questionTitleElement)
                        .parents(".question-title-component")
                        .css("margin-bottom", "4px");
                    $(questionTitleElement)
                        .parents(".question-container")
                        .find(".error-message")
                        .css("display", "flex");

                    $(questionTitleElement)
                        .parents(".question-title-component")
                        .css("border", "none");

                    $(questionTitleElement)
                        .parents(".question-title-container")
                        .css("border", "1px solid #CE061F");

                    $(questionTitleElement)
                        .parents(".question-title-component")
                        .find(".question-time-container")
                        .css({
                            border: "1px solid #e5e6eb",
                            "border-radius": "0 6px 6px 0",
                        });
                };

                var hideQuestionFormErrorMessage = function (
                    questionTitleElement
                ) {
                    $(questionTitleElement)
                        .parents(".question-title-component")
                        .css("margin-bottom", "12px");
                    $(questionTitleElement)
                        .parents(".question-container")
                        .find(".error-message")
                        .css("display", "none");

                    $(questionTitleElement)
                        .parents(".question-title-container")
                        .css("border", "none");
                    $(questionTitleElement)
                        .parents(".question-title-container")
                        .css("border-right", "1px solid #e5e6eb");

                    $(questionTitleElement)
                        .parents(".question-title-component")
                        .css("border", "1px solid #e5e6eb");

                    $(questionTitleElement)
                        .parents(".question-title-component")
                        .find(".question-time-container")
                        .css({
                            border: "none",
                            "border-radius": "0",
                        });
                };

                $scope.handleQuizConfigTabClick = function (e, tab) {
                    if ($scope.hasWritePermissions) {
                        validateQuizTitle();
                    }

                    if (tab === "questions") {
                        $scope.showQuestionsTab(e);
                    }

                    if (tab === "settings") {
                        $scope.showSettingsTab(e);
                    }

                    if (tab === "details") {
                        $scope.showDetailsTab(e);
                    }
                };

                $scope.showQuestionsTab = function (e) {
                    $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                    if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                        $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                    }else{
                        $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                    }
                    $(".quiz-metadata .empty-state-container").hide();
                    $(".detailsTabContent").hide();
                    $(".settingsTabContent").hide();

                    if ($scope.quiz.questions && $scope.quiz.questions.length) {
                        $(".questionsTabContent").show();
                    } else {
                        $(".empty-state-container").show();
                    }
                    $scope.questionsTabSelected = true;
                };

                $scope.showDetailsTab = function (e) {
                    $(".quiz-metadata .empty-state-container").hide();
                    $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                    if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                        $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                    }else{
                        $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                    }
                    $(".settingsTabContent").hide();
                    $(".questionsTabContent").hide();
                    $(".detailsTabContent").show();
                    $scope.questionsTabSelected = false;
                };

                $scope.showSettingsTab = function (e) {
                    $(".quiz-metadata .empty-state-container").hide();
                    $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");
                    if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                        $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                    }else{
                        $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                    }
                    $(".detailsTabContent").hide();
                    $(".questionsTabContent").hide();
                    $(".settingsTabContent").show();
                    $scope.questionsTabSelected = false;
                };

                $scope.handleQuestionCardMenuIconClick = function (e) {
                    var el = $(e.target)
                        .parents(".question-card")
                        .find(".view-answers-menu");
                    $.each($(".view-answers-menu"), function (k, v) {
                        if ($(v).attr("id") == $(el).attr("id")) {
                            el.toggle();
                            if(el.is(':visible')){
                                $(e.target).attr("aria-expanded","true");
                                el.focus();
                            }else{
                                $(e.target).attr("aria-expanded","false");
                                $(e.target).focus();
                            }
                        } else {
                            $(v).hide();
                        }
                    });
                };

                $scope.handleQuizMoreActionsMenuClick = function(e){
                    var el = $("#quizzingMoreActionsMenu");
                    el.toggle();
                    if(el.is(":visible")){
                        $("#quizzingMoreActionsMenuButton").attr("aria-expanded","true");
                        el.find('[tabindex="0"]').first().focus();
                    }else{
                        $("#quizzingMoreActionsMenuButton").attr("aria-expanded","false").focus();
                    }
                };

                $scope.handleQuizMoreActionsMenuKeydown = function(e){
                    if(e.which===32 || e.which===13){
                        e.preventDefault();
                        $(e.target).click();
                    } else if (e.which === 9 && !e.shiftKey) {
                        var lastItem = $("#quizzingMoreActionsMenu").find('[tabindex="0"]').last();
                        if($(e.target).is(lastItem)){
                            e.preventDefault();
                            $("#quizzingMoreActionsMenuButton").focus();
                        }
                    } else if(e.which===27){
                        $("#quizzingMoreActionsMenu").hide();
                        $("#quizzingMoreActionsMenuButton").attr("aria-expanded","false");
                        $("#quizzingMoreActionsMenuButton").focus();
                    }
                };

                $scope.hideQuizMoreActionsMenuWhenClickOutside = function(e){
                    if(!$(e.target).hasClass("overflow-menu") &&
                        $(e.target).parents(".overflow-menu").length ===0 &&
                        !$(e.target).hasClass("menu-button") &&
                        $(e.target).parents(".menu-button").length === 0){
                        $("#quizzingMoreActionsMenu").hide();
                        $("#quizzingMoreActionsMenuButton").attr("aria-expanded","false");
                    }
                };

                $scope.hideQuizAddQuestionMenuWhenClickOutside = function(e){
                    if(!$(e.target).hasClass("add-question-menu") &&
                        $(e.target).parents(".add-question-menu").length ===0 &&
                        !$(e.target).hasClass("add-question-button") &&
                        $(e.target).parents(".add-question-button").length === 0){
                        $("#quizzingAddQuestionButton").removeClass("open").attr("aria-expanded","false");
                    }
                };

                $scope.hideQuizViewAnswersMenuWhenClickOutside = function(e){
                    if(!$(e.target).hasClass("view-answers-menu") &&
                        $(e.target).parents(".view-answers-menu").length ===0 &&
                        !$(e.target).hasClass("view-answers-button") &&
                        $(e.target).parents(".view-answers-button").length === 0){
                        $(".view-answers-button").attr("aria-expanded","false");
                        $(".view-answers-menu").hide();
                    }
                };

                $scope.hideBreadcrumbMenuWhenClickOutside = function(e){
                    if(!$(e.target).hasClass("breadcrumb-menu") &&
                        $(e.target).parents(".breadcrumb-menu").length ===0 &&
                        !$(e.target).hasClass("ellipsis") &&
                        $(e.target).parents(".ellipsis").length === 0){
                        if($(".breadcrumb-menu").is(":visible")){
                            $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                            $('.breadcrumb-menu').hide();
                        }
                    }
                };

                $scope.handleChangeActiveViewClick = function (e, playerSide) {
                    if (
                        previousActiveElement != null &&
                        ($(previousActiveElement).hasClass("question-title") ||
                            $(previousActiveElement).hasClass(
                                "answerOptionTitle"
                            ))
                    ) {
                        $(previousActiveElement).focus();
                    }
                    if ($scope.focusInQuizTitle) {
                        focusOnQuizTitleInput();
                    }

                    if (playerSide === "left") {
                        $(".player-quiz-tabs-container").css(
                            "flex-direction",
                            "row"
                        );

                        if (!$(e.target).hasClass("selected")) {
                            $(e.target).addClass("selected");
                        }

                        //remove selected from right
                        var rightIcon = $(e.target)
                            .parent()
                            .find("div:nth-child(2)");
                        if ($(rightIcon).hasClass("selected")) {
                            $(rightIcon).removeClass("selected");
                        }
                    }

                    if (playerSide === "right") {
                        if (!$(e.target).hasClass("selected")) {
                            $(e.target).addClass("selected");
                        }

                        var leftIcon = $(e.target)
                            .parent()
                            .find("div:nth-child(1)");
                        if ($(leftIcon).hasClass("selected")) {
                            $(leftIcon).removeClass("selected");
                        }

                        $(".player-quiz-tabs-container").css(
                            "flex-direction",
                            "row-reverse"
                        );
                    }
                };

                $scope.handleCardViewAnswersClick = function (e, questionId) {
                    $(e.target)
                        .parents(".question-card")
                        .find(".answers-container")
                        .toggle();

                    var element;
                    if ($(e.target).hasClass("view-answers")) {
                        element = $(e.target);
                    } else {
                        element = $(e.target).parents(".view-answers");
                    }

                    if (
                        $(element)
                            .find(".chevron-down")
                            .css("transform")
                            .indexOf("matrix") > -1
                    ) {
                        $(element).find(".chevron-down").css("transform", "");
                    } else {
                        $(element)
                            .find(".chevron-down")
                            .css("transform", "rotate(180deg)");
                    }
                };

                $scope.handleQuestionCounterClick = function (questionNumber) {
                    $(".button-row").hide();
                    $scope.startTime = Date.now();
                    $scope.takeQuizSelectedQuestion = questionNumber;
                    var currentQuestion = $scope.quiz.questions.filter(
                        (x) => x.questionNumber == questionNumber
                    )[0];
                    $scope.showSkip = $scope.quiz.settings.allowSkipping;
                    $scope.loadMarkers(false);
                    if (currentQuestion.answered || currentQuestion.skipped) {
                        $scope.showSkip = $scope.quiz.settings.allowChanges && $scope.quiz.settings.allowSkipping;
                        $scope.enableButton("PlayToggle", true, null);
                    } else {
                        $scope.enableButton("PlayToggle", false, null);
                    }
                    $scope.enableButton("Video", true, null);
                    $timeout(function () {
                        $(".buttons-container .save-button").hide();
                        $(".next-question-button").hide();
                        $scope.isNextQuestion = false;
                        $(".feedback-container").hide();
                        var selectedCount = 0;
                        $(".take-quiz-answer-question .answers-container")
                                .find("ul li .answer-option-input")
                                .each(function (index, item) {
                                    if ($(item).prop("checked")) {
                                        selectedCount++;
                                    }
                                });
                        $(".clear-selection-button").show().prop("disabled", false);
                        if(selectedCount === 0){
                            $(".buttons-container .save-button").prop("disabled",true);
                            $scope.selectedAnswerIds = [];
                            $(".clear-selection-button").prop("disabled", true);
                        }
                        $(".buttons-container .save-button span").text("Save");
                        $(".cancel-answer-button").hide();
                        // TODO: Skipped
                        if (currentQuestion.skipped) {
                            $(".buttons-container .save-button").show();
                            $(".next-question-button").hide();
                            $scope.isNextQuestion = false;
                        } else if (currentQuestion.answered) {
                            var selectedAnswers =
                                currentQuestion.answers.filter(
                                    (x) => x.checked
                                );
                            $scope.selectedAnswerIds = selectedAnswers.map(
                                (x) => x.id
                            );
                            $(".clear-selection-button").hide();
                            if (!$scope.quiz.settings.allowSkipping) {
                            }
                            if ($scope.quiz.settings.allowChanges) {
                                if (selectedAnswers.length) {
                                    $timeout(() => {
                                        if (currentQuestion.answers.length) {
                                            $.each(currentQuestion.answers, function (k, answer) {

                                                const selector = "#answer-" + answer.id + " input";

                                                if ($scope.selectedAnswerIds.includes(answer.id)) {
                                                    $(selector).prop("checked", true);
                                                } else {
                                                    $(selector).prop("checked", false);
                                                }
                                            });
                                        }
                                    }, 10);
                                }
                                $(".next-question-button").show();
                                $scope.isNextQuestion = true;
                                $(
                                    ".buttons-container .change-answer-button"
                                ).show();
                                $(".buttons-container .save-button").hide();

                                if ($scope.isInReview) {
                                    $(
                                        ".buttons-container .keep-answer-button"
                                    ).show();
                                }

                                if (currentQuestion.answers.length) {
                                    $.each(currentQuestion.answers, function (k, answer) {
                                        $("#answer-" + answer.id + " input").attr("aria-readonly", true);
                                    });
                                }
                            } else {
                                if (currentQuestion.answers.length) {
                                    $.each(currentQuestion.answers, function (k, answer) {
                                        const $input = $("#answer-" + answer.id + " input");

                                        $input.attr("aria-readonly", true);
                                        $input.prop("checked", !!answer.checked); // coerces to true/false

                                        if (answer.checked) {
                                            if (
                                                $scope.quiz.settings.showFeedbackAnswerSubmission &&
                                                !$scope.hasWritePermissions
                                            ) {
                                                if (currentQuestion.wasCorrectAnswer) {
                                                    $("#correct-answer-icon-" + answer.id).show();
                                                } else {
                                                    $("#incorrect-answer-icon-" + answer.id).show();
                                                }
                                            }
                                        }
                                    });
                                }
                                $(".save-button").hide();
                                $(".next-question-button").show();
                                $scope.isNextQuestion = true;
                            }
                        } else {
                            $(
                                ".buttons-container .change-answer-button"
                            ).hide();
                            $(".buttons-container .keep-answer-button").hide();
                            $(".save-button").show();
                        }
                        //hide take quiz
                        $(".take-quiz-metadata-container").hide();
                        //hide submit quiz
                        $(".submit-quiz").hide();
                        //show question
                        $(".take-quiz-answer-question").show();
                        $(".question-container .question-counter").focus();
                    }, 50);
                };

                $scope.checkEnterKey = function (e) {
                    //console.log("checkEnterKey() ");
                    if($(e.target).attr("aria-readonly")==="true"){
                        //console.log("stop propagation");
                        e.stopPropagation();
                        e.preventDefault();
                    }else{
                        if (e.key === "Enter") {
                            e.preventDefault();
                            $(e.target).click();
                        }
                    }
                };

                $scope.checkKeyDown = function (e) {
                    var tgt = e.currentTarget, flag = false;

                    switch (e.key) {
                        case 'ArrowLeft':
                          $scope.initializeTabs();
                          $scope.moveFocusToPreviousTab(tgt);
                          flag = true;
                          break;

                        case 'ArrowRight':
                          $scope.initializeTabs();
                          $scope.moveFocusToNextTab(tgt);
                          flag = true;
                          break;

                        case 'Home':
                          $scope.initializeTabs();
                          $scope.moveFocusToTab($scope.firstTab);
                          flag = true;
                          break;

                        case 'End':
                          $scope.initializeTabs();
                          $scope.moveFocusToTab($scope.lastTab);
                          flag = true;
                          break;

                        default:
                          break;
                    }

                    if (flag) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                };
                $scope.moveFocusToTab = function(currentTab){
                    if (currentTab) {
                        if(typeof currentTab.focus === 'function'){
                            currentTab.focus();
                            //Include fallowing line for automatic tab selection
                            //currentTab.click();
                        }else{
                            console.log("moveFocusToTab() Element is not focusable.");
                        }
                    } else {
                        console.log("moveFocusToTab() Element to focus is not found.");
                    }
                };
                $scope.moveFocusToPreviousTab = function(currentTab){
                    var index;

                    if (currentTab === $scope.firstTab) {
                        $scope.moveFocusToTab($scope.lastTab);
                    } else {
                        index = $scope.tabs.indexOf(currentTab);
                        $scope.moveFocusToTab($scope.tabs[index - 1]);
                    }

                };
                $scope.moveFocusToNextTab = function(currentTab){
                    var index;

                    if (currentTab === $scope.lastTab) {
                        $scope.moveFocusToTab($scope.firstTab);
                    } else {
                        index = $scope.tabs.indexOf(currentTab);
                        $scope.moveFocusToTab($scope.tabs[index + 1]);
                    }
                };
                $scope.initializeTabs = function () {
                    $scope.tabs = Array.from($('.player-quiz-tabs-container [role=tab]:visible'));
                    $scope.firstTab = null;
                    $scope.lastTab = null;
                    for (var i = 0; i < $scope.tabs.length; i++) {
                        if (!$scope.firstTab) {
                            $scope.firstTab = $scope.tabs[i];
                        }
                        $scope.lastTab = $scope.tabs[i];
                    }
                    if(!$scope.firstTab || !$scope.lastTab){
                        console.log("initializeTabs failed and are empty");
                    }else if(typeof $scope.firstTab.focus !== 'function' || typeof $scope.lastTab.focus !== 'function'){
                        console.log("initializeTabs failed and have no focus function");
                    }
                };
                $scope.handleQuestionAnswerFeedbackButtonClick = function (
                    el,
                    type
                ) {
                    var text = "";
                    var modalSelector = "#" + type + "FeedbackModal";
                    var modal = $(modalSelector);
                    var textarea = modal.find("textarea");

                    textarea.attr("placeholder", "");

                    if (type == "answer") {
                        modal.attr("data-selecteditem", "");

                        var selectedItem = $(el.target)
                              .closest('.answer-option')
                              .find('input[type="radio"], input[type="checkbox"]')
                              .first()
                              .val();

                        var feedbackExists =
                            $scope.currentQuestionAnswerFeedbackList.filter(
                                (x) => x.id == selectedItem
                            );
                        if (feedbackExists.length) {
                            var selectedFeedback = feedbackExists[0];
                            text = selectedFeedback.feedback;
                        }
                        modal.attr("data-selecteditem", selectedItem);
                    }

                    if (type == "question") {
                        modal.attr("data-selecteditem", "");
                        if ($scope.currentQuestionFeedbackList.length > 0) {
                            var selectedFeedback =
                                $scope.currentQuestionFeedbackList[0];
                            text = selectedFeedback.feedback;
                        }
                    }

                    modal.attr("data-original-feedback", text);
                    modal
                        .find(".modal-footer .save-button")
                        .attr("disabled", true);

                    if (text == "") {
                        textarea.attr(
                            "placeholder",
                            "Enter " + type + " feedback"
                        );
                    } else {
                        setTimeout(function () {
                            textarea.val(text);
                        }, 350);
                    }
                    setTimeout(function () {
                        textarea.focus();
                    }, 550);
                };

                $scope.enableFormQuestionSaveBtn = function (formType) {
                    $scope.currentFormType = formType;
                    enableFormQuestionSaveButton(formType);
                };

                function enableFormQuestionSaveButton(formType) {
                    var totalNumOptions = $("." + formType + "-metadata-container .answer-option").length;
                    if (totalNumOptions > 1) {
                        var passed = false;
                        var filledOptionsCount = 0;
                        var selectedOption = false;

                        $(
                            "." +
                                formType +
                                "-metadata-container .answer-option"
                        ).each(function (index, item) {
                            if (formType === "true-false") {
                                if (
                                    $(item)
                                        .find(".answerOptionRadio")
                                        .prop("checked")
                                ) {
                                    selectedOption = true;
                                }
                                var timeChosen =
                                    $(
                                        "." +
                                            formType +
                                            "-metadata-container .time"
                                    )
                                        .val()
                                        .trim().length > 0;

                                if (
                                    $(
                                        "." +
                                            formType +
                                            "-metadata-container .question-title"
                                    )
                                        .val()
                                        .trim().length > 0 &&
                                    timeChosen &&
                                    selectedOption
                                ) {
                                    passed = true;
                                }
                            } else {
                                if (
                                    $(item)
                                        .find(".answerOptionTitle")
                                        .val()
                                        .trim() !== ""
                                ) {
                                    filledOptionsCount++;

                                    if (formType === "multiple-choice") {
                                        if (
                                            $(item)
                                                .find(".answerOptionRadio")
                                                .prop("checked")
                                        ) {
                                            selectedOption = true;
                                        }
                                    }

                                    if (formType === "multi-select") {
                                        if (
                                            $(item)
                                                .find(".answerOptionCheckbox")
                                                .prop("checked")
                                        ) {
                                            selectedOption = true;
                                        }
                                    }

                                    var timeChosen =
                                        $(
                                            "." +
                                                formType +
                                                "-metadata-container .time"
                                        )
                                            .val()
                                            .trim().length > 0;

                                    if (
                                        filledOptionsCount > 1 &&
                                        filledOptionsCount === totalNumOptions &&
                                        $(
                                            "." +
                                                formType +
                                                "-metadata-container .question-title"
                                        )
                                            .val()
                                            .trim().length > 0 &&
                                        timeChosen &&
                                        selectedOption
                                    ) {
                                        passed = true;
                                    }
                                }
                            }
                        });

                        $("." + formType + "-metadata-container")
                            .find(
                                ".buttons-container .action-buttons .save-question"
                            )
                            .attr("disabled", !passed);
                    }
                }

                $scope.showDiscardQuestionModal = function(){
                    if($scope.selectedQuestionId===-1){
                        var draftQuestion = $scope.quiz.questions.filter(function (e) {return e.isDraft === true;});
                        if(draftQuestion.length>0){
                            var questionStarted = $scope.hasQuestionStarted();
                            if(questionStarted){
                                $("#discardQuestionConfirmModalLabel span").text("Discard Question?");
                                $("#discardQuestionConfirmModal .modal-body").text("You have added a question but not saved it. If you navigate away from the unsaved question, it will be discarded. This action cannot be undone.");
                                $("#btnDiscardQuestionConfirm span").text("Discard Question");
                                $("#discardQuestionConfirmModal").modal({
                                    backdrop: "static",
                                    keyboard: false,
                                });
                                return false;
                            }else{
                                $("."+$scope.currentFormType+"-metadata-container button.defaultSecondaryButton").click();
                                $timeout(function () {
                                    if("edit"===$scope.questionToDiscardForType){
                                        $("#view-answers-menu-"+ $scope.questionToDiscardForNumber +" .view-answers-menu-edit-question").click();
                                    }else if("delete"===$scope.questionToDiscardForType){
                                        $("#view-answers-menu-"+ $scope.questionToDiscardForNumber +" .view-answers-menu-delete-question").click();
                                    }else{
                                        $("#marker-"+$scope.questionToDiscardForNumber +" > button").click();
                                    }
                                }, 70);
                                return false;
                            }
                        }
                    }else if($scope.selectedQuestionId > 0 && !$scope.isPreEdit){
                        var beforeDisabledState = $("."+$scope.currentFormType+"-metadata-container button.defaultPrimaryButton").prop('disabled');
                        enableFormQuestionSaveButton($scope.currentFormType);
                        var afterDisabledState = $("."+$scope.currentFormType+"-metadata-container button.defaultPrimaryButton").prop('disabled');
                        if(!beforeDisabledState || (beforeDisabledState && afterDisabledState)){
                            $("#discardQuestionConfirmModalLabel span").text("Discard Edits to Question?");
                            $("#discardQuestionConfirmModal .modal-body").text("You have edited a question but not saved the edits. If you navigate away from the question, the unsaved edits to the question will be discarded. This action cannot be undone.");
                            $("#btnDiscardQuestionConfirm span").text("Discard Edits");
                            $("#discardQuestionConfirmModal").modal({
                                backdrop: "static",
                                keyboard: false,
                            });
                            return false;
                        }else{
                            $("."+$scope.currentFormType+"-metadata-container button.defaultSecondaryButton").click();
                            $timeout(function () {
                                if("edit"===$scope.questionToDiscardForType){
                                    $("#view-answers-menu-"+ $scope.questionToDiscardForNumber +" .view-answers-menu-edit-question").click();
                                }else if("delete"===$scope.questionToDiscardForType){
                                    $("#view-answers-menu-"+ $scope.questionToDiscardForNumber +" .view-answers-menu-delete-question").click();
                                }else{
                                    $("#marker-"+$scope.questionToDiscardForNumber +" > button").click();
                                }
                            }, 70);
                            return false;
                        }
                    }
                    return true;
                }

                $scope.hasQuestionStarted = function(){
                    var questionStarted = false;
                    if($("."+$scope.currentFormType+"-metadata-container input.question-title").val().trim()!==""){
                        questionStarted = true;
                    } else if($scope.currentQuestionFeedbackList[0] !== undefined && $scope.currentQuestionFeedbackList[0].feedback.trim()!==""){
                        questionStarted = true;
                    } else if("multi-select"===$scope.currentFormType && $(".multi-select-metadata-container").find(".answerOptionCheckbox").prop("checked")){
                        questionStarted = true;
                    } else if(("multiple-choice"===$scope.currentFormType || "true-false"===$scope.currentFormType) &&
                            $("."+$scope.currentFormType+"-metadata-container").find(".answerOptionRadio").prop("checked")){
                        questionStarted = true;
                    } else {
                        var answerOptionTitles = $("."+$scope.currentFormType+"-metadata-container").find(".answerOptionTitle");
                        answerOptionTitles.each(function(){
                            if($(this).val().trim()!==""){
                                questionStarted = true;
                                return false;
                            }
                        });
                        if(("multiple-choice"===$scope.currentFormType || "multi-select"===$scope.currentFormType) &&
                                answerOptionTitles.length!==2)  {
                            questionStarted = true;
                        }
                        $($scope.currentQuestionAnswerFeedbackList).each(function(){
                            if($(this)[0].feedback.trim()!==""){
                                questionStarted = true;
                                return false;
                            }
                        });
                    }
                    return questionStarted;
                }

                $scope.handleQuestionTitleInputKeyUp = function (
                    e,
                    formType
                ) {
                    $scope.currentFormType = formType;
                    setTimeout(function () {
                        //at least 2 filled options for multiple choice and multiselect questions
                        if ((formType === "multiple-choice" || formType === "true-false" || formType === "multi-select") &&
                                !$scope.isNonInputKey(e)
                        ) {
                            enableFormQuestionSaveButton(formType);
                        }

                        if (
                            $(e.target).val().trim() === "" &&
                            $(e.target).val().length > 0
                        ) {
                            //show error message
                            console.log("show error - same as blur");
                            $scope.validateQuestion(e.target);
                        }

                        //This validateQuestion call will show the error message if there's no relevant content,
                        //i.e., empty spaces are not allowed as well as an empty question title.
                        $scope.validateQuestion(e.target);
                    }, 0);
                };

                $scope.handleAnswerInputKeyUp = function (e) {
                    setTimeout(function () {
                        if ($(e.target).val() === "") {
                            $(e.target).parent().css("background", "#f2f3f5");
                        } else {
                            $(e.target).parent().css("background", "#fff");
                        }

                        //at least 2 filled options for multiple choice and multiselect questions
                        if ($(e.target).parents(".multiple-choice-metadata-container").length &&
                               !$scope.isNonInputKey(e)
                        ) {
                            enableFormQuestionSaveButton("multiple-choice");
                        }

                        if ($(e.target).parents(".multi-select-metadata-container").length  &&
                            !$scope.isNonInputKey(e)
                        ) {
                            enableFormQuestionSaveButton("multi-select");
                        }

                        //
                    }, 0);
                };

                $scope.isNonInputKey = function(e) {
                    //console.log("isNonInputKey(): "+e.which);
                    var codes = ",9,13,16,17,18,19,20,27,33,34,35,36,37,38,39,40,45,93,144,145,";
                    if(codes.includes(","+e.which+",")){
                        return true;
                    }else{
                        return false;
                    }
                };

                $scope.handleDeleteQuizButtonClick = function () {
                    AssetService.DeleteQuiz.send(
                        {
                            quizId: $scope.quiz.id,
                        },
                        function (response) {
                            $("#deleteModal").modal("hide");
                            $scope.navigateToCollection({
                                type: "Collection",
                                xid: $scope.rootCollectionId
                            });
                        }
                    );
                };

                $scope.publishQuiz = function () {
                    $scope.openModal("Publish");
                    $scope.$broadcast('reloadPublishModal', { reload: true });
                    $timeout(function() {
                        $("#cbMakeQuizAvailable").prop('checked', false);
                    }, 100);
                };

                $scope.handleMoveQuizClick = function () {
                    $("#quizzingMoreActionsMenu").hide();
                    $("#quizzingMoreActionsMenuButton").attr("aria-expanded","false");
                    $scope.openModal("Move");
                };

                $scope.handleCopyQuizClick = function () {
                    $("#quizzingMoreActionsMenu").hide();
                    $("#quizzingMoreActionsMenuButton").attr("aria-expanded","false");
                    $scope.openModal("Copy");
                    $timeout(function() {
                        $("#cbMakeQuizAvailable").prop('checked', false);
                    }, 100);
                };

                $scope.viewQuizReport = function () {
                    $state.go("quizzingReportInstructor", {
                        collectionId: $scope.quiz.collectionId,
                        assetId: $scope.quiz.assetId,
                        quizId: $scope.quiz.id,
                    });
                };

                $scope.viewStudentQuizReport = function () {
                    $state.go("quizzingReportStudent", {
                        collectionId: $scope.quiz.collectionId,
                        assetId: $scope.quiz.assetId,
                        quizId: $scope.quiz.id,
                        showResyncButton: false,
                        isPreview: $scope.isPreview && $scope.isInstructor,
                    });
                };

                $scope.editQuiz = function () {
                    $(".view-actions-menu").hide();
                    AssetService.EditQuiz.get(
                        {
                            quizId: $scope.quiz.id,
                        },
                        function (response) {
                            $scope.getQuizMetadata();
                        }
                    );
                };

                $scope.editQuizModal = function () {
                    $("#editQuizModal").modal('show');
                    $(".view-actions-menu").hide();
                };

                $scope.republishQuiz = function () {
                    $(".view-actions-menu").hide();
                    AssetService.RepublishQuiz.get(
                        {
                            quizId: $scope.quiz.id,
                        },
                        function (response) {
                            $scope.getQuizMetadata();
                        }
                    );
                };

                $scope.previewQuiz = function () {
                    player.pause();
                    $scope.isPreview = true;
                    $scope.loadPageInfo();
                    $scope.enterPreviewTime = player.currentTime();
                    $scope.enterPreviewSelectedQuestionNumber = $scope.selectedQuestionNumber;

                    $scope.selectedQuestionNumber = -1;
                    $scope.selectedQuestionId = -1;
                    $scope.selectedQuestion = -1;
                    $scope.editQuestion = null;
                    $scope.quizInProgress = false;
                    $(".take-quiz-answer-question").hide();
                    $(".multiple-choice-metadata-container").hide();
                    $(".multi-select-metadata-container").hide();
                    $(".true-false-metadata-container").hide();
                    $(".numeric-metadata-container").hide();
                    $(".pre-edit-question").hide();
                    $(".video-js-custom.video-js").addClass("vjs-preview");
                    $("#questions-tab").trigger("click");
                };

                $scope.exitPreviewMode = function () {
                    $scope.isPreview = false;
                    $scope.loadPageInfo();
                    $scope.selectedQuestionNumber = -1;
                    $scope.selectedQuestionId = -1;
                    $scope.takeQuizSelectedQuestion = -1;
                    $timeout(function() {
                        $(".take-quiz-metadata-container").hide();
                        player.pause();
                        player.currentTime($scope.enterPreviewTime);
                        if ($scope.enterPreviewSelectedQuestionNumber > 0) {
                            $scope.handlePreEditQuestionClick($scope.enterPreviewSelectedQuestionNumber);
                        }
                        $scope.enterPreviewSelectedQuestionNumber = -1;
                        $(".video-js-custom.video-js").removeClass("vjs-preview");
                        $scope.enableButton("All", true, null);
                        $scope.enableButton("PlayToggle", true, null);
                    }, 650);
                };

                $scope.handleUnpublishClick = function () {
                    $(".view-actions-menu").hide();
                    var assetActiveStatusDTO = {
                        assetId: $scope.asset.aid,
                        active: false,
                    };
                    AssetService.SetActiveStatus.send(
                        assetActiveStatusDTO,
                        function (response) {
                            $scope.loadPageInfo();
                        }
                    );
                };

                $scope.handleRenameClick = function () {
                    $(".view-actions-menu").hide();
                    $(".pre-edit-question").hide();
                    $(".multiple-choice-metadata-container").hide();
                    $(".multi-select-metadata-container").hide();
                    $(".numeric-metadata-container").hide();
                    $(".true-false-metadata-container").hide();
                    $(".quiz-metadata-container").show();
                    $(".quiz-metadata-container .quiz-title-input").focus();
                };

                $scope.handleEditDescriptionClick = function () {
                    $(".view-actions-menu").hide();
                    $(".pre-edit-question").hide();
                    $(".multiple-choice-metadata-container").hide();
                    $(".multi-select-metadata-container").hide();
                    $(".numeric-metadata-container").hide();
                    $(".true-false-metadata-container").hide();
                    $(".quiz-metadata-container").show();
                    $(".quiz-metadata-container .quiz-desc-input").focus();
                };

                $scope.showDeleteQuestionConfirmModal = function (questionToDelete) {
                    $(".view-answers-button").attr("aria-expanded","false");
                    $(".view-answers-menu").hide();

                    // Conditionally show Discard Question Modal First
                    $scope.questionToDiscardForNumber = questionToDelete.id;
                    $scope.questionToDiscardForType = "delete";
                    if(!$scope.showDiscardQuestionModal()){
                        return false;
                    }

                    $scope.questionToDelete = questionToDelete;
                    $("#deleteQuestionConfirmModal").modal({
                        backdrop: "static",
                        keyboard: false,
                    });
                };

                $scope.handleDeleteQuestionClick = function () {
                    $scope.isPreEdit = false;
                    // if the question we are deleting is the active one, show the quiz metadata
                    if (
                        $(".vjs-active-marker").text() ==
                            $scope.questionToDelete.questionNumber ||
                        $(".vjs-marker.active").text() ==
                            $scope.questionToDelete.questionNumber ||
                        $(".vjs-marker.active > button").text() ==
                            $scope.questionToDelete.questionNumber
                    ) {
                        $(".multiple-choice-metadata-container").hide();
                        $(".multi-select-metadata-container").hide();
                        $(".true-false-metadata-container").hide();
                        $(".numeric-metadata-container").hide();
                        $(".pre-edit-question").hide();
                        $(".quiz-metadata-container").show();
                        $scope.enableButton("AddQuestion", true, null);
                        $scope.editQuestion = null;
                        $scope.selectedQuestionId = -1;
                        $scope.isPreEdit = false;
                    }

                    AssetService.DeleteQuizQuestion.send(
                        {
                            quizQuestionId: $scope.questionToDelete.id,
                        },
                        function (response) {
                            $scope.enableButton(null,null,{
                                ProgressControl: true,
                                AddQuestion: true,
                            });
                            $scope.getQuizMetadata();
                        }
                    );
                };

                $scope.handleDiscardQuestionClick = function () {
                    $("#discardQuestionConfirmModal").modal("hide");
                    $("."+$scope.currentFormType+"-metadata-container button.defaultSecondaryButton").click();
                    $timeout(function () {
                        if("edit"===$scope.questionToDiscardForType){
                            $("#view-answers-menu-"+ $scope.questionToDiscardForNumber +" .view-answers-menu-edit-question").click();
                        }else if("delete"===$scope.questionToDiscardForType){
                            $("#view-answers-menu-"+ $scope.questionToDiscardForNumber +" .view-answers-menu-delete-question").click();
                        }else{
                            $("#marker-"+$scope.questionToDiscardForNumber +" > button").click();
                        }
                    }, 70);
                };

                var generateCrumbs = function (cid, path) {
                    logger("generateCrumbs");

                    var crumbs = [];
                    if (path) {
                        var parents = path.split("/").slice(3);
                        if (parents.length && $scope.collectionTree) {
                            angular.forEach(
                                $scope.collectionTree.children,
                                function (node) {
                                    getCrumbs(node, crumbs, cid, parents);
                                }
                            );
                        }
                    }

                    return crumbs;
                };

                // recursive function that gets all parent nodes of a collection from the collection tree
                var getCrumbs = function (node, crumbs, cid, parents) {
                    logger("getCrumbs");
                    if (node.cid && parents.indexOf(node.cid) !== -1) {
                        crumbs.push({
                            title: node.title,
                            cid: node.cid,
                        });
                    }
                    angular.forEach(node.children, function (child) {
                        getCrumbs(child, crumbs, cid, parents);
                    });
                };

                $scope.handleDeleteQuizAnswerClick = function (quizAnswerId) {
                    AssetService.DeleteQuizAnswer.send(
                        {
                            quizAnswerId: quizAnswerId,
                        },
                        function (response) {
                            $scope.fromDeleteQuizAnswer = true;
                            $scope.getQuizMetadata();
                        }
                    );
                };

                $scope.handlePreEditQuestionClick = function (questionNumber) {
                    var question = $scope.quiz.questions.filter(
                        (x) => x.questionNumber == questionNumber
                    )[0];
                    $scope.isPreEdit = true;
                    $scope.enableButton(null, null, {
                        ProgressControl: false,
                        AddQuestion: false,
                    });
                    $scope.selectedQuestionNumber = question.questionNumber;
                    $scope.selectedQuestionId = question.id;
                    $scope.selectedQuestion = question;
                    $scope.editQuestion = null;
                    $scope.currentQuestionAnswerFeedbackList = [];
                    $scope.currentQuestionFeedbackList = [];
                    $(".vjs-marker").removeClass("active");
                    $("#marker-" + question.questionNumber).addClass("active");
                    playerCurrentTime(hmsToSecondsOnly(question.time));

                    $timeout(function () {
                        $scope.editQuestion = question;
                        $scope.selectedQuestionId = question.id;
                    }, 10);

                    var currentQuestion = question;
                    $timeout(function () {
                        var selectedAnswers = currentQuestion.answers.filter(
                            (x) => x.checked
                        );
                        $scope.selectedAnswerIds = selectedAnswers.map(
                            (x) => x.id
                        );
                        if (currentQuestion.answers.length) {
                            $.each(currentQuestion.answers, function (k, answer) {
                                const $input = $("#answer-" + answer.id + " input");

                                // Disable properly
                                $input.attr("aria-readonly", true);

                                // Set checked state properly
                                $input.prop("checked", !!answer.checked);

                                if (answer.checked) {
                                    if (
                                        $scope.quiz.settings.showFeedbackAnswerSubmission &&
                                        !$scope.hasWritePermissions
                                    ) {
                                        if (currentQuestion.wasCorrectAnswer) {
                                            $("#correct-answer-icon-" + answer.id).show();
                                        } else {
                                            $("#incorrect-answer-icon-" + answer.id).show();
                                        }
                                    }
                                }
                            });
                        }
                    }, 0);
                    $(".quiz-metadata-container").hide();
                    $(".true-false-metadata-container").hide();
                    $(".multi-select-metadata-container").hide();
                    $(".numeric-metadata-container").hide();
                    $(".multiple-choice-metadata-container").hide();
                    $("#quizzingAddQuestionButton").removeClass("open").attr("aria-expanded","false");
                    //set menu icon aria-expanded to false
                    $(".menu-icon").attr("aria-expanded","false");
                    $(".pre-edit-question").show();
                    $scope.loadMarkers(false);
                    $timeout(function () {
                        $(".question-container .question-counter").focus();
                    }, 50);
                };

                $scope.handleEditQuestionClick = function (question) {

                    $(".view-answers-button").attr("aria-expanded","false");
                    $(".view-answers-menu").hide();

                    // Conditionally show Discard Question Modal
                    $scope.questionToDiscardForNumber = question.id;
                    $scope.questionToDiscardForType = "edit";
                    if(!$scope.showDiscardQuestionModal()){
                        return false;
                    }

                    $scope.isFirstSeek = true;
                    $scope.isPreEdit = false;
                    $scope.selectedQuestionNumber = question.questionNumber;
                    $scope.selectedQuestionId = question.id;
                    $scope.selectedQuestion = question;
                    $scope.editQuestion = null;
                    $scope.currentQuestionAnswerFeedbackList = [];
                    $scope.currentQuestionFeedbackList = [];
                    $(".vjs-marker").removeClass("active");
                    $("#marker-" + question.questionNumber).addClass("active");
                    playerCurrentTime(hmsToSecondsOnly(question.time));
                    $scope.enableButton(null, null, {
                        ProgressControl: true,
                        AddQuestion: false,
                    });
                    if (question.type == "multiple-choice") {
                        $scope.handleAddMultipleChoiceClick(false);
                        $(
                            ".multiple-choice-metadata-container .answer-option"
                        ).remove();
                        $(
                            ".multiple-choice-metadata-container .question-title"
                        ).val(question.title);
                        $(".multiple-choice-metadata-container .time").val(
                            question.time
                        );
                        var answersSorted = question.answers
                            .slice()
                            .sort((a, b) => a.sortOrder - b.sortOrder);
                        $scope.currentQuestionFeedbackList =
                            $scope.currentQuestionFeedbackList.concat(
                                question.feedbacks
                            );
                        $.each(answersSorted, function (k, answer) {
                            if (answer.feedbacks.length)
                                answer.feedbacks[0].id = answer.id;
                            $scope.currentQuestionAnswerFeedbackList =
                                $scope.currentQuestionAnswerFeedbackList.concat(
                                    answer.feedbacks
                                );
                            $scope.handleMultipleChoiceAddNewOptionClick(
                                answer.id
                            );
                            var answerContainer = $(
                                '.answerOptionRadio[value="' + answer.id + '"]'
                            ).parents(".answer-option");
                            $(answerContainer)
                                .children(".answer-container")
                                .children("input")
                                .val(answer.title);
                            if (answer.checked)
                                $(
                                    '.answerOptionRadio[value="' +
                                        answer.id +
                                        '"]'
                                ).prop("checked", true);
                        });
                        $(".answer-container").css("background", "#fff");
                        $(
                            ".multiple-choice-metadata-container .buttons-container .save-question"
                        ).attr("disabled", false);
                    } else if (question.type == "true-false") {
                        $scope.handleAddTrueFalseClick(false);
                        $(
                            ".question-form.true-false-metadata-container .question-title"
                        ).val(question.title);
                        $(
                            ".question-form.true-false-metadata-container .time"
                        ).val(question.time);
                        $scope.currentQuestionFeedbackList =
                            $scope.currentQuestionFeedbackList.concat(
                                question.feedbacks
                            );
                        var answer = question.answers.filter(
                            (x) => x.checked
                        )[0].title;
                        $(
                            '.question-form.true-false-metadata-container .answerOptionRadio[value="' +
                                answer +
                                '"]'
                        ).prop("checked", true);
                        $(
                            ".true-false-metadata-container .buttons-container .save-question"
                        ).attr("disabled", false);
                    } else if (question.type == "multi-select") {
                        $scope.handleAddMultiSelectClick(false);
                        $(
                            ".multi-select-metadata-container .answer-option"
                        ).remove();
                        $(
                            ".multi-select-metadata-container .question-title"
                        ).val(question.title);
                        $(".multi-select-metadata-container .time").val(
                            question.time
                        );
                        var answersSorted = question.answers
                            .slice()
                            .sort((a, b) => a.sortOrder - b.sortOrder);
                        $scope.currentQuestionFeedbackList =
                            $scope.currentQuestionFeedbackList.concat(
                                question.feedbacks
                            );
                        $.each(answersSorted, function (k, answer) {
                            if (answer.feedbacks.length)
                                answer.feedbacks[0].id = answer.id;
                            $scope.currentQuestionAnswerFeedbackList =
                                $scope.currentQuestionAnswerFeedbackList.concat(
                                    answer.feedbacks
                                );
                            $scope.handleMultiselectAddNewOptionClick(
                                answer.id
                            );
                            var answerContainer = $(
                                '.answerOptionCheckbox[value="' +
                                    answer.id +
                                    '"]'
                            ).parents(".answer-option");
                            $(answerContainer)
                                .children(".answer-container")
                                .children("input")
                                .val(answer.title);
                            if (answer.checked)
                                $(
                                    '.answerOptionCheckbox[value="' +
                                        answer.id +
                                        '"]'
                                ).prop("checked", true);
                        });
                        $(".answer-container").css("background", "#fff");
                        $(
                            ".multi-select-metadata-container .buttons-container .save-question"
                        ).attr("disabled", false);
                    }
                    $scope.editQuestion = question;
                    $scope.currentFormType = question.type;
                    $scope.selectedQuestionId = question.id;
                    $timeout(function () {
                        $(".question-container .question-title-container input.question-title").focus();
                    }, 50);
                    $(".save-question").attr("disabled", true);
                };

                $scope.updateQuizSettings = function (e) {
                    var updateQuizSettings = {
                        quizId: $scope.quiz.id,
                        allowSkipping: $("#allowSkipping").prop("checked"),
                        allowChanges: $("#allowChanges").prop("checked"),
                        shuffleAnswers: $("#shuffleAnswers").prop("checked"),
                        //                    showCorrectAnswer: $("#showCorrectAnswer").prop("checked"),
                        showCorrectAnswer: false,
                        showFeedbackAnswerSubmission:
                            $("#showFeedback").prop("checked"),
                        showResultsQuizSubmission:
                            $("#showResults").prop("checked"),
                        answerSubmissions: $("#answerSubmissions").val(),
                        quizSubmissions: $("#quizSubmissions").val(),
                    };
                    AssetService.UpdateQuizSettings.send(
                        updateQuizSettings,
                        function (response) {
                            $scope.loadPageInfo();
                        }
                    );
                };

                $scope.handleSettingsSwitchClick = function (e) {
                    var switchId = $(e.target).attr("id");

                    if (!$scope.quiz.settings) $scope.quiz.settings = {};
                    if($("#"+switchId).attr("aria-readonly")==="true"){
                        //console.log("stop propagation");
                        e.stopPropagation();
                        e.preventDefault();
                    }else{
                        eval(
                            "$scope.quiz.settings." +
                                switchId +
                                " = " +
                                $(e.target)[0].checked
                        );
                        $(".header .buttons-container button:nth-child(3)").attr(
                            "disabled",
                            false
                        );

                        if (
                            $(e.target)[0].checked &&
                            (switchId == "allowSkipping" ||
                                switchId == "allowChanges" ||
                                switchId == "showFeedback" ||
                                switchId == "showResults")
                        ) {
                            // if we are turning the setting on, don't update setting yet. Show modal. Await confirmation
                            $scope.showSettingsConfirmModal(switchId);
                        } else {
                            $scope.updateQuizSettings();
                        }
                    }
                };

                var waitForElement = function (selector, callback) {
                    var tries = 0;
                    var intervalId = setInterval(function () {
                        tries++;
                        // console.log('tries', tries, selector)
                        if ($(selector).length) {
                            // console.log('found selector', selector)
                            clearInterval(intervalId);
                            callback();
                        }
                    }, 50);
                };

                var focusOnQuizTitleInput = function () {
                    waitForElement(
                        ".quiz-metadata-container .quiz-title-input",
                        function () {
                            if ($scope.isNewQuiz) {
                                $(
                                    ".quiz-metadata-container .quiz-title-input"
                                ).focus();
                            }
                        }
                    );
                };

                var hasEllipsisHeight = function (el) {
                    if (el.offsetHeight && el.scrollHeight) {
                        return el.offsetHeight < el.scrollHeight;
                    }

                    return null;
                };

                var hasEllipsisWidth = function (el) {
                    if (el && el.offsetWidth && el.scrollWidth) {
                        return el.offsetWidth < el.scrollWidth;
                    }

                    return null;
                };

                focusOnQuizTitleInput();

                $scope.firstEditDone = false;

                $scope.handleQuizNameKeyPress = function (e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        if ($scope.isNewQuiz && !$scope.firstEditDone) {
                            $(e.target)
                                .parents(".quiz-metadata-container")
                                .find("textarea")
                                .focus();
                            $scope.firstEditDone = true;
                        } else {
                            $(e.target).blur();
                        }
                    }
                };

                $scope.handleModalTextareaKeyDown = function (e, modalId) {
                    var modal = $("#" + modalId);
                    var originalValue =
                        modal.attr("data-original-feedback") || "";

                    setTimeout(function () {
                        var currentValue = $(e.target).val() || "";
                        var hasChanged = currentValue !== originalValue;

                        modal
                            .find(".modal-footer .save-button")
                            .attr("disabled", !hasChanged);
                    }, 50);
                };

                $scope.handleAnswerOptionInputRadioClick = function (
                    e,
                    formType
                ) {
                    $scope.currentFormType = formType;
                    enableFormQuestionSaveButton(formType);
                };

                $scope.handleAnswerOptionInputCheckboxClick = function (e) {
                    enableFormQuestionSaveButton("multi-select");
                };

                var validateQuizTitle = function () {
                    if (
                        $(".quiz-metadata-container .quiz-title-input")
                            .val()
                            .trim() === ""
                    ) {
                        showQuizTitleErrorMessage({
                            changeBorderColor: true,
                        });
                    }
                };

                $scope.handleQuizDescriptionClick = function () {
                    validateQuizTitle();
                };

                $scope.handleSaveAnswerFeedbackClick = function (e) {
                    var el = $(e.target).parents(".modal");
                    if ($(el).attr("id") == "answerFeedbackModal") {
                        var selectedItem = parseInt(
                            $(el).attr("data-selecteditem")
                        );
                        var selectedFeedback =
                            $scope.currentQuestionAnswerFeedbackList.filter(
                                (x) => x.id == selectedItem
                            );
                        if (selectedFeedback.length) {
                            selectedFeedback[0].feedback = $(e.target)
                                .parents(".modal")
                                .find("textarea")
                                .val();
                        } else {
                            $scope.currentQuestionAnswerFeedbackList.push({
                                id: selectedItem,
                                feedback: $(e.target)
                                    .parents(".modal")
                                    .find("textarea")
                                    .val(),
                                feedbackTypeId: 4,
                            });
                        }
                    }
                    setTimeout(function () {
                        //Clear the entered feedback content
                        $(e.target).parents(".modal").find("textarea").val("");

                        enableFormQuestionSaveButton($scope.currentFormType);

                        $(e.target).parents(".modal")
                            .find(".modal-footer .save-button")
                            .attr("disabled", true);
                    }, 1000);
                };

                $scope.handleSaveQuestionFeedbackClick = function (e) {
                    var el = $(e.target).parents(".modal");
                    if ($(el).attr("id") == "questionFeedbackModal") {
                        if ($scope.currentQuestionFeedbackList.length > 0) {
                            $scope.currentQuestionFeedbackList[0].feedback = $(
                                e.target
                            )
                                .parents(".modal")
                                .find("textarea")
                                .val();
                        } else {
                            $scope.currentQuestionFeedbackList.push({
                                id: 1,
                                feedback: $(e.target)
                                    .parents(".modal")
                                    .find("textarea")
                                    .val(),
                                feedbackTypeId: 3,
                            });
                        }
                    }
                    setTimeout(function () {
                        //Clear the entered feedback content
                        $(e.target).parents(".modal").find("textarea").val("");

                        enableFormQuestionSaveButton($scope.currentFormType);

                        $(e.target).parents(".modal")
                            .find(".modal-footer .save-button")
                            .attr("disabled", true);
                    }, 1000);
                };

                $scope.handleCloseQuestionFeedbackClick = function (e) {
                    setTimeout(function () {
                        //Clear the entered feedback content
                        $(e.target).parents(".modal").find("textarea").val("");

                        $(e.target).parents(".modal")
                            .find(".modal-footer .save-button")
                            .attr("disabled", true);
                    }, 1000);
                };

                $scope.handleCloseAnswerFeedbackClick = function (e) {
                    setTimeout(function () {
                        //Clear the entered feedback content
                        $(e.target).parents(".modal").find("textarea").val("");

                        $(e.target).parents(".modal")
                            .find(".modal-footer .save-button")
                            .attr("disabled", true);
                    }, 1000);
                };

                $scope.selectedAnswerIds = [];

                $scope.handleClearQuizAnswerSelection = function (e) {
                    $(".answers-container")
                        .find("ul li .answer-option-input")
                        .each(function (index, item) {
                            $(item).prop("checked", false);
                        });
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".buttons-container .save-button")
                        .prop("disabled", true);
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".buttons-container .clear-selection-button")
                        .prop("disabled", true);
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".buttons-container .skip-button")
                        .prop("disabled", false);
                };

                $scope.handleTakeQuizAnswerOptionClick = function (
                    e,
                    answerId,
                    isMultiselect
                ) {
                    //enable save if at least one option is checked
                    var selectedCount = 0;

                    $(e.target)
                        .parents(".answers-container")
                        .find("ul li .answer-option-input")
                        .each(function (index, item) {
                            if ($(item).prop("checked")) {
                                selectedCount++;
                            }
                        });

                    if (!isMultiselect) {
                        // can only make 1 selection, wipe out previous selections
                        $scope.selectedAnswerIds = [];
                        $scope.selectedAnswerIds.push(answerId);
                    } else {
                        // if multiselect, if answer already in list remove it, else push it.
                        if ($scope.selectedAnswerIds.includes(answerId)) {
                            $scope.selectedAnswerIds =
                                $scope.selectedAnswerIds.filter(function (e) {
                                    return e !== answerId;
                                });
                        } else {
                            $scope.selectedAnswerIds.push(answerId);
                        }
                    }

                    var currentQuestion = $scope.quiz.questions.filter(
                        (x) =>
                            x.questionNumber == $scope.takeQuizSelectedQuestion
                    )[0];

                    var prevSelectedAnswerIds = currentQuestion.answers
                        .filter((answer) => answer.checked)
                        .map((answer) => answer.id);

                    var allSameAnswers =
                        $scope.isChangingAnswer &&
                        $scope.selectedAnswerIds.length === prevSelectedAnswerIds.length &&
                        $scope.selectedAnswerIds.every(id => prevSelectedAnswerIds.includes(id));

                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".buttons-container .save-button")
                        .prop("disabled", selectedCount === 0 || allSameAnswers);
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".buttons-container .clear-selection-button")
                        .prop("disabled", selectedCount === 0);
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".buttons-container .skip-button")
                        .prop("disabled", false);
                };

                var resetTakeQuizForm = function (e) {
                    //clear radio and checkbox answers
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".answers-container .answer-option-input")
                        .each(function (index, item) {
                            $(item).prop("checked", false);
                        });

                    //TODO: set numeric to 0

                    //disable save button
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".buttons-container .save-button")
                        .prop("disabled", true);
                };

                $scope.getCollectionContent = function () {
                    CollectionService.GetCollectionContentItem.get(
                        {
                            cid: $scope.asset.cid,
                            aid: $scope.asset.aid,
                            isActive: $scope.asset.isActive,
                        },
                        function (result) {
                            $scope.collectionContent = result.contents;
                            $scope.contentLoaded = true;
                            var res = result.contents.filter(
                                (x) => x.xid == $scope.quiz.assetId
                            );
                            if (res) {
                                $scope.contentItem = res;
                            }
                            $scope.collectionContentFetched = true;
                        }
                    );
                };

                $scope.handleBreadCrumbCurrentCollectionClick = function (cid) {
                    $scope.navigateToCollection({
                        type: "Collection",
                        xid: cid,
                    });
                };

                $scope.handleTakeQuizRewatchButtonClick = function (e) {
                    //console.log("handleSkipBackwardButtonClick");
                    var currentTime = playerCurrentTime();
                    //console.log("currentTime: ", currentTime);
                    var questions = $scope.quiz.questions;
                    var afterTime = "";
                    var q = $scope.quiz.questions.filter(
                        (x) =>
                            currentTime >
                                roundValue(hmsToSecondsOnly(x.time)) &&
                            x.answered
                    );
                    if (q.length > 0) {
                        playerCurrentTime(hmsToSecondsOnly(q.pop().time));
                        $scope.enableButton(null, null, {
                            PlayToggle: true,
                            SkipBackward: true,
                            SkipForward: true,
                        });
                        player.play();
                    } else {
                        playerCurrentTime(0);
                        $scope.enableButton(null, null, {
                            PlayToggle: true,
                            SkipBackward: true,
                            SkipForward: true,
                        });
                        player.play();
                    }
                    resetTakeQuizForm(e);
                    if (!$scope.quiz.settings.allowSkipping) {
                        $scope.enableButton(null, null, {
                            PlayToggle: true,
                            SkipBackward: true,
                            SkipForward: true,
                        });
                    }
                    player.play();
                };

                $scope.allUserQuestions = [];

                function every(array, callback) {
                    var result = true;

                    array.forEach(function (element, index, array) {
                        if (!callback(element, index, array)) {
                            result = false;
                            // Break out of the loop early
                            return false;
                        }
                    });

                    return result;
                }

                $scope.handleChangeAnswerButtonClick = function (e) {
                    var currentQuestion = $scope.quiz.questions.filter(
                        (x) =>
                            x.questionNumber == $scope.takeQuizSelectedQuestion
                    )[0];
                    if (currentQuestion.answers.length) {
                        $.each(currentQuestion.answers, function (k, answer) {
                            $("#answer-" + answer.id + " input").attr(
                                "aria-readonly",
                                false
                            );
                        });
                        var selectedAnswers = currentQuestion.answers.filter((x) => x.checked);
                        $scope.selectedAnswerIds = selectedAnswers.map((x) => x.id);
                    }
                    $scope.isChangingAnswer = true;
                    $scope.questionBeforeChange = currentQuestion;
                    $(".buttons-container .save-button").show();
                    $(".buttons-container .cancel-answer-button").show();
                    $(".buttons-container .next-question-button").hide();
                    $scope.isNextQuestion = false;
                    $(".buttons-container .change-answer-button").hide();
                    $(".buttons-container .keep-answer-button").hide();
                    $(".buttons-container .save-button span").text("Save Changes");
                    $(".buttons-container .save-button").prop("disabled", true);
                    $(".question-container .question-counter").focus();
                };

                $scope.handleCancelAnswerButtonClick = function (e) {
                    $scope.isChangingAnswer = false;
                    var currentQuestion = $scope.quiz.questions.filter(
                        (x) =>
                            x.questionNumber == $scope.takeQuizSelectedQuestion
                    )[0];
                    $timeout(function () {
                        currentQuestion = $scope.questionBeforeChange;
                        $scope.questionBeforeChange = undefined;
                        $scope.handleQuestionCounterClick(currentQuestion.questionNumber);
                    }, 650);
                };

                $scope.handleSkipAnywaysClick = function () {
                    $('.skip-button')
                        .parents('.buttons-container')
                        .siblings('.question-container')
                        .find(".answers-container")
                        .find("ul li .answer-option-input")
                        .each(function (index, item) {
                             $(item).prop("checked", false);  // Unselect each item
                        });
                    $scope.selectedAnswerIds = [];
                    $('.skip-button').click();
                };

                $scope.handleTakeQuizSaveAnswerButtonClick = function (
                    e,
                    skipped
                ) {
                    $scope.isChangingAnswer = false;
                    if (skipped) {
                        var selectedCount = 0;

                        $(e.target)
                            .parents('.buttons-container')
                            .siblings('.question-container')
                            .find(".answers-container")
                            .find("ul li .answer-option-input")
                            .each(function (index, item) {
                                if ($(item).prop("checked")) {
                                    selectedCount++;
                                }
                            });

                        if (selectedCount > 0) {
                            // show modal to confirm skip
                            $("#skipAnsweredQuestionModal").modal({
                                backdrop: "static",
                                keyboard: false,
                            });
                            return;
                        }
                    }

                    var now = Date.now();
                    var elapsedMilliseconds = now - $scope.startTime;
                    var elapsedSeconds = Math.floor(elapsedMilliseconds / 1000);

                    var question =
                        $scope.quiz.questions[
                            $scope.takeQuizSelectedQuestion - 1
                        ];

                    if (skipped) {
                        $scope.selectedAnswerIds = [null];
                        question.skipped = true;
                    }

                    var requestBody = {
                        quizId: $scope.quiz.id,
                        quizQuestionId: question.id,
                        responseAnswerIds: $scope.selectedAnswerIds,
                        skipped: skipped,
                        quizAttemptId: $scope.quizAttemptId,
                        secondsToAnswer: elapsedSeconds,
                    };

                    $scope.showSkip = false;

                    var currentQuestionUsersAnswers =
                        ($scope.currentQuestionUsersAnswers = {
                            questionIndex: $scope.takeQuizSelectedQuestion,
                            answer: $scope.selectedAnswerIds,
                        });

                    //disable all input radios and checkboxes
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(
                            ".answers-container ul li .answer .answer-option-input"
                        )
                        .each(function (index, item) {
                            $(item).attr("aria-readonly", true);
                        });

                    AssetService.SubmitQuestionResponse.send(
                        requestBody,
                        function (response) {
                            $scope.prevSelectedAnswerIds =
                                $scope.selectedAnswerIds;
                            $scope.selectedAnswerIds = [];
                            var answerIsCorrect = false;
                            let displayFeedbacks = [];
                            if (!skipped) {
                                $scope.selectedAnswerIds = [];

                                // show correct/incorrect check or X next to answer
                                answerIsCorrect = response.correctResponse;
                                for (
                                    var i = 0;
                                    i < requestBody.responseAnswerIds.length;
                                    i++
                                ) {
                                    var id = requestBody.responseAnswerIds[i];
                                    if (
                                        $scope.quiz.settings
                                            .showFeedbackAnswerSubmission && !$scope.hasWritePermissions
                                    ) {
                                        if (answerIsCorrect) {
                                            $(
                                                "#correct-answer-icon-" + id
                                            ).show();
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .feedback-title"
                                                )
                                                .text("Correct");
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(".feedback-container")
                                                .removeClass("incorrect");
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(".feedback-container")
                                                .addClass("correct");
                                        } else {
                                            $(
                                                "#incorrect-answer-icon-" + id
                                            ).show();
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .feedback-title"
                                                )
                                                .text("Incorrect");
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(".feedback-container")
                                                .removeClass("correct");
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(".feedback-container")
                                                .addClass("incorrect");
                                        }

                                        let answerFeedbackList =
                                            question.answers.find(
                                                (answer) => answer.id === id
                                            ).feedbacks;

                                        if (
                                            answerFeedbackList !== undefined &&
                                            answerFeedbackList.length > 0
                                        ) {
                                            displayFeedbacks.push(
                                                answerFeedbackList[0].feedback
                                            );
                                        }

                                        if (
                                            question.feedbacks !== undefined &&
                                            question.feedbacks.length > 0
                                        ) {
                                            let correctAnswerFeedback =
                                                question.feedbacks.find(
                                                    (feedback) =>
                                                        feedback.feedbackTypeId ===
                                                        2
                                                );
                                            let incorrectAnswerFeedback =
                                                question.feedbacks.find(
                                                    (feedback) =>
                                                        feedback.feedbackTypeId ===
                                                        1
                                                );
                                            if (
                                                answerIsCorrect &&
                                                correctAnswerFeedback !==
                                                    undefined
                                            ) {
                                                displayFeedbacks.push(
                                                    correctAnswerFeedback.feedback
                                                );
                                            } else if (
                                                !answerIsCorrect &&
                                                incorrectAnswerFeedback !==
                                                    undefined
                                            ) {
                                                displayFeedbacks.push(
                                                    incorrectAnswerFeedback.feedback
                                                );
                                            }

                                            let tipFeedback =
                                                question.feedbacks.find(
                                                    (feedback) =>
                                                        feedback.feedbackTypeId ===
                                                        3
                                                );
                                            if (tipFeedback !== undefined) {
                                                displayFeedbacks.push(
                                                    tipFeedback.feedback
                                                );
                                            }
                                        }

                                        if (displayFeedbacks.length === 1) {
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .first-feedback"
                                                )
                                                .text(displayFeedbacks[0]);
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .show-additional-feedback"
                                                )
                                                .hide();
                                        } else if (
                                            displayFeedbacks.length === 2
                                        ) {
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .first-feedback"
                                                )
                                                .text(displayFeedbacks[0]);
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container #additional-feedback"
                                                )
                                                .text(displayFeedbacks[1]);
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .show-additional-feedback"
                                                )
                                                .show();
                                        } else if (
                                            displayFeedbacks.length === 3
                                        ) {
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .first-feedback"
                                                )
                                                .text(displayFeedbacks[0]);
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container #additional-feedback"
                                                )
                                                .text(displayFeedbacks[1]);
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container #additional-feedback-two"
                                                )
                                                .text(displayFeedbacks[2]);
                                            $(e.target)
                                                .parents(
                                                    ".take-quiz-answer-question"
                                                )
                                                .find(
                                                    ".feedback-container .show-additional-feedback"
                                                )
                                                .show();
                                        }
                                    }
                                }

                                if (
                                    $scope.quiz.settings
                                        .showFeedbackAnswerSubmission &&
                                    displayFeedbacks.length > 0
                                ) {
                                    $(e.target)
                                        .parents(".take-quiz-answer-question")
                                        .find(".feedback-container")
                                        .show();
                                }

                                $scope.recentlyAnsweredQuestion = question.id;
                                //Hide the Save button
                                $(e.target).parents(".take-quiz-answer-question").find(".save-button").hide();
                                $(".clear-selection-button").attr(
                                    "disabled",
                                    true
                                );
                                $scope.setUserQuestionResponsePanel(e, skipped);
                                $(e.target).parents(".take-quiz-answer-question").find(".next-question-button").focus();
                            } else {
                                $scope.setUserQuestionResponsePanel(e, skipped);
                                $scope.handleTakeQuizNextQuestionButtonClick();
                            }
                            $scope.loadMarkers(false);

                            if ($scope.isInReview) {
                                $timeout(function () {
                                    $scope.handleNextQuestionReview();
                                }, 750);
                            }

                        }
                    );
                };

                $scope.showSettingsConfirmModal = function (switchId) {
                    $("#btnSettingsConfirm").addClass("defaultPrimaryButton");
                    $("#btnSettingsConfirm").removeClass("warningPrimaryButton");
                    $scope.afterModelFocus = switchId;
                    $scope.safeApply(function () {
                        $scope.isImpactingChange = false;
                        if (switchId === "numSubmissions") {
                            $scope.quiz.settings.showFeedbackAnswerSubmission = false;
                            $scope.quiz.settings.showResultsQuizSubmission = false;
                            $scope.isImpactingChange = true;
                            $("#btnSettingsConfirm").addClass("warningPrimaryButton");
                            $("#btnSettingsConfirm").removeClass("defaultPrimaryButton");
                            $("#showFeedback").attr("aria-readonly", true);
                            $("#showResults").attr("aria-readonly", true);

                            $scope.settingsConfirmModalTitle =
                                "Changing Value Will Impact Use Of Other Settings";

                            $scope.settingsConfirmModalBody = $sce.trustAsHtml(
                                'If the value of the "Quiz Submissions" setting is changed to a value that is greater than one, ShareStream will disable the following settings, as showing students their results for their initial submission would assist them in choosing answers for subsequent submissions: ' +
                                    '<ul style="padding-left: 5%; padding-top: 5%;">' +
                                    '<li style="list-style: disc;">Show feedback after each answer choice</li>' +
                                    '<li style="list-style: disc;">Show details for quiz results</li>' +
                                    "</ul>"
                            );

                            $scope.settingsConfirmModalButtonText =
                                "Change Value for Setting";
                        } else if (switchId === "allowChanges") {
                            var disableImpact = "Disable";
                            $scope.quiz.settings.showFeedbackAnswerSubmission = false;
                            disableImpact = "Impact";
                            $scope.isImpactingChange = true;
                            $("#btnSettingsConfirm").addClass("warningPrimaryButton");
                            $("#btnSettingsConfirm").removeClass("defaultPrimaryButton");
                            $("#showFeedback").attr("aria-readonly", true);
                            $scope.settingsConfirmModalTitle =
                                "Turning Setting On Will " +
                                disableImpact +
                                " Another Setting";

                            $scope.settingsConfirmModalBody = $sce.trustAsHtml(
                                'If the "Allow Changes to answers" setting is turned on, ShareStream will turn the "Show feedback after each answer choice" setting off and disable the setting, as displaying feedback for each answer choices would assist students in changing their answers.'
                            );

                            $scope.settingsConfirmModalButtonText =
                                "Turn Setting On";
                        } else if (switchId === "allowSkipping") {
                            var disableImpact = "Disable";
                            $scope.quiz.settings.showFeedbackAnswerSubmission = false;
                            disableImpact = "Impact";
                            $scope.isImpactingChange = true;
                            $("#btnSettingsConfirm").addClass("warningPrimaryButton");
                            $("#btnSettingsConfirm").removeClass("defaultPrimaryButton");
                            $("#showFeedback").attr("aria-readonly", true);
                            $scope.settingsConfirmModalTitle =
                                "Turning Setting On Will " +
                                disableImpact +
                                " Another Setting";

                            $scope.settingsConfirmModalBody = $sce.trustAsHtml(
                                'If the "Allow Skipping" setting is turned on, ShareStream will disable the "Show feedback after each answer choice" setting, as feedback for answer choices could assist students in answering skipped questions.'
                            );

                            $scope.settingsConfirmModalButtonText =
                                "Turn Setting On";
                        } else if (switchId === "showFeedback") {
                            var disableImpact = "Disable";
                            $("#allowSkipping").attr("aria-readonly", true);
                            $("#allowChanges").attr("aria-readonly", true);
                            $("#quizSubmissions").attr("aria-readonly", true);
                            $scope.settingsConfirmModalTitle =
                                "Turning Setting On Will " +
                                disableImpact +
                                " Another Setting";

                            $scope.settingsConfirmModalBody = $sce.trustAsHtml(
                                'If the "Show feedback after each answer choice" setting is turned on, then, in order maintain the integrity of the quiz and preserve the significance of quiz results, ShareStream will disable the following settings: "Allow skipping", "Allow changes to answers", and "Quiz Submissions".'
                            );

                            $scope.settingsConfirmModalButtonText =
                                "Turn Setting On";
                        } else if (switchId === "showResults") {
                            var disableImpact = "Disable";
                            $("#quizSubmissions").attr("aria-readonly", true);
                            $scope.settingsConfirmModalTitle =
                                "Turning Setting On Will " +
                                disableImpact +
                                " Another Setting";

                            $scope.settingsConfirmModalBody = $sce.trustAsHtml(
                                'If the "Show details for quiz results" setting is turned on, then, in order maintain the integrity of the quiz and preserve the significance of quiz results, ShareStream will disable the "Quiz Submissions" setting.'
                            );

                            $scope.settingsConfirmModalButtonText =
                                "Turn Setting On";
                        }
                    });

                    $("#settingsConfirmModal").modal({
                        backdrop: "static",
                        keyboard: false,
                    });
                    setTimeout(() => {
                        $("#settingsConfirmModal .xmark").focus();
                    }, 500);
                };

                $scope.handleSettingsConfirmModalCancel = function (type) {
                    // revert quiz settings
                    $("#settingsConfirmModal").modal("hide");
                    $scope.getQuizMetadata();
                };

                $scope.handleSettingsConfirmModalCloseKeydown = function(e) {
                    console.log("handleSettingsConfirmModalKeydown(): ", e.which);
                    if(e.which === 27){
                        $scope.getQuizMetadata();
                    }else if(e.which === 32 || e.which === 13){
                        $(e.target).click();
                    }
                };
                $scope.handleSettingsConfirmModalKeydown = function(e) {
                    console.log("handleSettingsConfirmModalKeydown(): ", e.which);
                    if(e.which===27){
                        $scope.getQuizMetadata();
                    }
                };

                $scope.showSubmitQuiz = function (e) {
                    $scope.allQuestionsAnswered = every(
                        $scope.quiz.questions,
                        function (question) {
                            return question.answered === true && question.skipped !== true;
                        }
                    );

                    $scope.safeApply(function () {
                        $scope.submitQuizModalTitle = "Submit Quiz?";

                        if (!$scope.allQuestionsAnswered) {
                            $scope.submitQuizModalTitle =
                                "Submit Quiz Without Answering All Questions?";
                        }

                        $scope.submitQuizModalBody =
                            'If you click "Confirm Quiz Submission", your answers to the questions in the quiz will be submitted to your Instructor and you will not be able to change your answers.';
                        if (!$scope.allQuestionsAnswered) {
                            $scope.submitQuizModalBody =
                                'If you click "Confirm Quiz Submission", the questions that you have answered will be submitted to your Instructor and you will not be able to answer the questions that you have skipped.';
                        }

                        $scope.submitQuizButtonText = "Confirm Quiz Submission";
                    });

                    // todo: should this be a timeout or some other trigger
                    setTimeout(() => {
                        $(".take-quiz-metadata-container").hide();
                        $(".take-quiz-answer-question").hide();
                        $(".submit-quiz").show();
                        $scope.takeQuizSelectedQuestion = -1;
                        $scope.loadMarkers(false);
                    }, 500);
                };

                $scope.setUserQuestionResponsePanel = function (e, skipped) {
                    var question =
                        $scope.quiz.questions[
                            $scope.takeQuizSelectedQuestion - 1
                        ];

                    question.answers.forEach(a => a.checked = $scope.prevSelectedAnswerIds.includes(a.id));

                    if (skipped) {
                        //mark current question as skipped
                        question.answered = false;
                        question.skipped = true;
                        $.each(question.answers, function (k, v) {
                            v.checked = false;
                        });
                    } else {
                        //mark current question as completed
                        question.answered = true;
                        question.skipped = false;
                    }

                    //This object will be used in the side panel
                    $scope.allUserQuestions = $scope.quiz.questions.filter(
                        (x) => x.answered || x.skipped
                    );

                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".save-button span")
                        .text("Save");

                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".next-question-button")
                        .show();
                    $scope.isNextQuestion = true;
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".clear-selection-button")
                        .hide();
                    $(e.target)
                        .parents(".take-quiz-answer-question")
                        .find(".cancel-answer-button")
                        .hide();

                    if ($scope.quiz.settings.allowChanges) {
                        $(e.target)
                            .parents(".take-quiz-answer-question")
                            .find(".change-answer-button")
                            .show();
                    }

                    $scope.enableButton("PlayToggle", true, null);
                    if ($scope.recentlyAnsweredQuestion) {
                        $timeout(function () {
                            $(
                                "#questionCard-" +
                                    $scope.recentlyAnsweredQuestion
                            ).css("background", "#EEFFF7");
                            $timeout(function () {
                                $(
                                    "#questionCard-" +
                                        $scope.recentlyAnsweredQuestion
                                ).css("background", "#fff");
                                $scope.recentlyAnsweredQuestion = null;
                            }, 10000);
                        }, 250);
                    }
                };

                $scope.handleSettingsConfirmModalSave = function (e) {
                    $scope.updateQuizSettings();
                };

                $scope.handleSubmitQuiz = function () {
                    AssetService.EndQuizAttempt.send(
                        {
                            quizAttemptId: $scope.quizAttemptId,
                            token: localStorage.getItem("launchToken"),
                            state: localStorage.getItem("launchState"),
                            preview: $scope.isPreview,
                        },
                        function (response) {
                            $timeout(function () {
                                $state.go("quiz-submission", {
                                    collectionId: $scope.quiz.collectionId,
                                    assetId: $scope.quiz.assetId,
                                    quizId: $scope.quiz.id,
                                    isPreview: $scope.isPreview && $scope.isInstructor,
                                });
                                $scope.quizInProgress = false;
                            }, 500);
                        }
                    );
                };

                $scope.handleReviewAnswers = function (e) {
                    $scope.isInReview = true;
                    $scope.handleQuestionCounterClick(1);
                };

                $scope.handleSkiptoEnd = function (e) {
                    $scope.isInReview = false;
                    $(".submit-quiz").show();
                    $(".take-quiz-answer-question").hide();
                };

                $scope.handleNextQuestionReview = function () {
                    // if it is the last question, advance to the next question. Otherwise,
                    // show the submit screen if on last question
                    var question = $scope.quiz.questions.filter(
                        (x) =>
                            x.questionNumber ==
                            $scope.takeQuizSelectedQuestion + 1
                    )[0];
                    if (question) {
                        $scope.handleQuestionCounterClick(
                            $scope.takeQuizSelectedQuestion + 1
                        );
                    } else {
                        $(".take-quiz-answer-question").hide();
                        $(".submit-quiz").show();
                    }
                };

                $scope.handleAnswerSkippedQuestions = function (e) {
                    $(".submit-quiz").hide();
                    $(".take-quiz-metadata-container").show();
                    var skippedQuestions = $scope.quiz.questions
                        .filter((x) => x.skipped)
                        .sort((a, b) => a.questionNumber - b.questionNumber);

                    if (!skippedQuestions.length) {
                        return;
                    }

                    var firstSkippedQuestion = skippedQuestions[0];
                    var startTime = 0;

                    if (firstSkippedQuestion.questionNumber > 1) {
                        var previousQuestion = $scope.quiz.questions.find(
                            (q) =>
                                q.questionNumber ===
                                firstSkippedQuestion.questionNumber - 1
                        );
                        if (previousQuestion && previousQuestion.time != null) {
                            startTime = hmsToSecondsOnly(previousQuestion.time);
                        }
                    }

                    $scope.nextStop = firstSkippedQuestion;
                    player.currentTime(startTime);
                    player.play();
                };

                $scope.handleShowAdditionalFeedbackClick = function (e) {
                    var transformValue = $(e.currentTarget)
                        .find(".chevron-down")
                        .css("transform");

                    if (transformValue.indexOf("matrix") === -1) {
                        $(e.currentTarget)
                            .find(".chevron-down")
                            .css("transform", "rotate(180deg)");
                        $(e.target)
                            .parents(".take-quiz-answer-question")
                            .find(
                                ".answers-container .show-additional-feedback span"
                            )
                            .text("Hide additional feedback");
                    } else {
                        $(e.currentTarget)
                            .find(".chevron-down")
                            .css("transform", "");
                        $(e.target)
                            .parents(".take-quiz-answer-question")
                            .find(
                                ".answers-container .show-additional-feedback span"
                            )
                            .text("Show additional feedback");
                    }

                    $(e.currentTarget)
                        .parents(".feedback-container")
                        .find("#additional-feedback")
                        .toggle();
                    $(e.currentTarget)
                        .parents(".feedback-container")
                        .find("#additional-feedback-two")
                        .toggle();
                    $(e.currentTarget)
                        .parents(".feedback-container")
                        .find(".divider")
                        .toggle();
                };

                $scope.handleTakeQuizNextQuestionButtonClick = function () {
                    $(".take-quiz-metadata-container").show();
                    $(".take-quiz-answer-question").hide();
                    $scope.enableButton(null, null, {
                        PlayToggle: true,
                        SkipBackward: true,
                        SkipForward: true,
                    });
                    var question = $scope.quiz.questions.filter(
                        (x) =>
                            x.questionNumber == $scope.takeQuizSelectedQuestion
                    )[0];
                    $scope.takeQuizSelectedQuestion = -1;
                    $scope.loadMarkers(false);
                    playerCurrentTime(hmsToSecondsOnly(question.time));
                    player.play();
                    $timeout(function () {
                        $("#marker-" + question.questionNumber + " button").focus();
                    }, 50);
                };

                $scope.handleContinueButtonClick = function () {
                    $scope.isPreEdit = false;
                    $scope.enableButton(null, null, {
                        ProgressControl: true,
                        PlayToggle: true,
                        SkipBackward: true,
                        SkipForward: true,
                        AddQuestion: true,
                    });
                    $(".pre-edit-question").hide();
                    $(".quiz-metadata-container").show();
                    var question = $scope.quiz.questions.filter(
                        (x) => x.questionNumber == $scope.selectedQuestionNumber
                    )[0];
                    $scope.selectedQuestionNumber = -1;
                    $scope.selectedQuestionId = -1;
                    $scope.editQuestion = null;
                    $scope.currentQuestionAnswerFeedbackList = [];
                    $scope.currentQuestionFeedbackList = [];
                    $scope.loadMarkers(false);
                    playerCurrentTime(hmsToSecondsOnly(question.time));
                    player.play();
                    $timeout(function () {
                        $("#marker-" + question.questionNumber + " button").focus();
                    }, 50);
                };

                function hmsToSecondsOnly(str) {
                    if (typeof str === "string") {
                        var p = str.split(":"),
                            s = 0,
                            m = 1;
                        while (p.length > 0) {
                            (s += m * p.pop()), 10;
                            m *= 60;
                        }
                        return s;
                    } else {
                        return str;
                    }
                }

                $scope.initializeVideo = function (playerId, width, height, media) {
                    console.log("initializeVideo(" + playerId + ")");
                    if (playerId) {
                        //Dispose of any player with the same Id
                        var allPlayers = videojs.getPlayers();
                        for (var tempPlayerId in allPlayers) {
                            var playerTemp = allPlayers[tempPlayerId];
                            if (playerTemp && playerId === tempPlayerId) {
                                playerTemp.dispose();
                            }
                        }
                        var videoOptions = {
                            crossOrigin: 'anonymous',
                            controls: true,
                            autoplay: false,
                            fluid: true,
                            aspectRatio: '16:9',
                            preload: "auto",
                            playbackRates: [2, 1.5, 1, 0.5, 0.25],
                            inactivityTimeout: 0,
                            width: "auto",
                            noUITitleAttributes: true,
                            controlBar: {
                                skipButtons: {
                                    forward: 10,
                                    backward: 10
                                }
                            },
                            poster: $scope.asset.thumbnailUrl,
                            textTrackSettings: false,
                            playsinline: true,
                            html5: {
                                nativeTextTracks: false
                            }
                        };
                        //for iOS use nativeTextTracks and nativeTextTracks styling
                        if(videojs.browser.IS_IOS){
                            videoOptions.html5.nativeTextTracks = true;
                            $(".video-js-custom.video-js").addClass("vjs-is-ios");
                        }
                        //initialize player
                        player = videojs(playerId, videoOptions);

                        if (!$scope.hasWritePermissions) {
                            $scope.enableButton("All", false, null);
                            $scope.enableButton(null, null, {
                                CurrentTimeDisplay: true,
                                TimeDivider: true,
                                DurationDisplay: true,
                            });
                        }

                        player.src({
                            type: "application/x-mpegURL",
                            src: $scope.hlsUrl,
                        });

                        /*
                        player.spriteThumbnails({
                            url: $scope.asset.thumbnailUrl,
                            width: 100,
                            height: 56,
                            columns: 2
                        });
                        */

                        //insert markers
                        player.on("loadedmetadata", function () {
                            $scope.metadataloaded = true;
                            $scope.updateAudioTrackIcon();
                            $scope.loadMarkers(false);
                            player.trigger('playerresize');
                        });

                        player.on("play", function () {
                            //console.log("isPreEdit: ",$scope.isPreEdit);
                            //console.log("takeQuizSelectedQuestion: ",$scope.takeQuizSelectedQuestion);
                            if ($scope.isPreEdit) {
                                $scope.handleContinueButtonClick();
                            }
                            if (
                                !$scope.hasWritePermissions &&
                                $scope.takeQuizSelectedQuestion !== -1 &&
                                $scope.isNextQuestion === true
                            ) {
                                $scope.handleTakeQuizNextQuestionButtonClick();
                            }
                        });

                        player.controlBar.skipBackward.handleClick =
                            function () {
                                if (!$scope.hasWritePermissions) {
                                    //console.log("handleSkipBackwardButtonClick");
                                    var currentTime = playerCurrentTime() - 10;
                                    //console.log("currentTime: ", currentTime);
                                    var questions = $scope.quiz.questions;
                                    var afterTime = "";
                                    var q = $scope.quiz.questions.filter(
                                        (x) =>
                                            currentTime <=
                                                hmsToSecondsOnly(x.time) &&
                                            playerCurrentTime() >=
                                                roundValue(
                                                    hmsToSecondsOnly(x.time)
                                                ) &&
                                            x.answered
                                    );
                                    if (q.length > 0) {
                                        playerCurrentTime(
                                            hmsToSecondsOnly(q.pop().time)
                                        );
                                        $scope.enableButton(null, null, {
                                            PlayToggle: true,
                                            SkipBackward: true,
                                            SkipForward: true,
                                        });
                                        player.play();
                                    } else {
                                        playerCurrentTime(currentTime);
                                        $scope.enableButton(null, null, {
                                            PlayToggle: true,
                                            SkipBackward: true,
                                            SkipForward: true,
                                        });
                                        player.play();
                                    }
                                } else {
                                    playerCurrentTime(playerCurrentTime() - 10);
                                }
                            };

                        player.controlBar.skipForward.handleClick =
                            function () {
                                playerCurrentTime(playerCurrentTime() + 10);
                            };

                        player.on("ended", function () {
                            $(".take-quiz-answer-question").css("display");
                            if (!$scope.hasWritePermissions) {
                                $(".vjs-student").addClass("vjs-ended");
                            }
                        });

                        player.on("timeupdate", function (e) {
                            if ($scope.hasWritePermissions) {
                                $(".time").val(
                                    moment
                                        .utc(playerCurrentTime() * 1000)
                                        .format("HH:mm:ss")
                                );
                                var drafts = $scope.quiz.questions.filter(
                                    (x) => x.isDraft
                                );
                                if (drafts.length) {
                                    var draft = drafts[0];
                                    draft.time = $(".time").val();
                                    $(".question-title").blur();
                                    $scope.loadMarkers(true);
                                }
                            } else {
                                if (
                                    $scope.nextStop &&
                                    playerCurrentTime() > $scope.nextStop.time
                                ) {
                                    //console.log("timeupdate nextStop: "+playerCurrentTime()+" "+$scope.nextStop.time);
                                    player.pause();
                                    playerCurrentTime($scope.nextStop.time);
                                    $scope.enableButton("All", true, null);
                                    $scope.enableButton(null, null, {
                                        PlayToggle:
                                            $scope.answeredQuestions.filter(
                                                (x) =>
                                                    x.questionNumber ===
                                                    $scope.nextStop
                                                        .questionNumber
                                            ).length,
                                        SkipForward: false,
                                    });
                                    $(
                                        "#marker-" +
                                            $scope.nextStop.questionNumber
                                    )
                                        .children("button")
                                        .click();
                                } else if (
                                    !$(".video-js-custom.video-js").hasClass("vjs-preview") &&
                                    ($scope.nextStop == null || ($scope.nextStop && playerCurrentTime() < $scope.nextStop.time))
                                ) {
                                    $scope.enableButton("PlayToggle", true, null);
                                }
                                if (
                                    playerCurrentTime() >=
                                        roundValue($scope.lastMarker.time) &&
                                    player.duration() - playerCurrentTime() < 10
                                ) {
                                    //console.log("timeupdate  showSubmitQuiz: "+ roundValue($scope.lastMarker.time) +" " + player.duration() + " " + player.currentTime() + " " + $scope.takeQuizSelectedQuestion );
                                    if (
                                        $scope.takeQuizSelectedQuestion ===
                                            -1 &&
                                        $(".submit-quiz").css("display") ===
                                            "none"
                                    ) {
                                        $scope.showSubmitQuiz();
                                        //console.log("$scope.showSubmitQuiz()");
                                    }
                                }
                            }
                        });
                        player.on("seeking", function () {
                            if (!$scope.hasWritePermissions) {
                                if (
                                    $scope.finalStop &&
                                    playerCurrentTime() > $scope.finalStop.time
                                ) {
                                    //console.log("seeking: "+playerCurrentTime()+" "+$scope.finalStop.time);
                                    player.pause();
                                    playerCurrentTime($scope.finalStop.time);
                                    $(".video-js-custom.video-js").addClass(
                                        "vjs-stopped"
                                    );
                                    $scope.enableButton("PlayToggle", false, null);
                                } else if (
                                    $scope.finalStop == null ||
                                    ($scope.finalStop &&
                                        playerCurrentTime() <
                                            $scope.finalStop.time)
                                ) {
                                    $(".video-js-custom.video-js").removeClass(
                                        "vjs-stopped"
                                    );
                                    //console.log("seeking setNextStop: "+playerCurrentTime());
                                    $scope.setNextStop();
                                }
                            }
                        });

                        player.on("seeked", function () {
                            //console.log('seeked: '+ playerCurrentTime());
                            if ($scope.seekedloadMarkers) {
                                $scope.seekedloadMarkers = false;
                                $scope.loadMarkers(false);
                            }
                            if ($scope.hasWritePermissions) {
                                $(".video-js-custom.video-js").addClass(
                                    "vjs-seeked"
                                );

                                if (
                                    $scope.editQuestion != null &&
                                    !$scope.isFirstSeek
                                ) {
                                    $scope.isFirstSeek = false;
                                    $(".save-question").attr("disabled", false);
                                }

                                if ($scope.isFirstSeek) {
                                    $scope.isFirstSeek = false;
                                }
                            }
                            // Add your logic here to execute after seeking is complete
                        });
                        player.on("ratechange", function () {
                            var rate = player
                                .playbackRate()
                                .toString()
                                .replace(".", "_");
                            //console.log("rate: "+rate);
                            $(
                                ".video-js-custom.video-js .vjs-playback-rate button"
                            )
                                .removeClass(
                                    "vjs-rate-2 vjs-rate-1_5 vjs-rate-1 vjs-rate-0_5 vjs-rate-0_25"
                                )
                                .addClass("vjs-rate-" + rate);
                        });

                        player.audioTracks().addEventListener('addtrack', function(event) {
                            $timeout(function(){
                                $scope.updateAudioTrackIcon();
                            },0);
                        });
                        player.audioTracks().on("change", function (event) {
                            $scope.updateAudioTrackIcon();
                        });

                        player.on('durationchange', function() {
                            if(player.duration()>0){
                                $(".video-js-custom.video-js").addClass("vjs-times-loaded");
                            }
                        });

                        player.ready(function () {
                            console.log("Player is Ready!");
                            //console.log("IS_IOS: "+videojs.browser.IS_IOS);
                            //console.log("IS_SAFARI: "+videojs.browser.IS_SAFARI);
                            //console.log("isInFrame: "+videojs.dom.isInFrame());

                            //Disable Picture in Picture
                            $(".video-js-custom.video-js video").attr(
                                "disablepictureinpicture",
                                ""
                            );

                            // initialize captions
                            $.each(JSON.parse($scope.media.captions), function (i, k) {
                                var trackKind = "";
                                if (k.title.includes("(Audio Description)")) {
                                    k.title = k.title.replace("(Audio Description)", "[AD]");
                                    trackKind = 'descriptions';
                                    $scope.audioTextDescriptionsIncluded = true;
                                } else if (k.language === $scope.srcLang) {
                                    k.title += " [CC]";
                                    trackKind = 'captions';
                                    $scope.captionsIncluded = true;
                                } else if (k.language !== $scope.srcLang) {
                                    trackKind = 'subtitles';
                                    $scope.subtitlesIncluded = true;
                                }
                                var langCode = $scope.getLangCode(k.language);
                                k.captionUrl = $scope.media.captionUrl + '&id=' + k.id;
                                if (k.fileName && k.fileName.includes(".srt")) {
                                    // convert srt to vtt
                                    $.ajax({
                                        url: k.captionUrl,
                                        type: 'GET',
                                        dataType: 'text',
                                        async: false,
                                        success: function (data) {
                                            const vttText = $scope.convertSRTtoVTT(data);
                                            const vttBlob = new Blob([vttText], {type: 'text/vtt'});
                                            const vttUrl = URL.createObjectURL(vttBlob);

                                            player.addRemoteTextTrack({
                                                kind: trackKind,
                                                src: vttUrl,
                                                srclang: langCode,
                                                label: k.title,
                                                mode: 'disabled'
                                            }, false);
                                        },
                                        error: function (xhr, status, error) {
                                            console.error('Failed to load subtitles:', error);
                                        }
                                    });
                                } else {
                                    // add vtt directly
                                    player.addRemoteTextTrack({
                                        kind: trackKind,
                                        src: k.captionUrl,
                                        srclang: langCode,
                                        label: k.title,
                                        mode: 'disabled'
                                    }, false);
                                }
                            });

                            //Text track listener
                            var textTrackList = player.textTracks();

                            textTrackList.addEventListener('change', function() {
                                var isShowing = false;
                                for (var i = 0; i < textTrackList.length; i++) {
                                    var track = textTrackList[i];
                                    if (track.mode === 'showing') {
                                        isShowing = true;
                                        break;
                                    }
                                }
                                if(isShowing){
                                    $(".video-js-custom.video-js").addClass("vjs-showing-subs-caps");
                                }else{
                                    $(".video-js-custom.video-js").removeClass("vjs-showing-subs-caps");
                                }
                                if($scope.captionsIncluded && !$scope.subtitlesIncluded && !$scope.audioDescriptionsIncluded){
                                    $(".video-js-custom.video-js").addClass("vjs-subs-caps-alt");
                                    if(isShowing){
                                        $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-tooltip").html("Turn off captions");
                                        $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-control-text").html("Turn off captions");
                                    }else{
                                        $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-tooltip").html("Turn on captions");
                                        $(".video-js-custom.video-js .vjs-subs-caps-button-toggle .vjs-control-text").html("Turn on captions");
                                    }
                                }else{
                                    $(".video-js-custom.video-js").removeClass("vjs-subs-caps-alt");
                                }
                            });

                            //Insert Rewatch Button to videojs control-bar
                            var rewatchButton =
                                '<div class="vjs-rewatch "> ' +
                                '   <button ' +
                                '       class="rewatch-button" ' +
                                '       ng-click="handleTakeQuizRewatchButtonClick($event)" ' +
                                '       type="button"' +
                                '   ><span>Rewatch</span></button> ' +
                                '</div> ';
                            var rewatchButtonElement =
                                angular.element(rewatchButton);
                            $compile(rewatchButtonElement)($scope);
                            $(
                                ".video-js-custom.video-js .vjs-control-bar"
                            ).append(rewatchButtonElement);
                            if (!$scope.hasWritePermissions) {
                                $(".vjs-rewatch .rewatch-button").attr(
                                    "disabled",
                                    "true"
                                );
                            }

                            //Insert Add Question Button to videojs control-bar
                            if ($scope.hasWritePermissions && !$scope.isPreview) {
                                $(".video-js-custom.video-js").addClass(
                                    "vjs-instructor"
                                );
                                var questionButton =
                                    '<div class="vjs-add-question"> ' +
                                    '   <button id="quizzingAddQuestionButton" class="add-question-button" ng-click="handleAddQuestionButtonClick($event)" ng-keydown="handleAddQuestionMenuKeydown($event)" ng-disabled="quiz.id == 0" ' +
                                    '       aria-haspopup="menu" aria-expanded="false" aria-controls="quizzingAddQuestionMenu" type="button" style="display: none;"> ' +
                                    '       <span> ' +
                                    '           <img src="assets/images/plus-large.svg" style="width: 16px;height: 16px;" alt="">Add Question<img class="carot" src="assets/images/caret-down-white.svg" style="width: 16px;height: 16px;" alt=""> ' +
                                    '       </span> ' +
                                    '   </button> ' +
                                    '   <div id="quizzingAddQuestionMenu" aria-labelledby="quizzingAddQuestionButton" class="add-question-menu" style="z-index: 99;"> ' +
                                    '       <ul> ' +
                                    '           <li tabindex="0" ng-click="handleAddMultipleChoiceClick(true)" ng-keydown="handleAddQuestionMenuKeydown($event)" > ' +
                                    '               <div class="list-radio"></div> ' +
                                    '               <span>Multiple Choice</span> ' +
                                    '           </li> ' +
                                    '           <li tabindex="0" ng-click="handleAddTrueFalseClick(true)" ng-keydown="handleAddQuestionMenuKeydown($event)" > ' +
                                    '               <div class="circle-half-stroke"></div> ' +
                                    '               <span>True/False</span> ' +
                                    '           </li> ' +
                                    '           <li tabindex="0" ng-click="handleAddMultiSelectClick(true)" ng-keydown="handleAddQuestionMenuKeydown($event)" > ' +
                                    '               <div class="square-check"></div> ' +
                                    '               <span>Multiselect</span> ' +
                                    '           </li> ' +
                                    /*                                '           <li tabindex="0" ng-click="handleAddNumericClick(true)" ng-keydown="handleAddQuestionMenuKeydown($event)" > ' +
                                '               <div class="hashtag"></div> ' +
                                '               <span>Numeric</span> ' +
                                '           </li> ' +*/
                                    "       </ul> " +
                                    "   </div> " +
                                    "</div> ";

                                var questionButtonElement =
                                    angular.element(questionButton);
                                $compile(questionButtonElement)($scope);

                                $(
                                    ".video-js-custom.video-js .vjs-control-bar"
                                ).append(questionButtonElement);

                                // Hide rewatch button
                                $(".vjs-rewatch").hide();
                            } else {
                                $(".video-js-custom.video-js").addClass(
                                    "vjs-student"
                                );
                            }

                            //Add Div for Line
                            $('<div class="vjs-line"></div>').insertAfter(
                                ".vjs-skip-forward-10.vjs-control.vjs-button"
                            );

                            //Add Div for Markers
                            $(
                                ".video-js-custom.video-js .vjs-control-bar"
                            ).prepend('<div class="vjs-marker-control"></div>');

                            //Add Progress Mask and Bar
                            $(
                                '.video-js-custom.video-js .vjs-progress-control.vjs-control'
                            ).append('<div class="vjs-progress-mask"><div class="vjs-play-progress-bar"></div></div>');

                            //Add Progress Elypse
                            $(
                                ".video-js-custom.video-js .vjs-play-progress.vjs-slider-bar"
                            ).append("<div class='vjs-progress-point'></div>");

                            //Add mute tooltip and polygon
                            $(
                                ".video-js-custom.video-js .vjs-mute-control"
                            ).append(
                                '<div class="vjs-tooltip" aria-hidden="true"></div><div class="vjs-polygon" aria-hidden="true" ></div>'
                            );
                            $(".video-js-custom.video-js .vjs-mute-control")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }
                            });

                            //Add volume bar background
                            $(".video-js-custom.video-js .vjs-volume-control").prepend('<div class="vjs-vol-bar-start"></div>');
                            $(".video-js-custom.video-js .vjs-volume-control").append('<div class="vjs-vol-bar-end"></div>');

                            //Add volume control tooltip and polygon
                            $('.video-js-custom.video-js .vjs-volume-control').append('<div class="vjs-tooltip" aria-hidden="true">Volume</div><div class="vjs-polygon" aria-hidden="true" ></div>');
                            $(".video-js-custom.video-js .vjs-volume-control")
                              .on("mouseenter", function (event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave", function (event) {
                                $scope.hideTooltip(event);
                            }).keydown(function (event) {
                                if (27 === event.which) {
                                    $(".vjs-marker button").attr("aria-expanded", "false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }
                            });

                            $(".video-js-custom.video-js .vjs-volume-control .vjs-volume-bar")
                              .on("focus", function (event) {
                                $scope.showTooltip(event);
                            }).on("blur", function (event) {
                                $scope.hideTooltip(event);
                            });

                            //Add play control polygon
                            $(
                                ".video-js-custom.video-js .vjs-play-control"
                            ).append(
                                '<div class="vjs-tooltip" aria-hidden="true"></div><div class="vjs-polygon" aria-hidden="true"></div>'
                            );

                            $(".video-js-custom.video-js .vjs-play-control")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }
                            });

                            //Add playback rate tooltip and polygon
                            $(
                                ".video-js-custom.video-js .vjs-playback-rate button"
                            ).append(
                                '<div class="vjs-tooltip" aria-hidden="true">Change playback speed</div><div class="vjs-polygon" aria-hidden="true"></div>'
                            );

                            $(".video-js-custom.video-js .vjs-playback-rate button")
                              .attr("aria-haspopup","menu")
                              .attr("id","vjs-playback-rate-button-id")
                              .attr("aria-controls","vjs-playback-rate-menu-id")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }else if(38===event.which || 40===event.which){
                                    //event.preventDefault();
                                    //event.stopPropagation();
                                    $(event.target).click();
                                    var keydownMenuIndex = $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu .vjs-selected").index();
                                    if(keydownMenuIndex>=0){
                                        player.controlBar.playbackRateMenuButton.menu.focus(keydownMenuIndex);
                                    }else{
                                        var menu = player.controlBar.playbackRateMenuButton.menu;
                                        if(38===event.which ){
                                            menu.focus(menu.children().length-1);
                                        }else{
                                            menu.focus(0);
                                        }
                                    }
                                }
                            }).on("pointerup",function(event) {
                                $timeout(function(){
                                    if($(".video-js-custom.video-js .vjs-playback-rate .vjs-menu.vjs-lock-showing").length){
                                        var menuIndex = $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu .vjs-selected").index();
                                        if(menuIndex<0){menuIndex = 0;}
                                        player.controlBar.playbackRateMenuButton.menu.focus(menuIndex);
                                    }else{
                                        $(".video-js-custom.video-js .vjs-playback-rate button").focus();
                                    }
                                });
                            }).on("pointerdown",function(event){
                                event.preventDefault();
                                event.stopPropagation();
                            });
                            $(".video-js-custom.video-js .vjs-playback-rate .vjs-menu")
                              .attr("id","vjs-playback-rate-menu-id")
                              .attr("aria-labelledby","vjs-playback-rate-button-id");

                            //add closed captions tooltip and polygon
                            $(
                                ".video-js-custom.video-js .vjs-subs-caps-button button"
                            ).append(
                                '<div class="vjs-tooltip" aria-hidden="true">Captions and subtitles</div><div class="vjs-polygon" aria-hidden="true"></div>'
                            );

                            $(".video-js-custom.video-js .vjs-subs-caps-button button")
                              .attr("aria-haspopup","menu")
                              .attr("id","vjs-subs-caps-button-id")
                              .attr("aria-controls","vjs-subs-caps-menu-id")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }else if(38===event.which || 40===event.which){
                                    //event.preventDefault();
                                    //event.stopPropagation();
                                    $(event.target).click();
                                    var keydownMenuIndex = $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu .vjs-selected").index();
                                    if(keydownMenuIndex>=0){
                                        player.controlBar.subsCapsButton.menu.focus(keydownMenuIndex);
                                    }else{
                                        var menu = player.controlBar.subsCapsButton.menu;
                                        if(38===event.which ){
                                            menu.focus(menu.children().length-1);
                                        }else{
                                            menu.focus(0);
                                        }
                                    }
                                }
                            }).on("pointerup",function(event) {
                                $timeout(function(){
                                    if($(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu.vjs-lock-showing").length){
                                        var menuIndex = $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu .vjs-selected").index();
                                        if(menuIndex<0){menuIndex = 0;}
                                        player.controlBar.subsCapsButton.menu.focus(menuIndex);
                                    }else{
                                        $(".video-js-custom.video-js .vjs-subs-caps-button button").focus();
                                    }
                                });
                            }).on("pointerdown",function(event){
                                event.preventDefault();
                                event.stopPropagation();
                            });
                            $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu")
                              .attr("id","vjs-subs-caps-menu-id")
                              .attr("aria-labelledby","vjs-subs-caps-button-id");

                            //add audio tooltip and polygon
                            $(
                                ".video-js-custom.video-js .vjs-audio-button button"
                            ).append(
                                '<div class="vjs-tooltip" aria-hidden="true">Audio track</div><div class="vjs-polygon" aria-hidden="true"></div>'
                            );

                            $(".video-js-custom.video-js .vjs-audio-button button")
                              .attr("aria-haspopup","menu")
                              .attr("id","vjs-audio-button-id")
                              .attr("aria-controls","vjs-audio-menu-id")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }else if(38===event.which || 40===event.which){
                                    //event.preventDefault();
                                    //event.stopPropagation();
                                    $(event.target).click();
                                    var keydownMenuIndex = $(".video-js-custom.video-js .vjs-audio-button .vjs-menu .vjs-selected").index();
                                    if(keydownMenuIndex>=0){
                                        player.controlBar.audioTrackButton.menu.focus(keydownMenuIndex);
                                    }else{
                                        var menu = player.controlBar.audioTrackButton.menu;
                                        if(38===event.which ){
                                            menu.focus(menu.children().length-1);
                                        }else{
                                            menu.focus(0);
                                        }
                                    }
                                }
                            }).on("pointerup",function(event) {
                                $timeout(function(){
                                    if($(".video-js-custom.video-js .vjs-audio-button .vjs-menu.vjs-lock-showing").length){
                                        var menuIndex = $(".video-js-custom.video-js .vjs-audio-button .vjs-menu .vjs-selected").index();
                                        if(menuIndex<0){menuIndex = 0;}
                                        player.controlBar.audioTrackButton.menu.focus(menuIndex);
                                    }else{
                                        $(".video-js-custom.video-js .vjs-audio-button button").focus();
                                    }
                                });
                            }).on("pointerdown",function(event){
                                event.preventDefault();
                                event.stopPropagation();
                            });
                            $(".video-js-custom.video-js .vjs-audio-button .vjs-menu")
                              .attr("id","vjs-audio-menu-id")
                              .attr("aria-labelledby","vjs-audio-button-id");

                            //Add skip backward tooltip and polygon
                            $(
                                ".video-js-custom.video-js .vjs-skip-backward-10"
                            ).append(
                                '<div class="vjs-tooltip" aria-hidden="true">Step back 10 seconds</div><div class="vjs-polygon" aria-hidden="true"></div>'
                            );
                            $(".video-js-custom.video-js .vjs-skip-backward-10")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }
                            });
                            //Add skip forward tooltip and polygon
                            $(
                                ".video-js-custom.video-js .vjs-skip-forward-10"
                            ).append(
                                '<div class="vjs-tooltip" aria-hidden="true">Step forward 10 seconds</div><div class="vjs-polygon" aria-hidden="true"></div>'
                            );

                            $(".video-js-custom.video-js .vjs-skip-forward-10")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }
                            });

                            //Add Tabindexes
                            $(
                                ".add-question-button"
                            ).attr("tabindex", "0");

                            //Reorder DOM
                            $(".vjs-progress-control.vjs-control").insertBefore(
                                ".vjs-marker-control"
                            );
                            $(
                                ".vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button"
                            ).insertBefore(
                                ".vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal"
                            );
                            $(
                                ".vjs-audio-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button"
                            ).insertBefore(
                                ".vjs-playback-rate.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button"
                            );
                            $(
                                ".vjs-descriptions-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button"
                            ).insertBefore(
                                ".vjs-audio-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button"
                            );
                            $(
                                ".vjs-subs-caps-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button"
                            ).insertBefore(
                                ".vjs-descriptions-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button"
                            );

                            //Set up sprite thumbnails
                            //console.log("sprite-thumbnails: "+$(".video-js-custom.video-js").hasClass("vjs-sprite-thumbnails"));
                            if (
                                $(".video-js-custom.video-js").hasClass(
                                    "vjs-sprite-thumbnails"
                                )
                            ) {
                                //Add mouse time display
                                $(
                                    ".video-js-custom.video-js .vjs-progress-holder"
                                ).append(
                                    "<div class='vjs-mouse-display-2'><div class='vjs-time-tooltip-2'></div></div>"
                                );
                            }
                            $(".video-js-custom.video-js .vjs-progress-holder")
                              .keydown(function (event) {
                                if (27 === event.which) {
                                    $(".vjs-marker button").attr("aria-expanded", "false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }
                            });
                            
                            //Update vjs-control-text items
                            $(".video-js-custom.video-js .vjs-skip-backward-10 .vjs-control-text").html("Step back 10 seconds");
                            $('.video-js-custom.video-js .vjs-subs-caps-button .vjs-control-text').html('Captions and subtitles');
                            $(".video-js-custom.video-js .vjs-playback-rate .vjs-control-text").html("Change Playback speed");


                            //Add aria labels to various buttons
                            $(".vjs-big-play-button").attr("aria-label", "Play");

                            //Modify subs caps dialog
                            $(".video-js-custom.video-js .vjs-subs-caps-button .vjs-menu-content .vjs-menu-item-text:contains('captions off')").html("Off");

                            //Create caps toggle button
                            $("div.vjs-subs-caps-button").prepend(
                                    '<button class="vjs-subs-caps-button-toggle vjs-control vjs-button" type="button">'+
                                    '<span class="vjs-icon-placeholder" aria-hidden="true"></span>'+
                                    '<span class="vjs-control-text" aria-live="polite">Captions and subtitles</span>'+
                                    '<div class="vjs-tooltip" aria-hidden="true">Captions and subtitles</div>'+
                                    '<div class="vjs-polygon" aria-hidden="true"></div>'+
                                    '</button>');

                            $(".video-js-custom.video-js .vjs-subs-caps-button-toggle")
                              .on("mouseenter",function(event) {
                                $scope.showTooltip(event);
                            }).on("mouseleave",function(event) {
                                $scope.hideTooltip(event);
                            }).on("focus",function(event) {
                                $scope.showTooltip(event);
                            }).on("blur",function(event) {
                                $scope.hideTooltip(event);
                            }).keydown(function(event) {
                                if(27===event.which){
                                    $(".vjs-marker button").attr("aria-expanded","false");
                                    $(".vjs-button").removeClass("vjs-tooltip-show");
                                    $(".vjs-marker").removeClass("vjs-popover-show");
                                }
                            }).mousedown(function(event){
                                $scope.toggleCC();
                            }).keypress(function(event){
                                if(event.which===32 || event.which===13){
                                    $scope.toggleCC();
                                }
                            });

                            //Create filler div
                            $('<div class="vjs-filler"></div>').insertAfter(".vjs-duration.vjs-time-control.vjs-control");

                            //Catch menu keydown and set focus
                            $(".vjs-menu .vjs-menu-item").on("keydown.quizzing", function(event){
                                if(27===event.which){
                                    $(".vjs-menu.vjs-lock-showing").parent().children("button:visible").focus();
                                }
                            });

                            //Prevent tooltip clicks
                            $(".vjs-tooltip").on('click', function(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            });

                            //Prevent polygon clicks
                            $(".vjs-polygon").on('click', function(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            });
                            
                            //start constantUpdates
                            $scope.makeUpdate();

                            //Disable All example
                            //$scope.enableButton("All", false, null);

                            //Disable and enable multiple example
                            //$scope.enableButton(null, null, {"BigPlayButton":false,"ProgressControl":false,"VolumePanel":false,"AddQuestion":true});

                            //Disable ProgressControl or Markers
                            //$scope.enableButton("ProgressControl", false, null);
                            //$scope.enableButton("Markers", false, null);

                            //Disable PlayToggle
                            //$scope.enableButton("PlaybackRateMenuButton", false, null);
                            
                            //Start player resizeOoserver
                            $scope.playerEl = player.el();
                            $scope.resizeObserver.observe($scope.playerEl);

                            $timeout(function () {
                                $scope.playerLoaded = true;
                            }, 50);
                        });
                    }
                }

                $scope.convertSRTtoVTT = function(srt) {
                   return 'WEBVTT\n\n' + srt
                     .replace(/\r+/g, '')
                     .replace(/(\d+)\n(\d{2}:\d{2}:\d{2}),(\d{3}) --> (\d{2}:\d{2}:\d{2}),(\d{3})/g,
                       '$1\n$2.$3 --> $4.$5')
                     .replace(/\n\n\n+/g, '\n\n');
                }
                $scope.resizeObserver = new ResizeObserver((entries) => {
                    for (var entry of entries) {
                        if (entry.contentBoxSize) {
                            var newWidth = parseInt(entry.contentBoxSize[0].inlineSize);
                            var newSize="";
                            if(newWidth<=399){
                                newSize="XS";
                                }else if(newWidth<=479){
                                newSize="S";
                            }else if(newWidth<=1023){
                                newSize="M";
                            }else{
                                newSize="L";
                            }
                            if($(".video-js-custom.video-js:not(.vjs-size-" + newSize + ")")){
                                $(".video-js-custom.video-js").removeClass("vjs-size-XS vjs-size-S vjs-size-M vjs-size-L").addClass("vjs-size-"+newSize);
                            }
                            if(newSize==="XS"||newSize==="S"){
                                $(".video-js-custom.video-js:not(.vjs-volume-popover)").addClass("vjs-volume-popover");
                            }else{
                                $(".video-js-custom.video-js.vjs-volume-popover").removeClass("vjs-volume-popover");
                            }
                            if(newSize === "M"){
                                var audioBarLength = Math.round(((newWidth - 480) / (1023 - 480) * 25) + 75);
                                if(audioBarLength !== $(".video-js-custom.video-js .vjs-filler").width()){
                                    $(".video-js-custom.video-js .vjs-volume-bar.vjs-slider-horizontal").width(audioBarLength);
                                    $(".video-js-custom.video-js .vjs-filler").width(audioBarLength);
                                }
                            }else{
                                if($(".video-js-custom.video-js .vjs-filler").get(0).style.width){
                                    $(".video-js-custom.video-js .vjs-volume-bar.vjs-slider-horizontal").css("width", "");
                                    $(".video-js-custom.video-js .vjs-filler").css("width", "");
                                }
                            }
                            if(!videojs.browser.IS_IOS){
                                var fontSize = null;
                                switch (newSize) {
                                    case 'XS':
                                        fontSize = "14.00";
                                        break;
                                    case 'S':
                                        fontSize = (((newWidth - 400) * 0.025316456) + 14).toFixed(2);
                                        break;
                                    case 'M':
                                        fontSize = (((newWidth - 480) * 0.007366483) + 16).toFixed(2);
                                        break;
                                    case 'L':
                                        fontSize = (((newWidth - 1024) * 0.017857143) + 20).toFixed(2);
                                        if(newWidth > 1920){
                                            fontSize = "36.00";
                                        }
                                        break;
                                    default:
                                }
                                var currentFontPercent = $(".vjs-font-percent > select").val();
                                if(currentFontPercent && currentFontPercent !== "1.00"){
                                    fontSize = (parseFloat(fontSize)*parseFloat(currentFontPercent)).toFixed(2);
                                }
                                if(fontSize !== $scope.currentTextTrackFontSize){
                                    //console.log("fontSize change from " +$scope.currentTextTrackFontSize + " to " + fontSize );
                                    $("#video-js-captions-styles").html(
                                           ".video-js-custom.video-js .vjs-text-track-display .vjs-text-track-cue {font-size: " +fontSize + "px !important;}"
                                    );
                                    $scope.currentTextTrackFontSize = fontSize;
                                }
                                if(newWidth !== $scope.currentWidth){
                                    //console.log("update textTracks");
                                    $scope.currentWidth = newWidth;
                                    player.trigger('playerresize');
                                }
                            }
                        }
                    }
                });

                /*
                 * makeUpdate function
                 * Function to make updates every 30ms
                 * Updates width of play  progress bar.
                 * Centers popovers.
                 * if sprites are in use it copies contents of vjs-time-tooltip to vjs-time-tooltip-2.
                 * @returns {undefined}
                 */
                $scope.makeUpdate = function() {
                    if($(".video-js-custom.video-js .vjs-play-progress-bar").css('width')!==$(".video-js-custom.video-js .vjs-play-progress").css( "width" )){
                        $(".video-js-custom.video-js .vjs-play-progress-bar").css('width', $(".video-js-custom.video-js .vjs-play-progress").css( "width" ));
                    }
                    var progressHolder = $(
                        ".video-js-custom.video-js .vjs-progress-holder"
                    );
                    var popovers = $(".vjs-popover");
                    $.each(popovers, function () {
                        var popoverSpan = $(this).find("div span");
                        popoverSpan.css("width", "250px");
                        popoverSpan.css("text-wrap", "wrap");
                        var textHeight = popoverSpan.outerHeight();
                        if (textHeight < 30) {
                            popoverSpan.css("width", "unset");
                            popoverSpan.css("text-wrap", "nowrap");
                        }
                        var popoverWidth = $(this).outerWidth();
                        var offset = Math.round(popoverWidth / 2);
                        var left = $(this).parent().offset().left;

                        var popoverLeftDif = parseInt(
                            left - progressHolder.offset().left
                        );
                        if (popoverLeftDif < 10) {
                            popoverLeftDif = 10;
                        }
                        var popoverRightDif = parseInt(
                            progressHolder.offset().left +
                                progressHolder.width() -
                                left
                        );
                        if (popoverRightDif < 10) {
                            popoverRightDif = 10;
                        }
                        if (popoverLeftDif < offset) {
                            offset = popoverLeftDif;
                        } else if (popoverRightDif < offset) {
                            offset = 2 * offset - popoverRightDif;
                        }
                        if (offset > 0) {
                            $(this).css("left", "-" + offset + "px");
                        }
                    });
                    var tooltips = $(".vjs-tooltip");
                    $.each(tooltips, function () {
                        $(this).css("left", "");
                        var offset = Math.round($(this).outerWidth() / 2);
                        var parentOffset = Math.round($(this).parent().outerWidth() / 2);
                        var parentLeft = $(this).parent().offset().left + parentOffset;
                        var tooltipLeftDif = parseInt(
                            parentLeft - progressHolder.offset().left
                        );
                        if (tooltipLeftDif < 10) {
                            tooltipLeftDif = 10;
                        }
                        var tooltipRightDif = parseInt(
                            progressHolder.offset().left +
                                progressHolder.width() -
                                parentLeft
                        );
                        if (tooltipRightDif < 10) {
                            tooltipRightDif = 10;
                        }
                        if (tooltipLeftDif < offset) {
                            offset = tooltipLeftDif - parentOffset;
                            if (offset > 0) {
                                $(this).css("left", "-" + offset + "px");
                            }
                        } else if (tooltipRightDif < offset) {
                            offset = 2 * offset - tooltipRightDif - parentOffset;
                            if (offset > 0) {
                                $(this).css("left", "-" + offset + "px");
                            }
                        }
                    });
                    if ($(".video-js-custom.video-js").hasClass("vjs-sprite-thumbnails")) {
                        var progressHolder = $(
                            ".video-js-custom.video-js .vjs-progress-holder"
                        );
                        var mouseDisplay2 = $(
                            ".video-js-custom.video-js .vjs-progress-holder .vjs-mouse-display-2"
                        );
                        var timeTooltip2 = $(
                            ".video-js-custom.video-js .vjs-progress-holder .vjs-mouse-display-2 .vjs-time-tooltip-2"
                        );
                        mouseDisplay2.css(
                            "left",
                            $(
                                ".video-js-custom.video-js .vjs-progress-holder .vjs-mouse-display"
                            ).css("left")
                        );
                        timeTooltip2.html(
                            $(
                                ".video-js-custom.video-js .vjs-progress-holder .vjs-mouse-display .vjs-time-tooltip"
                            ).html()
                        );
                        var tooltip2LeftDif = parseInt(
                            mouseDisplay2.css("left").replace("px", "")
                        );
                        var tooltip2RightDif =
                            progressHolder.width() - tooltip2LeftDif - 5;
                        //console.log("tooltipLeftDif:"+tooltipLeftDif);
                        //console.log("tooltipRightDif:"+tooltipRightDif);
                        var offset = timeTooltip2.outerWidth() / 2;
                        if (tooltip2LeftDif < offset) {
                            offset = tooltip2LeftDif;
                        } else if (tooltip2RightDif < offset) {
                            offset = 2 * offset - tooltip2RightDif;
                        }
                        timeTooltip2.css("left", "-" + offset + "px");
                    }
                    var lineClamps = $(".line-clamp");
                    for(var c=0; c < lineClamps.length; c++){
                        var divObject = $(lineClamps[c]);
                        if(divObject[0].scrollHeight > divObject[0].offsetHeight){
                            divObject.removeClass("hide-tooltip");
                        }else{
                            divObject.addClass("hide-tooltip");
                        }
                    }
                    if($(".video-js-custom.video-js.vjs-showing-menu").length){
                        $(".video-js-custom.video-js:not(:has(.vjs-menu.vjs-lock-showing))").removeClass("vjs-showing-menu");
                    }else{
                        $(".video-js-custom.video-js:has(.vjs-menu.vjs-lock-showing)").addClass("vjs-showing-menu");
                    }
                    $scope.updateTimeout = $timeout($scope.makeUpdate, 30);
                };
                $scope.updateAudioTrackIcon = function () {
                    //console.log("updateAudioTrackIcon()");
                    //Prevent this code if currently sorting audioTracks
                    if (!$scope.metadataloaded){
                        return;
                    }
                    //
                    var playerAudioTracks = player.audioTracks();
                    if (playerAudioTracks !== null && playerAudioTracks.length > 0) {
                        //console.log("playerAudioTracks.length: "+playerAudioTracks.length);
                        var audioTrackList = null;
                        if(player.tech_.featuresNativeAudioTracks){
                            //console.log("Using Native audioTracks");
                            var video = $(".video-js-custom.video-js video.vjs-tech")[0];
                            audioTrackList = video.audioTracks;
                        }
                        //search for main track
                        var mainId = "";
                        for (var i = 0; i < playerAudioTracks.length; i++) {
                            if("main" ===playerAudioTracks[i].kind){
                                mainId = playerAudioTracks[i].id;
                            }
                        };
                        if(!mainId){
                            if(audioTrackList !== undefined && audioTrackList!==null && audioTrackList.length > 0){
                                mainId = audioTrackList[0].id;
                            }else{
                                mainId = playerAudioTracks[0].id;
                            }
                        }
                        //console.log("mainId: "+mainId);
                        //Search for enabledId emulated tracks
                        var enabledId = "";
                        for (var i = 0; i < playerAudioTracks.length; i++) {
                            if(playerAudioTracks[i].enabled){
                                enabledId = playerAudioTracks[i].id;
                            }
                        };
                        //If no track is enabled then enable the main track
                        if(!enabledId){
                            enabledId = mainId;
                            playerAudioTracks.getTrackById(enabledId).enabled = true;
                        }
                        //console.log("enabledId: "+enabledId);
                        // Make json copy of tracks
                        var jsonAudioTracks =[];
                        for (var i = 0; i < playerAudioTracks.length; i++) {
                            var jsonAudioTrack = {id: playerAudioTracks[i].id,kind: playerAudioTracks[i].kind,label: playerAudioTracks[i].label,language: playerAudioTracks[i].language, enabled: enabledId===playerAudioTracks[i].id};
                            jsonAudioTracks.push(jsonAudioTrack);
                        };
                        
                        //Set main track kind to main and look for other audio in same language and set kind to main-desc for sorting
                        var mainLabel = jsonAudioTracks.find(item => item.id === mainId).label.toLowerCase();
                        for (var i = 0; i < playerAudioTracks.length; i++) {
                            if(playerAudioTracks[i].id === mainId){
                                jsonAudioTracks.find(item => item.id === playerAudioTracks[i].id).kind="main";
                            }else if(playerAudioTracks[i].label.toLowerCase().includes(mainLabel)){
                                jsonAudioTracks.find(item => item.id === playerAudioTracks[i].id).kind="main-desc";
                            }
                        };
                        //console.log("jsonAudioTracks:\n"+JSON.stringify(jsonAudioTracks, null, 2));
                        // Make sorted json copy of tracks
                        var sortedJsonAudioTracks = null;
                        if (typeof structuredClone === 'function') {
                            sortedJsonAudioTracks = structuredClone(jsonAudioTracks);
                        } else {
                            sortedJsonAudioTracks = JSON.parse(JSON.stringify(jsonAudioTracks));
                        }
                        sortedJsonAudioTracks.sort((a,b) => {
                            var kindComparison = a.kind.localeCompare(b.kind);
                            if(kindComparison !==0 ){
                                if(a.kind === "main"){
                                    return -1;
                                }
                                if(b.kind === "main"){
                                    return 1;
                                }
                                if(a.kind === "main-desc"){
                                    return -1;
                                }
                                if(b.kind === "main-desc"){
                                    return 1;
                                }
                            }
                            return a.label.localeCompare(b.label);
                        });
                        //console.log("sortedJsonAudioTracks:\n"+JSON.stringify(sortedJsonAudioTracks, null, 2));
                        // if json copy and sorted json copy are not the same then replace tracks with sorted
                        if(JSON.stringify(jsonAudioTracks) !== JSON.stringify(sortedJsonAudioTracks)){
                            //console.log("start sorting");
                            //console.log("jsonAudioTracks:\n"+JSON.stringify(jsonAudioTracks, null, 2));
                            //console.log("sortedJsonAudioTracks:\n"+JSON.stringify(sortedJsonAudioTracks, null, 2));
                            sortedJsonAudioTracks.forEach(track =>{
                                var tempTrack = playerAudioTracks.getTrackById(track.id);
                                player.audioTracks().removeTrack(tempTrack);
                                player.audioTracks().addTrack(tempTrack);
                                //console.log("move "+ track.label);
                            });
                            //console.log("stop sorting");
                        }
                        // Update each playerAudioTrack.label and find label for class tag
                        var enabledLabel = "";
                        for (var i = 0; i < playerAudioTracks.length; i++) {
                            
                            var track = playerAudioTracks[i];
                            //console.log("Track["+i+"]- id:"+track.id+", kind:"+track.kind+", label:"+track.label+", language:"+track.language+", enabled:"+track.enabled);
                            if(!player.tech_.featuresNativeAudioTracks){
                                playerAudioTracks[i].label = playerAudioTracks[i].label.replace("(Audio Description)","[AD]");
                            }
                            var label = playerAudioTracks[i].label.split(" ")[0].toLowerCase();
                            $(".video-js-custom.video-js .vjs-audio-button button").removeClass("vjs-audio-" + label);
                            if (playerAudioTracks[i].enabled) {
                                enabledLabel = label;
                            }
                        }
                        //console.log("enabledLabel: "+enabledLabel);
                        if(enabledLabel){
                            $(".video-js-custom.video-js .vjs-audio-button button").addClass("vjs-audio-" + enabledLabel);
                        }
                        $(".vjs-menu .vjs-menu-item").off("keydown.quizzing");
                        //Catch menu keydown and set focus
                        $(".vjs-menu .vjs-menu-item").on("keydown.quizzing", function(event){
                            if(27===event.which){
                                $(".vjs-menu.vjs-lock-showing").parent().children("button:visible").focus();
                            }
                        });
                        $(".video-js-custom.video-js .vjs-audio-button .vjs-menu")
                              .attr("id","vjs-audio-menu-id")
                              .attr("aria-labelledby","vjs-audio-button-id");
                    }
                };
                /* set and get currentTime rounded*/
                function playerCurrentTime(time) {
                    if (typeof time !== "undefined") {
                        //console.log("playerCurrentTime("+time+")");
                        player.currentTime(roundValue(time));
                    } else {
                        //console.log("playerCurrentTime(): "+player.currentTime());
                        return roundValue(player.currentTime());
                    }
                }
                /*Round number to six decimal places*/
                function roundValue(value) {
                    if (typeof value !== "undefined") {
                        return Number(
                            Math.round(value + "e6").toString() + "e-6"
                        );
                    }
                }
                /*
                 * enableButton function
                 * @param {type} identifier
                 * @param {type} enabled
                 * @param {type} buttonStates
                 * @returns {undefined}
                 *
                 * to disable or enable a single button enter identifier and enabled true or false state.
                 *      example: enableButton("PlayToggle", false, null);
                 * to disable or enable all buttons enter "All" and enabled true or false state.
                 *      example: enableButton("All", false, null);
                 * to blur the video and prevent video pointer events disable Video.
                 *      example: enableButton("Video", false, null);
                 * to change state of multiple buttons populate buttonStates with json.
                 *      example enableButton(null, null, {"PlayToggle":false,"SkipBackward":false,"AddQuestion":true});
                 */
                $scope.enableButton = function (identifier, enabled, buttonStates) {
                    //console.log("enableButton(" + identifier + ", " + enabled + ")");
                    var buttonClasses = {
                        Video: ".video-js-custom",
                        ProgressControl: ".vjs-progress-control",
                        Markers: ".vjs-marker-control",
                        PlayToggle: ".vjs-play-control",
                        SkipBackward: ".vjs-skip-backward-10",
                        SkipForward: ".vjs-skip-forward-10",
                        SubsCapsButton: ".vjs-subs-caps-button",
                        AudioButton: ".vjs-audio-button",
                        PlaybackRateMenuButton: ".vjs-playback-rate",
                        VolumePanel: ".vjs-volume-panel",
                        CurrentTimeDisplay: ".vjs-current-time",
                        TimeDivider: ".vjs-time-divider",
                        DurationDisplay: ".vjs-duration",
                        AddQuestion: ".vjs-add-question",
                        Rewatch: ".vjs-rewatch",
                        BigPlayButton: ".vjs-big-play-button",
                    };
                    if (buttonStates === null) {
                        buttonStates = JSON.parse(
                            '{"' + identifier + '":' + enabled + "}"
                        );
                        if ("All" === identifier) {
                            buttonStates = {
                                Video: enabled,
                                ProgressControl: enabled,
                                Markers: enabled,
                                PlayToggle: enabled,
                                SkipBackward: enabled,
                                SkipForward: enabled,
                                SubsCapsButton: enabled,
                                AudioButton: enabled,
                                PlaybackRateMenuButton: enabled,
                                VolumePanel: enabled,
                                CurrentTimeDisplay: enabled,
                                TimeDivider: enabled,
                                DurationDisplay: enabled,
                                AddQuestion: enabled,
                                Rewatch: enabled,
                                BigPlayButton: enabled,
                            };
                        }
                    }
                    for (var buttonName in buttonStates) {
                        //console.log("items: " + buttonName +" " +buttonStates[buttonName]);
                        var buttonClass = buttonClasses[buttonName];
                        if (buttonStates[buttonName]) {
                            $(buttonClass).removeClass("vjs-disabled");
                            if ("ProgressControl" === buttonName) {
                                $(".vjs-progress-holder").attr("tabindex", "0");
                            } else if ("Markers" === buttonName) {
                                $(".vjs-marker button").attr("tabindex", "0");
                            } else if ("SubsCapsButton" === buttonName) {
                                $(".vjs-subs-caps-button button").attr("tabindex", "0");
                            } else if ("AudioButton" === buttonName) {
                                $(".vjs-audio-button button").attr("tabindex", "0");
                            } else if ("PlaybackRateMenuButton" === buttonName) {
                                $(".vjs-playback-rate button").attr("tabindex", "0");
                            } else if ("VolumePanel" === buttonName) {
                                $(".vjs-mute-control").attr("tabindex", "0");
                                $(".vjs-volume-bar").attr("tabindex", "0");
                            } else if ("AddQuestion" === buttonName) {
                                $(".vjs-add-question button").attr("tabindex","0");
                            } else if ("Rewatch" === buttonName) {
                                $(".vjs-rewatch button").attr("tabindex","0");
                            } else if ("CurrentTimeDisplay" === buttonName
                                    || "TimeDivider" === buttonName
                                    || "DurationDisplay" === buttonName) {
                            } else {
                                $(buttonClass).attr("tabindex", "0");
                            }
                            //console.log("enable  " + buttonName);
                        } else {
                            $(buttonClass).addClass("vjs-disabled");
                            if ("ProgressControl" === buttonName) {
                                $(".vjs-progress-holder").attr(
                                    "tabindex",
                                    "-1"
                                );
                            } else if ("Markers" === buttonName) {
                                $(".vjs-marker button").attr("tabindex", "-1");
                            } else if ("SubsCapsButton" === buttonName) {
                                $(".vjs-subs-caps-button button").attr("tabindex", "-1");
                            } else if ("AudioButton" === buttonName) {
                                $(".vjs-audio-button button").attr("tabindex", "-1");
                            } else if ("PlaybackRateMenuButton" === buttonName) {
                                $(".vjs-playback-rate button").attr("tabindex", "-1");
                            } else if ("VolumePanel" === buttonName) {
                                $(".vjs-mute-control").attr("tabindex", "-1");
                                $(".vjs-volume-bar").attr("tabindex", "-1");
                            } else if ("AddQuestion" === buttonName) {
                                $(".vjs-add-question button").attr("tabindex","-1");
                            } else if ("Rewatch" === buttonName) {
                                $(".vjs-rewatch button").attr("tabindex","-1");
                            } else if ("CurrentTimeDisplay" === buttonName
                                    || "TimeDivider" === buttonName
                                    || "DurationDisplay" === buttonName) {
                            } else {
                                $(buttonClass).attr("tabindex", "-1");
                            }
                            //console.log("disable  " + buttonName);
                        }
                    }
                }
                /*
                 * addVideoMarkers function
                 * @param {type} markers JSON
                 * @returns {undefined}
                 * markers is json array of
                 * time: seconds
                 * label: integertypes
                 * type: inactive, active, completed, skipped
                 */
                $scope.addVideoMarkers = function(markers) {
                    $(".video-js-custom.video-js .vjs-marker").remove();
                    $(".video-js-custom.video-js .vjs-active-marker").remove();
                    $(".video-js-custom.video-js").removeClass(
                        "vjs-edit-question"
                    );
                    var total = player.duration();
                    var p = $(
                        ".video-js-custom.video-js .vjs-control-bar .vjs-marker-control"
                    );
                    for (var i = 0; i < markers.length; i++) {
                        var left = (markers[i].time / total) * 100 + "%";
                        var time = markers[i].time;
                        var type = "";
                        if (
                            markers[i].type !== null &&
                            typeof markers[i].type === "string" &&
                            markers[i].type.length > 0
                        ) {
                            type = " " + markers[i].type;
                        }
                        //console.log("type(" + i + "):" + type);
                        var tabindex = "0";
                        if ($(".vjs-marker-control.vjs-disabled").length) {
                            tabindex = "-1";
                        }
                        if (
                            $scope.hasWritePermissions &&
                            !$scope.isPreEdit &&
                            "active" === markers[i].type
                        ) {
                            $(".vjs-play-progress.vjs-slider-bar").append(
                                '<button class="vjs-active-marker" type="button" tabindex="' +
                                    tabindex +
                                    '">' +
                                    markers[i].label +
                                    "</button></div>"
                            );
                            $(".video-js-custom.video-js").addClass(
                                "vjs-edit-question"
                            );
                        } else {
                            var popoverElm = "";
                            if (markers[i].popover) {
                                popoverElm =
                                    '<div class="vjs-popover" role="dialog" aria-modal="false"><div><div>' +
                                    markers[i].label +
                                    "</div><span>" +
                                    markers[i].popover +
                                    '</span></div><span ng-click="clickTimecode(' +
                                    markers[i].label +
                                    ')"' +
                                    ' ng-focus ="showPopover($event)" ng-blur ="hidePopover($event)"' +
                                    '  aria-label="Dialog Select question number ' +
                                    markers[i].label +
                                    ' ' +
                                    markers[i].popover +
                                    ' at ' +
                                    markers[i].displayTime +
                                    '" >' +
                                    markers[i].displayTime +
                                    '</span><div class="vjs-hover"></div></div><div class="vjs-polygon" aria-hidden="true"></div>';
                            }else{
                                tabindex = -1;
                            }
                            var el = $(
                                '<div  id="marker-' +
                                    markers[i].label +
                                    '" class="vjs-marker' +
                                    type +
                                    '" ng-mouseenter ="showPopover($event)" ng-mouseleave ="hidePopover($event)"' +
                                    ' style="left:' +
                                    left +
                                    '" data-time="' +
                                    time +
                                    '">' +
                                    '<button ng-click="setMarkerActive($event,' +
                                    markers[i].label +
                                    ')"' +
                                    ' ng-focus ="showPopover($event)" ng-blur ="hidePopover($event)" type="button"' +
                                    ' aria-expanded ="false"' +
                                    ' aria-haspopup="menu"' +
                                    ' tabindex="' +
                                    tabindex +
                                    '" aria-label="Marker Select question number ' +
                                    markers[i].label +
                                    ' ' +
                                    markers[i].popover +
                                    ' at ' +
                                    markers[i].displayTime +
                                    ' ">' +
                                    markers[i].label +
                                    "</button>" +
                                    popoverElm +
                                    "</div>"
                            );
                            $compile(el)($scope);
                            p.append(el);
                        }
                    }
                };
                $scope.startQuiz = function () {
                    $scope.quizInProgress = true;
                    if (!$scope.hasWritePermissions) {
                        if ($scope.submissionsLeft > 0) {
                            $timeout(function () {
                                $scope.submissionsLeft = $scope.submissionsLeft - 1;
                            }, 5);
                        }
                        AssetService.GetQuizAttempt.get(
                            {
                                quizId: $scope.quiz.id,
                                isPreview: $scope.isPreview && $scope.isInstructor,
                            },
                            function (quizAttempt) {
                                $scope.quizAttemptId =
                                    quizAttempt.quizAttemptId;
                                console.log("HEREquizAttempt");
                                console.log($scope.quizAttemptId);
                                $scope.quizAttemptLoaded = true;
                                $scope.shouldStartQuiz = true;
                                $scope.getQuizMetadata();
                            }
                        );
                    }
                    if ($scope.isPreview) {
                        $scope.shouldStartQuiz = true;
                        $scope.getQuizMetadata();
                    }
                };

                $scope.$watch("render", function () {
                    if ($scope.render) $scope.loadPageInfo();
                    $scope.render = false;
                });

                $scope.resumeQuiz = function () {
                    $scope.quizInProgress = true;
                    if (!$scope.hasWritePermissions) {
                        $(".vjs-rewatch .rewatch-button").removeAttr("disabled");
                        $(".button-row").hide();
                        var questionToStart = $scope.quiz.questions
                            .filter((x) => x.answered)
                            .pop();
                        if (questionToStart) {
                            playerCurrentTime(
                                hmsToSecondsOnly(questionToStart.time)
                            );
                        } else {
                            playerCurrentTime(0);
                        }

                        // setting player current time above triggers 'seeking' event which may pause the player
                        // set timeout avoids race conditon when calling play when pause is in progress
                        // or vice versa

                        // TODO: we may have to revisit this anyways, where should the quiz resume?
                        setTimeout(() => {
                            player.play();
                        }, 150);
                        $scope.enableButton(null, null, {
                            Video: true,
                            ProgressControl: true,
                            PlayToggle: true,
                            SkipBackward: true,
                            SkipForward: true,
                            SubsCapsButton: true,
                            AudioButton: true,
                            PlaybackRateMenuButton: true,
                            VolumePanel: true,
                            AddQuestion: true,
                        });

                        if (
                            $scope.answeredQuestions.length ==
                            $scope.quiz.questions.length
                        ) {
                            $scope.showSubmitQuiz();
                        }
                    }
                };

                // TODO: retake quiz flow
                $scope.retakeQuiz = function () {
                    if (!$scope.hasWritePermissions) {
                        $scope.enableButton(null, null, {
                            Video: true,
                            PlayToggle: true,
                            SkipBackward: true,
                            SkipForward: true,
                        });
                        $(".vjs-rewatch .rewatch-button").removeAttr("disabled");
                        $(".button-row").hide();
                        player.play();
                    }
                };
                /*
                 * setMarkerActive
                 * todo: This function assumes that the only options are active and inactive.
                 * New logic is most likely required for dealing with completed and skipped
                 */
                $scope.setMarkerActive = function (ev, questionNumber) {
                    ev.stopPropagation();

                    // Conditionally show Discard Question Modal
                    $scope.questionToDiscardForNumber = questionNumber;
                    $scope.questionToDiscardForType = "preEdit";
                    if(!$scope.showDiscardQuestionModal()){
                        return false;
                    }

                    $(".vjs-marker").removeClass("active").addClass("inactive");
                    $(ev.currentTarget)
                        .parent()
                        .addClass("active")
                        .removeClass("inactive");
                    var question = $scope.quiz.questions.filter(
                        (x) => x.questionNumber == questionNumber
                    )[0];
                    player.pause();
                    if (player.currentTime() != hmsToSecondsOnly(question.time))
                        player.currentTime(hmsToSecondsOnly(question.time));
                    player.pause();
                    if ($scope.hasWritePermissions) {
                        $scope.handlePreEditQuestionClick(questionNumber);
                    } else {
                        $scope.handleQuestionCounterClick(questionNumber);
                    }
                };
                $scope.showPopover = function(e){
                    $(e.target).parents(".vjs-marker:first").addClass("vjs-popover-show");
                    $(e.target).parents(".vjs-marker:first").find("button").attr("aria-expanded","true");
                };
                $scope.hidePopover = function(e){
                    $(e.target).parents(".vjs-marker:first").removeClass("vjs-popover-show");
                    $(e.target).parents(".vjs-marker:first").find("button").attr("aria-expanded","false");
                };
                $scope.showTooltip = function(e){
                    $(".vjs-button").removeClass("vjs-tooltip-show");
                    if($(e.target).is(".vjs-volume-control")){
                        $(e.target).addClass("vjs-tooltip-show");
                    }else if($(e.target).is(".vjs-volume-bar")){
                        $(e.target).parents(".vjs-volume-control:first").addClass("vjs-tooltip-show");
                    }else if($(e.target).is(".vjs-button")){
                        $(e.target).addClass("vjs-tooltip-show");
                    }else{
                        $(e.target).parents(".vjs-button:first").addClass("vjs-tooltip-show");
                    }
                };
                $scope.hideTooltip = function(e){
                    if($(e.target).is(".vjs-volume-control")){
                        $(e.target).removeClass("vjs-tooltip-show");
                    }else if($(e.target).is(".vjs-volume-bar")){
                        $(e.target).parents(".vjs-volume-control:first").removeClass("vjs-tooltip-show");
                    }else if($(e.target).is(".vjs-button")){
                        $(e.target).removeClass("vjs-tooltip-show");
                    }else{
                        $(e.target).parents(".vjs-button:first").removeClass("vjs-tooltip-show");
                    }
                };
                $scope.closeMenuAndFocusOnMenuIcon = function(e) {
                    logger('closeMenuAndFocusOnMenuIcon');
                    if(e.which === 27) {
                        $("#quizzingMoreActionsMenu").hide();
                        $("#quizzingMoreActionsMenuButton").attr("aria-expanded","false");
                        $("#quizzingMoreActionsMenuButton").focus();
                    }
                }
                $scope.handleQuizAvailabilitySwitchKeyPress = function(e) {
                    logger('handleQuizAvailabilitySwitchKeyPress');
                    if(e.which === 13) {
                        $scope.handleQuizAvailabilitySwitchClick(e);
                    }
                }
                $scope.handleQuizAvailabilitySwitchClick = function (e) {
                   $scope.quiz.available = !$scope.quiz.available;
                   var quizPublishDTO = {
                        assetId: $scope.asset.aid,
                        collectionId: $scope.asset.cid,
                        makeAvailable: $scope.quiz.available,
                    };
                    AssetService.PublishQuiz.send(quizPublishDTO, function (resp) {
                        console.log('making quiz available: ', resp);
                    });
                }
                $scope.toggleCC = function(){
                    if($scope.captionsIncluded && !$scope.subtitlesIncluded && !$scope.audioDescriptionsIncluded){
                        var isShowing = false;
                        var textTrackList = player.textTracks();
                        for (var i = 0; i < textTrackList.length; i++) {
                            var track = textTrackList[i];
                            if (track.mode === 'showing') {
                                isShowing = true;
                                break;
                            }
                        }
                        for (var i = 0; i < textTrackList.length; i++) {
                            var track = textTrackList[i];
                            if(track.kind==="captions"){
                                if(isShowing){
                                    track.mode = 'disabled';
                                }else{
                                    track.mode = 'showing';
                                }
                            }
                        }
                    }
                }
                $scope.handleBreadcrumbEllipsisClick = function(e) {
                    $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').toggle();

                    setTimeout(function(){
                        if($(e.target).parents('.breadcrumb').find('.breadcrumb-menu').is(':visible')) {
                            var intervalId = setInterval(function(){
                                if($('.breadcrumb-menu li:nth-child(1) > div > span')[0].offsetWidth) {
                                    clearInterval(intervalId);

                                    //check each LI if there's ellipsis
                                    for(var i = 0; i < $('.breadcrumb-menu li').length; i++) {
                                        if(hasEllipsisWidth($('.breadcrumb-menu li:nth-child(' + (i + 1) + ') > div > span')[0])) {
                                            $scope.crumbsForMenu[i].hasEllipsis = true;
                                        } else {
                                            $scope.crumbsForMenu[i].hasEllipsis = false;
                                        }
                                    }
                                }
                            }, 100);
                            $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').find('[tabindex="0"]').first().focus();
                            $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",true);
                        }else{
                            $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                        }
                    }, 100);
                };
                $scope.handleBreadcrumbMenuItemClick = function(e, cid) {
                    $scope.navigateToCollection({type: 'Collection', xid: cid});
                    $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').hide();
                    $(e.target).parents('.breadcrumb').find('.elipse').attr("aria-expanded",false);
                };
                $scope.$watch('[parent, asset]', function(){
                    if($scope.parent && $scope.asset){
                        // Get a few assets from the same parent collection to display in the sidebar
                        AssetService.GetAllAssets.get({cid: $scope.parent.cid, isActive: $scope.asset.isActive}, function (assetList) {
                            $scope.assets = assetList.assets;

                            setTimeout(() => {
                                //Add ellipsis for long titles
                                $('.sidebar-courses .course-title a').each((index, item) => {
                                    $clamp(item, {clamp: 2});
                                });

                                //Add tooltip if there's ellipsis in title
                                $('.sidebar-courses .course-title a').each((index, item) => {
                                    if(hasEllipsisHeight(item)) {
                                        $scope.assets[index].hasEllipsis = true;
                                    }
                                });

                            }, 0)
                        });
                    }
                });
            });
            $scope.handleModalKeyPress = function(e){
                if(e.which === 32 || e.which === 13){
                    //$(e.target).click();
                }
            };
            $scope.handleInputKeypress = function(e){
                if(typeof $(e.target).attr('aria-readonly') !== 'undefined' && $(e.target).attr("aria-readonly")==="true"){
                   if((e.which > 36 && e.which < 41) || e.which === 32 || e.which === 13){
                       e.preventDefault();
                       e.stopPropagation();
                   }
                }else if(e.which === 32 || e.which === 13){
                    e.preventDefault();
                    e.stopPropagation();
                    $(e.target).click();
                }
            }
            $scope.getLangCode = function(lang){
                var langData = [{lang: "Afrikaans", code: "af"},{lang: "Amharic", code: "am"},{lang: "Arabic", code: "ar"},{lang: "Assamese", code: "as"},
                    {lang: "Azerbaijani", code: "az"},{lang: "Bashkir", code: "ba"},{lang: "Bulgarian", code: "bg"},{lang: "Bengali", code: "bn"},
                    {lang: "Tibetan", code: "bo"},{lang: "Breton", code: "br"},{lang: "Catalan", code: "ca"},{lang: "Corsican", code: "co"},
                    {lang: "Czech", code: "cs"},{lang: "Welsh", code: "cy"},{lang: "Danish", code: "da"},{lang: "German", code: "de"},
                    {lang: "Greek", code: "el"},{lang: "English", code: "en"},{lang: "Spanish", code: "es"},{lang: "Estonian", code: "et"},
                    {lang: "Basque", code: "eu"},{lang: "Persian", code: "fa"},{lang: "Finnish", code: "fi"},{lang: "Faroese", code: "fo"},
                    {lang: "French", code: "fr"},{lang: "Frisian", code: "fy"},{lang: "Irish", code: "ga"},{lang: "Galician", code: "gl"},
                    {lang: "Gujarati", code: "gu"},{lang: "Hausa", code: "ha"},{lang: "Hebrew", code: "he"},{lang: "Hindi", code: "hi"},
                    {lang: "Croatian", code: "hr"},{lang: "Hungarian", code: "hu"},{lang: "Armenian", code: "hy"},{lang: "Indonesian", code: "id"},
                    {lang: "Icelandic", code: "is"},{lang: "Italian", code: "it"},{lang: "Inuktitut", code: "iu"},{lang: "Japanese", code: "ja"},
                    {lang: "Georgian", code: "ka"},{lang: "Kazakh", code: "kk"},{lang: "Greenlandic", code: "kl"},{lang: "Kannada", code: "kn"},
                    {lang: "Korean", code: "ko"},{lang: "Kurdish", code: "ku"},{lang: "Lithuanian", code: "lt"},{lang: "Macedonian", code: "mk"},
                    {lang: "Malayalam", code: "ml"},{lang: "Mongolian", code: "mn"},{lang: "Marathi", code: "mr"},{lang: "Malay", code: "ms"},
                    {lang: "Maltese", code: "mt"},{lang: "Burmese", code: "my"},{lang: "Nepali", code: "ne"},{lang: "Dutch", code: "nl"},
                    {lang: "Norwegian", code: "no"},{lang: "Occitan", code: "oc"},{lang: "Punjabi", code: "pa"},{lang: "Polish", code: "pl"},
                    {lang: "Portuguese", code: "pt"},{lang: "Quechua", code: "qu"},{lang: "Romanian", code: "ro"},{lang: "Russian", code: "ru"},
                    {lang: "Kinyarwanda", code: "rw"},{lang: "Sanskrit", code: "sa"},{lang: "Sindhi", code: "sd"},{lang: "Slovak", code: "sk"},
                    {lang: "Slovenian", code: "sl"},{lang: "Albanian", code: "sq"},{lang: "Serbian", code: "sr"},{lang: "Sesotho", code: "st"},
                    {lang: "Swedish", code: "sv"},{lang: "Tamil", code: "ta"},{lang: "Telugu", code: "te"},{lang: "Tajik", code: "tg"},
                    {lang: "Thai", code: "th"},{lang: "Turkmen", code: "tk"},{lang: "Tagalog", code: "tl"},{lang: "Turkish", code: "tr"},
                    {lang: "Tatar", code: "tt"},{lang: "Ukrainian", code: "uk"},{lang: "Urdu", code: "ur"},{lang: "Uzbek", code: "uz"},
                    {lang: "Vietnamese", code: "vi"},{lang: "Wolof", code: "wo"},{lang: "Xhosa", code: "xh"},{lang: "Yiddish", code: "yi"},
                    {lang: "Yoruba", code: "yo"},{lang: "Chinese", code: "zh"},{lang: "Zulu", code: "zu"}];

                var langObject = langData.find(u => u.lang.toUpperCase() === lang.toUpperCase()) || {code: lang};
                return langObject.code;
            };
            $(document).on("keydown.quizzing", function (event) {
                if (event.which === 27) {
                    if($(".view-answers-menu").is(":visible")){
                        $(".view-answers-menu:visible").prev().children(":last-child").focus();
                    }
                    $(".view-answers-menu").hide();
                    $(".ellipsis-vertical.menu-button").attr("aria-expanded","false");
                    if($(".vjs-popover-show span").is(":focus")){
                        $(".vjs-popover-show span:focus").parents(".vjs-marker:first").find("button").focus();
                    }
                    $(".vjs-marker").removeClass("vjs-popover-show");
                    $(".vjs-marker button").attr("aria-expanded","false");
                    $(".vjs-button").removeClass("vjs-tooltip-show");
                    $(".vjs-volume-control").removeClass("vjs-tooltip-show");
                    if($(".breadcrumb-menu").is(":visible")){
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find('.ellipsis').first().focus();
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                        $('.breadcrumb-menu').hide();
                    }
                    $('.tooltip').hide();
                    if($("#vjs-more-actions-dialog-id").hasClass("vjs-lock-showing")){
                        $("#vjs-more-actions-button-id").focus();
                        $scope.closeMoreActionsDialog();
                    }
                }
            });
            $(window).on("click.quizzing", function (e) {
                $scope.hideQuizMoreActionsMenuWhenClickOutside(e);
                $scope.hideQuizAddQuestionMenuWhenClickOutside(e);
                $scope.hideQuizViewAnswersMenuWhenClickOutside(e);
                $scope.hideBreadcrumbMenuWhenClickOutside(e);
            });
            $scope.$on('$destroy', function() {
                console.log('quizzing.controller.js controller is being destroyed, performing cleanup...');
                $scope.resizeObserver.unobserve($scope.playerEl);
                $timeout.cancel($scope.updateTimeout);
                $(document).off("keydown.quizzing");
                $(window).off("click.quizzing");
                $(".vjs-menu .vjs-menu-item").off("keydown.quizzing");
            });
        }
    );
